// RO
const locale = {
    MENU: {
        DASHBOARD: "Dashboard",
        CREATE_REQUEST_BUTTON: "Creeaza cerere",
        SEARCH_BUTTON: "Cautare avansata",
        RESPONSE_TEMPLATES: "Template-uri de raspuns",
        TRANSLATIONS: "Traduceri",
        TRANSLATIONS_GLOSSARY: "Glosar traduceri",
        TRANSLATIONS_DASHBOARD: "Panou traduceri",
        TAX_CATEGORY: "Categorii de taxare",
        COMPLAIN_TYPE: "Tipologii de sesizare",
        ORGANIZATION: "Administrare organizatii",
        MY_ORGANIZATION: "Administrare organizație",
        ACCOUNTS: "Conturi secundare",
        BENEFICIARIES: "Beneficiari",
        MY_APPLICATIONS: "Cererile mele",
        DRAFT: "Draft",
        SUBMITTED: "Depuse",
        SIGN_PENDING: "De semnat",
        TO_CLARIFY: "De clarificat",
        FINALIZED: "Finalizate",
        STAFF_APPLICATIONS: "Registru cereri",
        NOTIFICATIONS: "Mesaje si notificari",
        RESPONSIBILITIES: "Nomenclator Responsabilități",
        MY_COMPLAINS: "Sesizarile mele",
        STAFF_COMPLAINS: "Registru sesizari",
        PAYMENTS: "Registru plati",
        DOCUMENTS: "Acte emise",
        EXTERNAL_APPS: "Aplicații",
        ATLAS: "Atlas teritorial",
        EFACTURA: "e-Factura",
        ARCHIVE: "Arhiva",
        HELP: "Ajutor",
        MANUAL: "Manual",
        FAQ: "Întrebări frecvente",
        ADMINISTRATOR: {
            HEADER: "Administrator",
            MANAGE: "Gestiune",
            FUNCTIONARY: "Functionar",
        },
        DOCUMENT_TEMPLATE: "Formulare tipizate",
        FORMS: "Interfețe formulare",
        APPLICATION_TYPE: "Tipologii registratură",
        PROCESS_MANAGEMENT: "Management procese",
        PERMISSIONS: "Permisiuni",
        METADATA_MAPPING: "Mapare Metadate",
        GU: "Ghișeul Unic",
        STAFF_OWN_APPLICATIONS: "De semnat (acte)",
        STAFF_OWN_CLARIFICATIONS: "De semnat (clarificări)",
        STAFF_REVIEW_APPLICATIONS: "De revizuit",
        DECISION_TARGET: "Hotărâri locații",
        DECISION_PURPOSE: "Hotărâri scopuri",
        DOCUMENT_SERIES_TYPE: "Tipologii de serie",
        REGISTERS_TYPE: "Tipologii registre",
        REGISTERS: "Registre",
        SPECIAL_REGISTERS: "Registre speciale",
        PAYMENT_REGISTRY: "Registru plăți",
        REAL_ESTATE_REGISTER: "Date CF",
        ISSUED_DOCUMENT: "Acte emise",
        ISSUED_DOCUMENT_STAFF: "Registru acte emise",
        CONTROLS: "Registru de control",
        ORGANISATION_CONFIG: "Configurări organizație",
        SYSTEM_CONFIG: "Configurări sistem",
        TRANSLATIONS_SECTION: "Traduceri",
        INTERNAL_DOCUMENTS: "Registru documente",
        DOCUMENT_SERIES_ALLOCATION: "Registru rezervări",
        USEFUL_LINKS: "Linkuri utile",
        APPLICATIONS_DETAILS: "Detalii aplicații",
        CONTROL_TYPE: "Tipologii control",
        STAFF_SIGN_INTERNAL_DOCUMENTS: "De semnat",
        STAFF_TO_REVIEW_DOCUMENTS: "De revizuit",
        DASHBOARD_REPORTS: "Rapoarte",
        PURPOSE_LIST: "Scopuri hotărâri",
        TARGET_LIST: "Locații hotărâri",
        SYSTEM_SETTINGS: "Setări sistem",
        INBOX: "Inbox",
        IN_WORK: "În lucru",
        NEW: "Noi",
        COMPLETED: "Finalizate",
        WITH_ERRORS: "Erori",
        REGISTRY: "Registratură",
        GENERAL_REGISTRY: "Registratură Generală",
        REGISTRY_ADD: "Adaugă",
    },
    GENERAL: {
        YES: "Da",
        NO: "Nu",
        CLOSE: "Închide",
        NEXT: "Înainte",
        PREV: "Înapoi",
        STATUS: "Status",
        ACTIVE: "Activ",
        INACTIVE: "Inactiv",
        CHECK: "Verifică",
        LOADING: "Se încarcă...",
        EXTEND: "Extinde",
        NOT_AVAILABLE: "Indisponibil",
        PREVIEW: "Previzualizare",
        GIS_INTERSECTIONS: "Intersecții GIS",
        GIS_INTERSECTIONS_METADATAS: "Metadate intersecții GIS",
        GIS_INTERSECTIONS_RESULTS: "Rezultate intersecții GIS",
        CONTINUE_NAVIGATION_BUTTON: "Continuă fără salvare",
        LINE_SPACING: {
            SINGLE: "Simplu",
            DOUBLE: "Dublu",
        },
        BUTTON: {
            ADD: "Adaugă",
            CANCEL: "Renunță",
            SAVE: "Salvează",
            UPDATE: "Modifică",
            CONFIRM: "Confirmă",
            ERASE: "Șterge",
            MORE_FILTERS: "Alte filtre",
            OK: "Ok",
            SEND_CODE: "Trimite codul",
            SEND: "Trimite",
            SENDING: "Se trimite...",
            CONTINUE: "Continuă",
            PUBLISH: "Publică",
            UPLOAD_FILE: "Alege fișier",
            COMPLETE: "Completează",
            UPLOAD_MAX_FILE_SIZE: "Încarcă documente (max {0} MB/doc)",
            DOWNLOAD: "Descarcă",
            EXTRACT: "Extrage selecție",
            SEARCH: "Caută",
            DIGITALIZE: "Digitalizează cerere",
            VIEW: "Vizualizează",
            VIEW_DOC: "Vizualizează document",
            DELETE_FILES: "Șterge documente ",
            GO_TO_APPLICATION: "Mergi la cerere",
            REFRESH: "Reîncarcă",
        },
        ACTIONS: {
            EDIT: "Editare",
            DELETE: "Ștergere",
            DELETE_MESSAGE: "Ești sigur că vrei să continui acțiunea de ștergere?",
            VIEW: "Vizualizare",
            DOWNLOAD: "Descarcă",
            DOWNLOAD_ALL: "Descarcă toate",
            SIGN: "Semnează",
            VIEW_ORIGINAL: "Vizualizare document",
            VIEW_STATUS: "Vizualizare status semnare",
            DO_UPDATE: "Actualizează",
            GO_TO_LINK: "Mergi la pagina instituției",
            COPY: "Copiază",
            SELECT_ALL: "Selectează toate",
            UN_SELECT_ALL: "Deselectează toate",
            REMOVE_SELECTION: "Elimină selecția",
            SEND_EMAIL: "Trimite email",
            VIEW_QR: "Printare bon inregistrare",
            CLONE: "Clonează",
            FILTER_PROJECT_IDS: "Filtreaza dupa Project ID",
            LOGS: "Istoric",
        },
        DATEPICKER: {
            FROM_DATE: "De la data",
            TO_DATE: "Până la data",
            SELECT_DATE: "Selectează",
            INVALID_DATE: "Data introdusă e invalidă",
            HELP: "Folosiți cursorul pentru a naviga prin datele din calendar",
        },
        PAGINATION: "Afișare rezultate de la {start} la {end}",
        CREATED_SUCCESS: "Salvat cu succes.",
        UPDATED_SUCCESS: "Salvat cu succes.",
        PUBLISHED_SUCCESS: "Publicat cu succes.",
        PUBLISHED_FAILED: "A apărut o eroare la publicarea layerului, vă rugăm reîncercați",
        REMOVE_SUCCESS: "Șters cu succes.",
        SELECT_PLACEHOLDER: "Alege",
        EXPIRED_SESSION: "Sesiunea a expirat",
        TABLE: {
            ACTIONS: "Acțiuni",
            COLUMN_SELECTOR_TITLE: "Selectează coloanele vizibile",
            SELECT_ALL_COLUMNS: "Selectează toate",
            FILTER_SELECTOR_TITLE: "Selectează filtrele vizibile",
            SELECT_ALL_FILTERS: "Selectează toate",
            APPLY: "Aplică",
            RESET_WIDTHS: "Resetează lățimile",
            CANCEL: "Anulează",
            RECOMMENDED_SELECTION_TITLE: "Selecție mare",
            RECOMMENDED_SELECTION_TEXT: "Ați selectat {selected} de elemente. Selectarea a mai mult de {recommended} de elemente poate reduce performanța. Puteți selecta până la {max} de elemente.",
            MAX_SELECTION_TITLE: "Număr maxim de selecții atins",
            MAX_SELECTION_TEXT: "Puteți selecta cel mult {max} de elemente. Au fost selectate primele {max} de elemente configurate.",
        },
        TABLE_ACTIONS_COLUMN: "Acțiuni",
        TABLE_EMPTY_TEXT: "Nu există înregistrări de afișat",
        DAYS: "zile | zi | zile",
        AUTOCOMPLETE_NO_OPTIONS: "Nici o opțiune potrivită",
        AUTOCOMPLETE_LOAD_MORE: "Încarcă mai multe opțiuni...",
        DUAL_LIST_BOX: {
            SEARCH_PLACEHOLDER: "Caută",
            SEARCH_RESULTS: "Nu s-au găsit rezultate.",
            CLEAR_SEARCH: "Șterge căutarea",
        },
        CLICK_HERE: "click aici",
        CITIZEN: "Cetățean",
        STAFF: "Funcționar",
        SIGN: "Semnare",
        SYSTEM: "Sistem",
        ORGANISATION: "Organizație",
        CITIZEN_CLARIFICATION: "Clarificări cetățean",
        STAFF_CLARIFICATION: "Clarificări funcționar",
        ERROR_PAGE: {
            TITLE: "Oops...",
            TEXT: "A apărut o problemă...",
            SUB_TEXT: "eroare neașteptată",
            NOT_FOUND_TITLE: "Pagina nu a fost găsită",
            NOT_FOUND_TEXT: "Resursa căutată nu există sau nu mai este disponibilă.",
            BACK_HOME: "Înapoi la pagina principală",
        },
        SELECT_LOADING: "Încărcare",
        CURRENCY_LABEL: "RON",
        RECOMANDED_SCREEN: "Această aplicație nu este optimizată pentru telefoane mobile sau tablete. Pentru cea mai bună experiență de navigare și funcționare recomandăm folosirea versiunii web a aplicației.",
        OR: "sau",
        MAINTENANCE: "Momentan sistemul este în mentenanță, iar unele funcționalități pot să nu funcționeze corect.",
        SEARCH_OPTIONS: "Caută {0}",
        NO_RESULTS: "Nu există rezultate pentru ",
        COPY_PREFIX: "Anexa",
        MISSING_ADDRESS: "Adresă indisponibilă",
        ADD_ASSIGNMENT: "Adaugă repartizare",
        REMOVE_ASSIGNMENT: "Șterge repartizare",
        NO_OPTIONS_AVAILABLE: "Nici o opțiune disponibilă",
        CITIZEN_MAINTENANCE_TITLE: "Sistemul se află în mentenanță",
        MAINTENANCE_MESSAGE: "Platforma este temporar indisponibilă din cauza lucrărilor de mentenanță. Vă rugăm să reveniți mai târziu.",
        LOGO_ALT: "Logo",
        MAP: {
            EXPORT_MAP: "Exportă harta",
            DOWNLOAD_PDF: "Descarcă ca PDF",
            DOWNLOAD_PNG: "Descarcă ca PNG",
            MEASURE_DISTANCE: "Măsoară distanța între două sau mai multe puncte",
            MEASURE_AREA: "Măsoară aria",
            CLEAR_MEASUREMENTS: "Șterge măsurătorile",
            EXPORT_PDF_ERROR: "Harta nu a putut fi exportată ca PDF",
            EXPORT_PNG_ERROR: "Harta nu a putut fi exportată ca PNG",
        },
        DOCUMENT_EDITOR: {
            TOTAL_PAGES: "Total pagini",
            TOTAL_PAGES_TOOLTIP: "Inserează numărul total de pagini.",
            DEFAULT_AUTHOR: "Utilizator",
            PASTE: "Lipește",
            TABLE_HEADER_GROUP: "Antet tabel",
            REPEAT_HEADER_ROWS: "Repetare rânduri antet",
            REPEAT_HEADER_ROWS_TOOLTIP: "Repetă rândul de antet al tabelului în partea de sus a fiecărei pagini.",
        },
        UNKNOWN_USER: "Utilizator necunoscut",
    },
    ALERT_MODAL: {
        ERROR: "Eroare",
        WARNING: "Atenție",
        SUCCESS: "Succes",
        INFO: "Info",
    },
    AUTH: {
        GENERAL: {
            OR: "sau",
            CANCEL_BUTTON: "Renunță",
            BACK_BUTTON: "Inapoi",
            PRIVACY: "Politica de Confidențialitate",
            LEGAL: "Termeni și Condiții",
        },
        LOGIN: {
            TITLE: "Bun venit!",
            DESC: "Introduceți email-ul și parola pentru a accesa platforma",
            NO_ACCOUNT: "Nu ai cont? Creează acum!",
            BUTTON: "Intră în cont",
            FORGOT_PASSWORD_LABEL: "Ai uitat parola ?",
            GOOGLE_BUTTON: "Intră in cont folosind Google",
            FACEBOOK_BUTTON: "Intră în cont folosind Facebook",
            ROEID_BUTTON: "Conectează-te cu ROeID",
            HELP_TEXT: "* Aplicația permite crearea a două tipuri de conturi. Unul personal dedicat persoanelor fizice și juridice și unul profesional destinat birourilor de proiectare/planificare.",
            ROEID_INFO_TEXT_FIRST: "Vă recomandăm să folosiți aplicația ",
            ROEID_INFO_TEXT_SECOND: " pentru conectarea la sistemul Ghișeul Unic.",
            ROEID_INFO_DESCRIPTION: "{roeid} este o aplicație pe telefonul mobil pusă la dispoziție de către {adr}, aplicație notificată la {ec} ca modalitatea oficială de identificare electronică în România.",
            ROEID_INFO_ADR_LINK_TEXT: "Autoritatea pentru Digitalizarea României",
            ROEID_INFO_EC_LINK_TEXT: "Comisia Europeană",
        },
        FORGOT: {
            TITLE: "Resetare parolă?",
            DESC: "Introduceți adresa de email aferentă contului.",
            BUTTON: "Trimite email",
            SUCCESS: "Your account has been successfully reset.",
        },
        RESET: {
            TITLE: "Resetare parolă?",
            DESC: "Introduceți parola nouă",
            BUTTON: "Schimbă parola",
        },
        CHANGE_PASSWORD: {
            TITLE: "Schimbare parolă",
            DESC: "Introduceți parola nouă",
            BUTTON: "Schimbă parola",
        },
        SET: {
            TITLE: "Setare parolă",
            DESC: "Introduceți o parola",
            BUTTON: "Setează parola",
        },
        REGISTER: {
            TITLE: "Bun venit!",
            DESC: "Aplicația permite crearea a două tipuri de conturi. Unul personal dedicat persoanelor fizice/juridice, UAT și unul profesional destinat birourilor de proiectare/planificare.",
            HAS_ACCOUNT: "Ai cont deja? Conectează-te",
            GOOGLE_BUTTON: "Creează cont folosind Google",
            FACEBOOK_BUTTON: "Creează cont folosind Facebook",
            BUTTON: "Creează cont",
            ACCEPT_TERMS: "Accept {0}, {1}.",
            PRIVACY: "politica de confidențialitate",
            TOS: "termeni și condițiile",
            PASSWORD_HELP: "Minim 8 caractere, o majusculă, o minusculă, o cifră și un caracter special",
            PROFESSIONAL_TITLE: "Creează cont Profesional nou",
            PROFESSIONAL_DESC: "Contul de tip profesional se adresează persoanelor juridice - birouri / societăți / p.f.a. / b.i.a care activează în domeniul proiectării în (arhitectură, urbanism, inginerie, s.a.) și este destinat gestionării/depunerii de cereri pentru unul sau mai mulți beneficiari - permite subconturi",
            PERSONAL_TITLE: "Creează cont Personal nou",
            PERSONAL_DESC: "Contul de tip personal se adresează persoanelor fizice / juridice, administrațiilor publice și este destinat depunerii de cereri pentru/în numele persoanelor fizice / juridice / primăriilor",
            BUTTON_PERSONAL: "Creează cont Personal",
            BUTTON_PROFESSIONAL: "Creează cont Profesional",
            ROEID_BUTTON: "Conectează-te cu ROeID",
        },
        INPUT: {
            EMAIL: "E-mail",
            PASSWORD: "Parolă",
            CONFIRM_PASSWORD: "Confirmă parola",
            NEW_PASSWORD: "Parolă noua",
            OLD_PASSWORD: "Parolă veche",
            PHONE: "Număr telefon",
            VALIDATION_CODE_PLACEHOLDER: "Cod validare",
        },
        VERIFY_EMAIL: {
            TITLE: "Confirmare e-mail",
            MESSAGE_SENT: "S-a trimis un link de activare la adresa de e-mail {0}. Verifică e-mailul iar dupa confirmare continuă procesul de validare a contului. Uneori link-ul de activare poate ajunge în spam, te rugăm să verifici și folderul de spam.",
            RESEND_CONFIRMATION_MESSAGE: "Nu ai primit e-mail de confirmare? {0}.",
            RESEND_LINK: "Retrimite link-ul",
            TOAST_MESSAGE: "Emailul de confirmare trimis cu succes",
        },
        VERIFY_SMS: {
            TITLE: "Validarea contului",
            MESSAGE: "Din motive de securitate Ghiseul Unic are nevoie sa iti verifice contul prin SMS. Introdu numarul de telefon si urmeaza pasii pentru validare.",
            MESSAGE_SENT: "S-a trimis un SMS la numarul de telefon {0}. Adauga codul primit si valideaza contul.",
            BUTTON_SUBMIT: "Trimite cod",
            BUTTON_VALIDATE: "Valideaza contul",
            INPUT_PLACEHOLDER: "Cod validare",
            MESSAGE_NOT_RECEIVED: "Nu ai primit codul? {0}",
            RESEND_LINK: "Retrimite mesajul",
            CHANGED_VALIDATION_METHOD_LINK: "schimba metoda de validare",
        },
        INVALID_LINK: {
            TITLE: "Link de activare invalid",
            MESSAGE: "Link-ul de activare este invalid, a expirat sau a fost deja folosit. Te rugăm să îți verifici contul sau să reiei procesul de înregistrare.",
            REGISTER_MESSAGE: "Mergi la pagina de {0}.",
            REGISTER_LINK: "înregistrare",
        },
        VALIDATION: {
            INVALID: "{{name}} nu este valid",
            REQUIRED: "Acest câmp este obligatoriu",
            EMAIL: "Adresa de e-mail nu este valabilă",
            INVALID_EMAIL: "Adresa de e-mail nu este validă.",
            MIN_LENGTH: "Lungimea minimă a {{name}} este {{min}}",
            AGREEMENT_REQUIRED: "Acceptarea termenilor și condițiilor este obligatoriu",
            NOT_FOUND: "The requested {{name}} is not found",
            INVALID_LOGIN: "Date de autentificare incorecte. Te rugăm să încerci din nou.",
            REQUIRED_FIELD: "Acest câmp este obligatoriu",
            CONFIRM_PASSWORD: "Parola nu este identică",
            MIN_LENGTH_FIELD: "Câmpul trebuie să aibă minim {min} caractere",
            MAX_LENGTH_FIELD: "Câmpul trebuie să aibă maxim {max} caractere",
            INVALID_FIELD: "Câmpul nu este valid",
            STRONG_PASSWORD: "Parolă invalidă",
            INVALID_PHONE: "Numarul de telefon nu este valid",
            NUMERIC_FIELD: "Acest câmp conține doar valori numerice",
            PHONE_FIELD: "Acest câmp conține doar valori numerice",
            INVALID_URC: "CUI invalid",
            INVALID_PNC: "CNP invalid",
            POSTAL_CODE_MAX_LENGTH_FIELD: "Codul poștal trebuie să conțină 6 cifre",
            SMS_CODE_LENGTH: "Codul de verificare trebuie să conțină 6 cifre",
            IBAN: "Cod IBAN invalid.",
            INTEGER: "Valoarea câmpului nu este un număr întreg valid",
            INVALID_DATE: "Dată invalidă",
            ALPHABETICAL: "Valoarea câmpului trebuie să conțină doar litere și spațiu",
            LETTERS_ONLY: "Valoarea câmpului trebuie să conțină doar litere",
            NO_UPPER: "Acest câmp conține doar minuscule",
            ALPHABETICAL_SPECIAL_CHARS: "Valoarea câmpului trebuie să conțină doar litere, spațiu, apostrof și -",
            URL: "Link-ul introdus nu e valid",
            FULL_URL: "Link-ul introdus nu e valid. Prefixul \"https\" e obligatoriu.",
            ARCGIS_FEATURE_SERVICE_URL: "Link-ul introdus nu e un valid Arcgis Feature Service",
            INVALID_EMAIL_DOMAIN: "Va rugăm să folosiți o altă adresa de email de pe alt domeniu",
            NO_SPACE: "Acest câmp nu poate să conțină spațiu",
            "АT_LEAST_ONE_COLUMN": "Selectați cel puțin o coloană",
        },
    },
    LAYOUT: {
        HEADER: {
            SEARCH_PLACEHOLDER: "Cauta cerere, aviz sau alt document",
        },
    },
    LOGOUT: {
        CONFIRMATION_MESSAGE: "Esti sigur ca doresti terminarea sesiunii de lucru?",
    },
    RESET_PASSWORD: {
        CONFIRMATION_MESSAGE: "Eşti sigur că doreşti să resetezi parola?",
        SUCCESSFULLY_SENT_MESSAGE: "S-a trimis un link de resetare a parolei pe adresa ta de e-mail indicată.",
        SUCCESSFULLY_MESSAGE: "Parola dvs. a fost schimbată cu succes",
    },
    UNLINK_ROEID: {
        CONFIRMATION_MESSAGE: "Ești sigur că dorești să dezactivezi conectarea cu ROeID? Această acțiune va elimina datele preluate din contul ROeID și va dezactiva funcționalitățile asociate contului ROeID.",
        SUCCESSFULLY_MESSAGE: "Conectarea cu ROeID a fost dezactivată cu succes. Veți primi o notificare prin e-mail pentru resetarea parolei.",
    },
    LINK_ROEID: {
        INFORMATION_MESSAGE: "Pentru a conecta contul cu ROeID este necesar să vă delogați, iar ulterior să vă autentificați folosind opțiunea Conecteaza-te cu ROeID. După conectare, datele din contul ROeID vor putea fi preluate și actualizate în profilul dumneavoastră. Dacă nu aveți un cont ROeID, vă recomandăm să descărcați aplicația ROeID de pe telefonul mobil și să urmați pașii pentru crearea unui cont ROeID, apoi reveniți pentru a conecta conturile.",
    },
    HOME: {
        WELCOME_TEXT: "Bine ați venit în aplicația Ghișeul Unic.",
    },
    PROFILE: {
        HEADER: "Contul meu",
        HEADER_CITIZEN: "Contul meu Personal",
        HEADER_LEGAL: "Contul meu Profesional",
        LOGOUT_BUTTON_TEXT: "Delogare",
        UPDATE_BUTTON: "Actualizează datele",
        ROEID_BUTTON: "Preia datele din contul ROeID",
        DEACTIVATE_ROEID_BUTTON: "Dezactivează conectarea cu ROeID",
        VIDEO_ENROLL_BUTTON: "Înrolare video",
        SECTIONS: {
            ACCOUNT_DETAILS: {
                HEADER: "Detalii cont",
            },
            PERSONAL_DETAILS: {
                HEADER: "Detalii personale",
            },
            PERSONAL_DATAS: {
                HEADER: "Date personale",
            },
            COMPANY_DATAS: {
                HEADER: "Date firmă",
            },
            RESPONSIBILITIES: {
                HEADER: "Responsabilități",
            },
            IDENTITY_CARD: {
                HEADER: "Date carte de identitate",
            },
            LANGUAGE: {
                SAVE_FAILED: "Limba nu a putut fi salvată în profilul dumneavoastră. Vă rugăm să încercați din nou.",
                CHOICE: {
                    LOGIN_TITLE: "Ce limbă doriți să folosiți?",
                    LOGIN_TEXT: "Limba salvată în contul dumneavoastră diferă de cea cu care v-ați autentificat. Alegerea dumneavoastră se va folosi pentru:",
                    SWITCH_TITLE: "Schimbați limba?",
                    SWITCH_TEXT: "Noua limbă se va folosi pentru:",
                    APPLIES_TO: {
                        PLATFORM: "Platformă",
                        EMAIL: "E-mail",
                        SMS: "SMS",
                    },
                    TAGS: {
                        ACCOUNT: "Contul dumneavoastră",
                        LOGIN_SCREEN: "Ecranul de autentificare",
                        CURRENT: "Limba actuală",
                        NEW: "Limba nouă",
                    },
                    CAPTION_ACCOUNT: "Păstrați limba salvată în contul dvs.",
                    CAPTION_LOGIN_SCREEN: "Treceți la limba cu care v-ați autentificat",
                    CAPTION_KEEP: "Păstrez limba română",
                    CAPTION_SWITCH: "Schimb la limba română",
                    DESCRIPTION_USE: "Platforma și notificările în limba română",
                    DESCRIPTION_KEEP: "Platforma și notificările dumneavoastră rămân în limba română.",
                    DESCRIPTION_SWITCH: "Întreaga platformă și toate notificările vor fi în limba română.",
                    FOOTNOTE: "O puteți schimba oricând din steagul din bara de sus.",
                    NOTICE: "Platforma și notificările dumneavoastră sunt acum în limba română.",
                },
            },
        },
        OPTIONS: {
            MY_PROFILE: {
                NAME: "Profilul meu",
                DESCRIPTION: "Vezi detalii profil",
            },
            RESET_PASSWORD: {
                NAME: "Resetare Parola",
                DESCRIPTION: "Aceseaza formularul de resetare",
            },
            NOTIFICATIONS_MANAGEMENT: {
                NAME: "Management Notificari",
                DESCRIPTION: "Gestioneaza tipul și frecvența notificarilor",
            },
            UNLINK_ROEID: {
                NAME: "Dezactivează ROeID",
                DESCRIPTION: "Dezactivează conectarea cu ROeID",
            },
            LINK_ROEID: {
                NAME: "Conectează-te cu ROeID",
                DESCRIPTION: "Conectează contul cu ROeID pentru a prelua datele din contul ROeID.",
            },
            PCUEL: {
                NAME: "PCUEL",
                DESCRIPTION: "Ultima sincronizare {0}",
                BUTTON: "Sincronizează",
            },
        },
        FIELDS: {
            PERSONAL_NUMERIC_CODE: "CNP",
            LAST_NAME: "Nume",
            FIRST_NAME: "Prenume",
            COUNTY: "Județ",
            LOCALITY: "Municipiu/Oraș/Comună",
            VILLAGE: "Localitate",
            SECTOR: "Sector",
            STREET: "Strada",
            POSTAL_CODE: "Cod Poștal",
            STREET_NUMBER: "Număr",
            STAIRCASE: "Scara",
            BLOCK: "Bloc",
            FLOOR: "Etaj",
            APARTMENT: "Apartament",
            EMAIL: "E-mail",
            PHONE: "Telefon",
            PASSPORT_NUMBER: "Pașaport/Carte de identitate",
            COUNTRY: "Țara",
            CITY: "Oraș",
            ADDRESS: "Adresa",
            UNIQUE_REGISTRATION_CODE: "CIF sau CUI",
            REGISTRATION_NUMBER: "Număr înregistrare Oficiul Registrul Comerțului",
            COMPANY_NAME: "Denumire entitate",
            IBAN: "Cont IBAN",
            BANK: "Deschis la",
            LICENSE: "Arhitect - număr TNA",
            STATUS: "Status",
            IDENTIFICATION_NUMBER: "Număr legitimaţie",
            ORGANISATION: "Instituție",
            FUNCTIONS: "Funcție",
            DEPARTMENTS: "Departament",
            USER_TYPE_NAME: "Tip utilizator",
            ID_CARD_SERIAL: "Serie CI",
            ID_CARD_NUMBER: "Număr CI",
            ID_CARD_ISSUED_DATE: "Data eliberării",
            ID_CARD_EXPIRATION_DATE: "Data expirării",
            ID_CARD_ISSUER: "Eliberat de",
        },
        PLACEHOLDERS: {
            COUNTY: "Județ",
            LOCALITY: "Localitate",
            VILLAGE: "Sat",
            COUNTRY: "Țara",
            STATUS: "Status",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
        },
        MESSAGES: {
            ID_CARD_EXPIRED: "Cartea de identitate a expirat!",
            STAFF_ENROLLMENT_PROCESSING_TITLE: "Înrolare video în procesare...",
            STAFF_ENROLLMENT_SUCCESS_TITLE: "Funcționarul a fost înrolat cu succes",
            STAFF_ENROLLMENT_REDIRECT_TEXT: "Vei fi redirecționat în câteva secunde la profilul tău. Dacă nu ești redirecționat automat te rugăm dă {0}",
            STAFF_ENROLLMENT_FAILED_TITLE: "A apărut o eroare la procesul de înrolare, te rugăm încearcă din nou.",
            ROEID_UPDATED_SUCCESSFULLY: "Datele ROeID au fost preluate cu succes. Pentru a transforma contul tău în cont calificat, te rugăm să apeși butonul Actualizează Datele. Dacă ai un cont profesional, completează restul câmpurilor obligatorii înainte de actualizare",
        },
        ENROLLED_BADGE_LABEL: "Înrolat",
        ROEID_BADGE_LABEL: "Calificat",
        DEACTIVATE_PCUEL_BUTTON: "Dezactivează PCUEL",
    },
    SET_PROFILE_DATA: {
        UPDATE_PROFILE_MODAL: {
            HEADER: "Actualizare importantă de date!",
            TEXT: "Ca urmare a dezvoltării unor facilități noi în aplicație, vă adresăm rugămintea de a actualiza datele de profil. Vă mulțumim!",
            GO_TO_PROFILE: "Mergi la Profilul meu",
        },
        UPDATE_PROFILE_MODAL_ROEID: {
            TEXT: "Datele din contul ROeID au fost actualizate. Pentru a le actualiza în profilul tău, te rugăm să preiei și să salvezi datele.",
        },
        WELCOME_MODAL: {
            BRAND: {
                NAME: "Ghișeul unic",
                ORGANISATION: "Consiliul Județean Cluj",
            },
            HEADER: {
                TOP_P: "Bun venit în platforma Ghișeul Unic!",
                BOTTOM_P: "Completează datele profilului tău pentru a putea customiza experiența conform nevoilor tale.",
                BOTTOM_P_PERSON: "Setează cont Personal",
                BOTTOM_P_LEGAL: "Setează cont Profesional",
            },
            OPTIONS: {
                PERSON: "Setează profil Personal",
                LEGAL: "Setează profil Profesional",
            },
        },
        CITIZEN: {
            ROMANIAN: "Cetățean romȃn",
            FOREIGNER: "Cetățean străin",
        },
        FORM_BUTTONS: {
            CHANGE_TYPE: "Schimbă tipul profilului",
            SAVE: "Salvează datele",
        },
        LEGAL_FORM: {
            COMPANY: "Detalii Firma",
            LEGAL_REPRESENTATIVE: "Detalii reprezentant Legal",
        },
        PERSON: {
            PNC: "CNP",
            LAST_NAME: "Nume",
            FIRST_NAME: "Prenume",
            COUNTY: "Judet",
            LOCALITY: "Municipiu/Oraș/Comună",
            VILLAGE: "Localitate",
            SECTOR: "Sector",
            STREET: "Strada",
            POSTAL_CODE: "Cod Postal",
            NUMBER: "Numar",
            STAIRCASE: "Scara",
            BLOCK: "Bloc",
            FLOOR: "Etaj",
            APARTMENT: "Apartament",
            EMAIL: "E-mail",
            PHONE: "Telefon",
        },
        FOREIGNER: {
            PNC: "Pasaport/Carte de identitate",
            LAST_NAME: "Nume",
            FIRST_NAME: "Prenume",
            COUNTRY: "Tara",
            CITY: "Oras",
            ADDRESS: "Adresa",
            EMAIL: "E-mail",
            PHONE: "Telefon",
        },
        LEGAL: {
            URC: "CUI",
            COMPANY_NAME: "Denumire",
            COUNTY: "Judet",
            LOCALITY: "Localitate",
            STREET: "Strada",
            POSTAL_CODE: "Cod Postal",
            NUMBER: "Numar",
            STAIRCASE: "Scara",
            BLOCK: "Bloc",
            FLOOR: "Etaj",
            APARTMENT: "Apartament",
            LAST_NAME: "Nume",
            FIRST_NAME: "Prenume",
            PNC: "CNP",
            LICENSE: "Arhitect - număr TNA",
            EMAIL: "E-mail",
            PHONE: "Telefon",
        },
        ERRORS: {
            LOCALITIES: "Eroare la generarea listei de localitati!",
            VILLAGES: "Eroare la generarea listei de sate!",
            UPDATE: "Eroare la modificarea informațiilor despre profil!",
            CREATE: "Eroare la crearea profil utilizator!",
        },
        SUCCESS_MODAL: {
            TITLE: "Bun venit {0}!",
            TEXT: "Acum ai posibilitatea de a încarca și transmite documentele necesare procesului de autorizare și de a-ți gestiona documentele.",
            CONFIRM_BUTTON: "Hai să începem!",
        },
        UPDATED_MESSAGE: "Profilul a fost actualizat cu succes!",
        GDPR: {
            AGREE_CONDITION: "Sunt de acord cu prelucrarea datelor cu caracter personal",
            CONDITIONS: "În temeiul Regulamentului (UE) nr. 2016/679 privind protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu caracter personal și privind libera circulație a acestor date și de abrogare a Directivei 95/46/CE (Regulament general privind protecția datelor) și al Legii nr.190/2018 Consiliul Județean Cluj prelucrează date cu caracter personal, cu asigurarea securității și confidențialității acestora.”",
        },
    },
    NOTIFICATIONS: {
        BUTTON_TEXT: "Aplică modificările",
        HEADER: {
            TOP: "Management notificări",
            COL_1: "Tipul notificării",
            COL_2: "Email",
            COL_3: "Sms",
            COL_4: "În aplicație",
        },
        SECTION_TITLE: {
            ACCOUNT: "Cont",
            APPLICATIONS: "Cereri",
            DOCUMENTS: "Acte",
            ALERTS: "Alerte",
            OTHERS: "Altele",
            COMPLAINS: "Sesizări",
            COMMENTS: "Mesaje",
            INTERNAL_DOCUMENTS: "Documente Interne",
            CONTROLS: "Controale",
        },
        FREQUENCY: {
            DAILY: "Zilnic",
            WEEKLY: "Saptamanal",
            MONTHLY: "Lunar",
        },
        ITEMS: {
            ACCOUNT_DATA_CHANGED: "Se modifica datele contului",
            ACCOUNT_TYPE_CHANGED: "Se modifica tipul contului",
            NEW_APPLICATION: "Se primește o cerere noua",
            APPLICATION_CHANGED: "Se modifică o cerere",
            APPLICATION_STATUS_CHANGED: "Se schimbă statusul unei cereri",
            APPLICATION_SENT: "Se trimite o cerere",
            DOCUMENT_CREATED: "Se emite un act nou",
            DOCUMENT_CANCELLED: "Se anuleaza un act",
            TAX_DEADLINE_EXPIRES: "Expira un termen de plata",
            RESPONSE_DEADLINE_EXPIRES: "Expira un termen de raspuns",
            MESSAGE_SENT: "Se trimite mesaj.",
            NEW_COMPLAIN: "Se primește o sesizare nouă",
            COMPLAIN_STATUS_CHANGED: "Se schimbă statusul unei sesizări",
            NEW_COMMENT: "Se primește un mesaj nou",
            OTHER_APPLICATION_RELATED_UPDATES: "Se primesc noutăți din aplicație",
            INTERNAL_DOCUMENT_STATUS_CHANGED: "Se schimbă statusul unui document intern",
            CONTROLS_STATUS_CHANGED: "Se schimbă statusul unui control",
            APPLICATION_SIGNED: "Se aplică o semnătură pe documentele alocate",
            APPLICATION_TO_BE_SIGNED: "Se primește un document de semnat",
        },
        ERRORS: {
            NOTIFICATIONS: "Eroare la generarea listei de notificari!",
            UPDATE: "Eroare la modificarea notificării!",
        },
        SUCCESS: {
            UPDATE: "Modificarea notificării s-a realizat cu succes.",
        },
        TEMPLATES: {
            TITLE: "Template-uri notificari",
            TABLE: {
                ACTIONS: "Actiuni",
                EDIT: "Editeaza",
            },
            EDIT: {
                PAGE_TITLE: "Editeaza template",
                SUBJECT: "Subiect",
                MESSAGE: "Mesaj",
                COPY_HINT: "Apasa pe un placeholder pentru a-l copia",
                COPIED: "Copiat",
                TITLE: "Titlu",
                SMS: "SMS",
                EMAIL: "E-mail",
                IN_APP: "In-App",
                ACCEPTED_PLACEHOLDERS: "Placeholdere acceptate",
                SAVE: "Salveaza",
                MAX_CHARS: "Max: {chars} caractere.",
                REMAINING_CHARS: "Au mai ramas: {chars}",
            },
            FIELDS: {
                TITLE: "Denumire",
                TYPE: "Cod template",
                CHANNEL: "Canal de livrare",
            },
            PLACEHOLDERS: {
                TITLE: "Cauta dupa denumire",
                CHANNEL: "Canal de livrare",
            },
            SECTIONS: {
                DETAILS: "Detalii template",
                CONTENT: "Continut mesaj",
            },
        },
    },
    NOTIFICATIONS_IN_APP: {
        TITLE: "Notificări",
        MESSAGE: {
            INPUT_CODE: "Cod intrare",
            BENEFICIARY: "Beneficiar",
        },
        LOCALE: {
            FUTURE: "în",
            PAST: "acum",
            SECOND: "căteva secunde",
            SECONDS: "secunde",
            MINUTE: "un minut",
            MINUTES: "minute",
            HOUR: "o oră",
            HOURS: "ore",
        },
        NOW: "Acum",
    },
    BENEFICIARY: {
        BENEFICIARY_DETAILS: {
            HEADER: "Detalii beneficiar",
            ADD_BTN: "Adaugă beneficiar",
            REMOVE_BTN: "Sterge beneficiar",
            PERSON: {
                HEADER: "Tip persoană",
                INDIVIDUAL: "Persoană fizică",
                LEGAL: "Persoană juridică",
            },
            CITIZENSHIP: {
                HEADER: "Cetățenie",
                ROMANIAN: "Cetățean romȃn",
                FOREIGNER: "Cetățean străin",
            },
            FOOTER_CHECKBOX: "Beneficiarul este persoana de contact",
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Filiala",
            },
            ADDRESS: "Adresă",
            CONTACT: "Contact",
            PERSON_DETAILS_HEADER: "REPREZENTATĂ LEGAL DE",
            ID_DETAILS_HEADER: "DATE PRIVIND ACTUL DE IDENTITATE",
            OFFICE_DETAILS_HEADER: "DATE PRIVIND SEDIUL SOCIAL",
            ID_LEGAL_DETAILS_HEADER: "DATE PRIVIND ACTUL DE IDENTITATE ALE REPREZENTANTULUI LEGAL",
            BANK_DETAILS_HEADER: "DATE BANCARE ALE ENTITĂȚII",
        },
        APPLICANT_DETAILS: {
            HEADER: "Detalii solicitant",
            FOOTER_CHECKBOX: "Solicitantul este persoana de contact",
        },
        SINGLE: "Total {total} beneficiar",
        MULTIPLE: "Total {total} beneficiari",
        LIST_HEADER: "Lista beneficiarilor",
        MODAL: {
            ADD_HEADER: "Adaugă un beneficiar",
            EDIT_HEADER: "Editează un beneficiar",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Adresă domiciliu",
            CONTACT: "Contact",
            CITIZENSHIP: "Cetătenie",
            ADDRESS_COUNTY: "Judetul",
            ADDRESS_STREET: "Str.",
            ADDRESS_NUMBER: "nr.",
            ADDRESS_STAIRCASE: "scara",
            ADDRESS_APARTMENT: "ap.",
        },
        SEARCH_DESCRIPTION: "Selectați beneficiarul sau adăugați unul nou",
        SEARCH_PLACEHOLDER: "Căutați beneficiarul după CNP/CUI sau adăugați unul nou",
        SEARCH_PLACEHOLDER_ON_APPLICATION: "Căutați beneficiarul",
        SEARCH_DESCRIPTION_ON_APPLICATION: "Selectați beneficiarul",
        ANAF_VALIDATION: "Sistemul de validare ANAF este inaccesibil. Beneficiarul trebuie adăugat manual și va fi validat la editare sau la adăugarea într-o cerere",
        ANAF_ADDRESS_INFO: "Info ANAF - denumire județ: {county}, denumire localitate: {locality}",
    },
    ERRORS: {
        DEFAULT_ERROR_MESSAGE: "A apărut o eroare, vă rugăm reîncercați",
        AUTH_REQUIRED: "Este nevoie de autorizare.",
        AUTH_INVALID: "Autentificare eșuată.",
        AUTH_INVALID_ATTEMPTS_REMAINING: "Autentificare eșuată. {0} încercări rămase.",
        REGISTRATION_EMAIL_ALREADY_EXISTS: "Adresa de e-mail există deja.",
        REGISTRATION_INVALID_PASSWORD: "Parolă invalidă",
        REGISTRATION_INVALID: "Înregistrare invalidă.",
        FACEBOOK_EMAIL_NOT_RECEIVED: "A apărut o eroare, nu s-a putut obține adresa dvs. de e-mail. Verificați setările Facebook și încercați din nou!",
        PASSWORD_EXPIRED: "Parola dvs. a expirat și trebuie schimbată.",
        AUTH_FAILED: "Autentificare eșuată.",
        AUTH_FAILED_ATTEMPTS_REMAINING: "Autentificare eșuată. {0} încercări rămase.",
        RESET_PASSWORD_ALREADY_USED: "Parola trebuie să fie diferită de cea curentă.",
        FORBIDDEN: "Ne pare rău, nu aveți drepturi necesare ca să continuați.",
        TOKEN_INVALID: "Token invalid",
        DUPLICATE_FUNCTION_NAME: "Numele funcției adăugate deja există!",
        CATEGORY_NOT_EMPTY: "Categoria nu poate fi ștearsă!",
        NAME_NOT_UNIQUE: "Numele nu este unic.",
        ERROR_PAGE_MESSAGE: "OOPS! Something went wrong here",
        AUTH_ACCOUNT_NOT_FOUND: "Credențialele sunt introduse greșit!",
        PARENT_MUST_BE_ADMIN_OF_LEGAL_ENTITY: "Nu aveți permisiunea de a adăuga sau edita un cont!",
        USER_ALREADY_EXISTS: "Acest utilizator este deja existent!",
        TAX_ALREADY_EXISTS: "Această taxă este deja existentă!",
        VERIFICATION_SERVICE_UNAVAILABLE: "Codul introdus nu este valid!",
        CANNOT_DELETE_ORGANISATION: "Această organizație nu poate fi ștearsă fiindcă există utilizatori asociați",
        ORGANISATION_ALREADY_EXISTS: "Această organizație există deja",
        DOCUMENT_SERIES_ALREADY_EXISTS: "Această serie este deja existentă!",
        REGISTER_CONFIG_EXISTS: "Există deja un registru cu acest nume.",
        REGISTER_TYPE_EXISTS: "Există deja un tip de registru cu acest nume.",
        REGISTER_TYPE_CANNOT_BE_DELETED: "Există deja cel puțin un registru de documente asociat acestei tipologii și nu poate fi șters.",
        PREFIXLESS_SERIES_ALREADY_EXISTS: "Există deja o serie fără prefix pentru această organizație!",
        DOCUMENT_SERIES_NOT_EXIST: "Nu există serie definită!",
        DOCUMENT_SERIES_NOT_ACTIVE: "Seria nu este activă!",
        RESPONSIBILITY_ALREADY_EXISTS: "Această responsabilitate este deja existentă!",
        INDEX_CANNOT_BE_LOWER_THAN_CURRENT_VALUE: "Valoarea indexului nu poate fi mai mică decât valoarea curentă!",
        CONFLICT: "Înregistrare duplicat",
        PAYMENT_ALREADY_PROCESSED: "Plata a fost deja procesată!",
        PAYMENT_STATE_CHANGED: "Plata a fost modificată între timp.",
        DUPLICATE_MANUAL_PAYMENT: "O plată cu aceeași sumă, modalitate, dată și același număr de document este deja adăugată.",
        PAYMENT_DATE_IN_FUTURE: "Data plății nu poate fi în viitor.",
        INVALID_MANUAL_PAYMENT: "Datele plății nu sunt valide.",
        PAYMENT_NOT_ALLOWED: "Această plată nu poate fi modificată.",
        PAYMENT_LOG_NOT_FOUND: "Plata nu a fost găsită.",
        PAYMENTS_SERVICE_UNAVAILABLE: "Serviciul de plăți nu răspunde. Încearcă din nou peste câteva minute.",
        PAYMENT_ACTION_FORBIDDEN: "Nu ai permisiunea pentru această acțiune sau sesiunea s-a încheiat. Reîncarcă pagina și încearcă din nou.",
        PAYMENT_RESULT_UNKNOWN: "Nu am primit răspunsul serviciului de plăți. Verifică plata în listă înainte de a încerca din nou.",
        INVALID_PAYMENT_PROOF: "Dovada plății nu a putut fi verificată. Elimină fișierul și încarcă-l din nou.",
        PAYMENT_PROOF_UNAVAILABLE: "Dovada plății nu poate fi verificată acum, așa că nimic nu a fost salvat. Încearcă din nou peste câteva minute.",
        AUTH_INVALID_CONFIRMATION_VALIDATIONS: "Solicitarea de resetare parolă a expirat!",
        CERTSIGN_CONFIRMING_SIGNING_FAILED: "Codul introdus nu este valid!",
        ATLAS_NO_SEARCH_RESULT: "Adresa nu a fost găsită!",
        DECISION_TARGET_CANNOT_BE_DELETED: "Această locație nu poate fi ștearsă fiindcă este asociată unei hotărâri",
        DECISION_PURPOSE_CANNOT_BE_DELETED: "Aceast scop nu poate fi ștears fiindcă este asociat unei hotărâri",
        DECISION_PURPOSE_ALREADY_EXISTS: "Aceast scop este deja existent!",
        DECISION_TARGET_ALREADY_EXISTS: "Această locație este deja existentă!",
        DOCUMENT_SERIES_TYPE_CANNOT_BE_DELETED: "Această tipologie nu poate fi ștearsă fiindcă este asociată unei serii",
        DOCUMENT_SERIES_TYPE_ALREADY_EXISTS: "Această tipologie este deja existentă!",
        DUPLICATE_COMPLAIN_TYPE_NAME: "Numele tipului de sesizare introdus deja există!",
        DUPLICATE_RESPONSE_TEMPLATE_NAME: "Numele templateului introdus deja există!",
        INVALID_EMAIL: "Adresa de email nu este valabilă",
        INVALID_CERTSIGN_ENROLLMENT: "A apărut o eroare la procesul de semnare, lipsă înrolare.",
        REQUEST_ALREADY_CONFIRMED: "Cererea a fost deja semnată",
        INVALID_TOKEN: "Ne pare rău, a apărut o eroare. Incercați din nou!",
        SOURCE_FILE_ID_MISSING_ERROR: "Ne pare rău, încărcarea fișierului nu a fost cu succes. Incercați din nou!",
        UAT_ALREADY_ASSIGNED: "UAT-ul selectat este asignat la alt funcționar!",
        ERROR_VALIDATING_LAYER_CREATION_REQUEST: "A apărut o eroare, vă rugăm reîncercați",
        NOT_OK: "A apărut o eroare, verificați dacă documentele sunt semnate și încercați din nou.",
        ARCHIVE_CONTENT_INVALID_FILES_BY_NAME: "A apărut o eroare, verificați numele pachetului de documente și încercați din nou.",
        INVALID_FILE: "A apărut o eroare, extensia pachetului de documente trebuie fie .zip",
        AUTH_FAILED_ACCOUNT_LOCKED: "Autentificarea a eșuat. Contul este blocat. Incercați din nou peste {0} minute",
        AUTH_DISABLED: "Eroare de autentificare, contul este blocat sau inactiv.",
        URBANISM_REQULATION_ZONE_NOT_UNIQUE: "Denumirea zonei (per UAT și Scop) nu este unică.",
        AUTH_FAILED_PASSWORD_EXPIRED: "Parola dvs. a expirat și trebuie schimbată.",
        WORKFLOW_EXISTS: "Un proces cu acest nume există deja",
        MISSING_SIGN_PLACEHOLDER: "A apărut o eroare la procesul de semnare, vă rugăm reîncercați.",
        INVALID_TARGET_FOR_SIGN_PLACEHOLDER: "A apărut o eroare la procesul de semnare, vă rugăm reîncercați.",
        MISMATCH_TARGET_FILES_AND_META: "A apărut o eroare la procesul de semnare, vă rugăm reîncercați.",
        CERTSIGN_SIGNING_ID_NOT_GENERATED: "A apărut o eroare la procesul de semnare, vă rugăm reîncercați.",
        PERMISSIONS_ARE_EQUAL_TO_CURRENT_RESPONSIBILITY: "Permisiunile salvate sunt aceleași cu cele inițiale.",
        TOO_MANY_FILES_OR_FILE_SIZE_EXCEEDED: "Numărul maxim de fișiere a fost atins sau documentul depășește limita maxim admisă.",
        CERTSIGN_INTERNAL_ERROR: "A apărut o eroare la procesul de semnare, vă rugăm reîncercați.",
        ERROR_INIT_SIGNING: "A apărut o eroare la inițierea procesul de semnare, vă rugăm reîncercați.",
        ERROR_DOCUMENT_GENERATION: "A apărut o eroare, te rugăm încearcă mai târziu.",
        CANNOT_DELETE_FUNCTION_ASSOCIATED_USERS_EXIST: "A apărut o eroare la ștergere, funcția are utilizatori asociați.",
        CANNOT_DELETE_FUNCTION_ASSOCIATED_DEPARTMENTS_EXIST: "A apărut o eroare la ștergere, funcția este asignată la un departament.",
        APPLICATION_NOT_SUBMITTED: "A apărut o eroare la procesul de depunere, vă rugăm reîncercați.",
        ERROR_VALIDATING_RU_SCOPE_AND_UAT_ALREADY_EXISTS_FOR_SIMPLE_LAYER: "Scop RU cu UAT-ul selectat deja există.",
        ERROR_VALIDATING_CONTAINER_COMPONENT_MISMATCHED_RU_SCOPE: "Scop RU nu este aceleași cu cel al container-ului.",
        ERROR_VALIDATING_RU_SCOPE_ALREADY_EXISTS_FOR_CONTAIANERS: "Scop RU există deja în lista de containere.",
        PDF_INVALID: "Fișierul nu are o semnătura validă!",
        PDF_IS_ENCRYPTED: "Fișierul nu are o semnătura validă sau este criptat!",
        ERROR_VALIDATING_PUBLISHED_LAYER_WAS_ALREADY_PUBLISHED: "Layerul selectat a fost deja publicat. ",
        DUPLICATE_DEPARTMENT_NAME: "Există un departament cu acest nume",
        CAN_NOT_USE_SYSTEM_FUNCTIONS: "Există o funcție de sistem cu acest nume",
        FUNCTION_NAME_ALREADY_EXIST: "Există o funcție cu acest nume",
        INVALID_PDF_ERROR: "Semnatura este invalidă, vă rugăm reîncercați folosind o semnatură digitală validă.",
        PDF_READING_ERROR: "Fișierul nu a putut fi citit, vă rugăm reîncercați.",
        EMPTY_RESPONSIBILITIES: "Funcția nu are responsabilități atribuite.",
        REJECT_FORM_STAFF: "Acestei tipologii de cerere îi lipsește interfața formular sau formularul tipizat pentru respingere",
        ERROR_VALIDATING_TARGET_CONTAINER_IS_SYSTEM_LAYER: "Eroare la publicare layer, layerul sursă este de tip sistem.",
        AUTH_SERVICE_UNAVAILABLE: "A apărut o eroare, te rugăm încearcă mai târziu.",
        ERROR_VALIDATING_LAYER_NAME_ALREADY_EXISTS: "Denumirea layerului este deja utilizată.",
        THE_REQUEST_IS_NOT_VALID: "A apărut o eroare, te rugăm încearcă mai târziu.",
        EMPTY_TARGET_FILES: "Nu există document generat, cererea nu se poate semna",
        ERROR_VALIDATING_ARCGIS_IMPORTED_ITEM_DOES_NOT_EXISTS: "Layerul nu este accesibil sau layerul nu există.",
        ERROR_VALIDATING_ARCGIS_IMPORTED_ITEM_INVALID: "Identificatorul layerului nu este valid.",
        ERROR_VALIDATING_APPLICATION_TYPE_ALREADY_LINKED_TO_ANOTHER_LAYER: "Unul dintre tipurile de cerere selectate este deja asociat altui layer.",
        FILE_NOT_EXISTS: "Fișierul pentru care se încearcă ștergerea, nu există!",
        ERROR_MISSING_DOCUMENT_REJECTED_SERIES: "Seria pentru acest document nu a fost setată!",
        INVALID_FORM_VALUE: "Valoarea introdusă în formular nu este validă!",
        TOO_MANY_INTEREST_AREAS: "S-a atins numărul maxim de zone de interes ce pot fi definite.",
        TOO_MANY_CITIZEN_FEATURES: "S-a atins numărul maxim de layere ce pot fi încărcate.",
        APPLICATION_TYPE_EXISTS: "Există deja o tipologie de cerere cu această denumire",
        ERROR_DOWNLOAD_COMPRESSION: "A apărut o eroare la descărcarea fișierelor, vă rugăm reîncercați.",
        APPLICATION_REQUEST_DENIED: "Nu aveți suficiente permisiuni pentru a vizualiza cererea",
        APPLICATION_ALREADY_SUBMITTED: "Cererea a fost depusă, nu poate fi salvat ca si Draft.",
        CANNOT_INIT_PAYMENT: "Plata nu poate fi inițiată.",
        USER_PROFILE_ALREADY_EXISTS: "Un utilizator cu acest email există deja in sistem",
        BENEFICIARY_EMAIL_ALREADY_INVITED: "Beneficiarul cu acest email a fost invitat deja",
        UTILS_LINKS_CSV_PARSE_ERROR: "Fișierul de linkuri utile nu se poate procesa",
        ANAF_VALIDATION: "În acest moment, sistemul de validare cu baza de date a ANAF este inaccesibil, motiv pentru care beneficiarul a fost adăugat în sistem fără validarea datelor sale. Validarea va fi reluată automat la momentul adăugării beneficiarului într-o cerere sau al editării acestuia.",
        EXCEEDED_MAX_COUNT: "Raportul selectat depășește numărul maxim înregistrări, vă rugăm să ajustați intervalul de timp sau numărul de tipologii",
        AUTH_ROEID_ERROR: "A apărut o eroare la conectarea cu ROeID, vă rugăm încercați din nou.",
        AUTH_STS_ERROR: "A apărut o eroare la autentificarea cu STS, vă rugăm încercați din nou.",
        SERIES_TYPE_ID_NOT_FOUND_FOR_VIZA_TYPE_REJECTION_VIZA_SERIES_TYPE_ID: "Seria pentru respingerea vizei nu a fost configurată! Vă rugăm contactați administratorul.",
    },
    REQUESTS: {
        BUILDING: {
            DETAILS: "Detalii imobil",
            LAND: "Teren",
            LAND_CONSTRUCTIONS: "Teren + Constructii",
            COUNTY: "Judet",
            LOCALITY: "Localitate",
            VILLAGE: "Sat",
            SECTOR: "Sector",
            STREET: "Strada",
            POSTAL_CODE: "Cod postal",
            NUMBER: "Numar",
            STAIRCASE: "Scara",
            BLOCK: "Bloc",
            FLOOR: "Etaj",
            APARTMENT: "Apartament",
            LAND_AREA: "Suprafata terenului",
            OTHER_IDENTIFICATION: "Alta identificare",
            CADASTRAL_NUMBER: "Nr. cadastral",
            ADD_CADASTRAL_NUMBER: "Adauga nr. cadastral",
            REMOVE_CADASTRAL_NUMBER: "Sterge nr. cadastral",
        },
    },
    VALIDATION: {
        REQUIRED_FIELD: "Acest câmp este obligatoriu!",
        NUMERIC_FIELD: "Acest câmp conține doar valori numerice!",
        EMAIL_FIELD: "Adresa de e-mail este invalida",
        PHONE_FIELD: "Numărul de telefon este invalid",
        UPLOADED_FILE_SIZE: "Dimensiunea fișierul este prea mare",
        UPLOADED_FILE_SIZE_NAME: "Dimensiunea fișierul {name} este prea mare",
        UPLOADED_FILE_TYPE: "Tipul fișierului nu este suportat",
        MAX_UPLOADED_FILES: "Numărul maxim de fișiere admise este {max}. Mai pot fi încărcate {amount} fișiere.",
        PDF_FIELD: "Extensia fișierului selectat trebuie să fie .pdf .",
        MULTIPLE_FILES: "Unele fișiere nu au putut fi încărcate din cauza extensiei sau a dimensiunii",
        ENTER_NUMBER: "Introduceți un număr",
    },
    PLACEHOLDERS: {
        MP: "mp",
    },
    INSTITUTION: {
        MAIN_HEADER: "Organizație selectată",
        PAGE_HEADER: "Organizații",
        LOGO_LABEL: "Logo",
        USEFUL_LINKS_CSV_UPLOAD_LABEL: "Informatii Utile",
        USEFUL_LINKS_CSV_UPLOAD_INFO: "incarcati un fisier .csv cu informatii utile cu urmatorul format <Nume, Link>",
        LIST: {
            TITLE: "Lista organizațiilor",
        },
        FIELDS: {
            NAME: "Denumire",
            STATUS: "Status",
            COUNTY: "Județ",
            LOCALITY: "Localitate",
            TYPE: "Tip",
            UAT: "UAT",
            DESCRIPTION: "Descriere",
            IS_TEST: "Organizație de test",
            STAFF_USERS: "Funcționar",
            ORGANISATION: "Organizație",
            LOGO: "Logo",
            EXTERNAL_LINK: "Link extern",
            IS_CITIZEN_VISIBLE: "Vizibilă pe dashboard-ul cetățeanului",
            UNIQUE_REGISTRATION_CODE: "CIF sau CUI",
            LEGAL_REPRESENTATIVE_FUNCTION: "Funcție",
            LEGAL_REPRESENTATIVE_NAME: "Nume",
            ACCOUNT_BANK: "Bancă",
            ACCOUNT_IBAN: "IBAN",
            ACCOUNT_ADDRESS: "Adresă",
            ACCOUNT_PHONE: "Telefon",
            ACCOUNT_EMAIL: "Email",
            REMARKS: "Observații",
            NOTES: "Mențiuni",
            ADDITIONAL_DETAILS: "Detalii suplimentare",
            DETAILS_SECTION: "Detalii organizație",
            LEGAL_REPRESENTATIVE_SECTION: "Date reprezentant legal",
            ACCOUNT_SECTION: "Date cont",
            OTHER_INFO_SECTION: "Alte informații",
        },
        PLACEHOLDERS: {
            NAME: "Nume",
            STATUS: "Stare",
            DESCRIPTION: "Introduceți descrierea organizației",
            IS_TEST: "Organizație de test",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
            IS_TEST: {
                YES: "Da",
                NO: "Nu",
            },
        },
        MAIN_PAGE: {
            SEARCH: {
                PLACEHOLDER: "Caută organizație",
                ERASE_BUTTON: "Șterge",
            },
            TABLE_HEADER: {
                NAME: "Nume",
                DESCRIPTION: "Descriere",
                STATUS: "Stare",
                IS_TEST: "Organizație de test",
                ACTIONS: "Acțiuni",
            },
            TOOLTIPS: {
                EDIT: "Editare",
                DELETE: "Ștergere",
                FUNCTIONS: "Funcții",
                DEPARTMENTS: "Departamente",
                USERS: "Utilizatori",
                ACCOUNTS: "Conturi colectoare",
                TAXES: "Taxe",
                RESPONSIBILITIES: "Responsabilități",
            },
            STATUS_TYPE: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
        },
        TABS: {
            DETAILS: "Detalii",
            FUNCTIONS: "Funcții",
            DEPARTMENTS: "Departamente",
            ORGANISATION_TREE: "Organigramă",
            TAXES: "Taxe",
            USERS: "Utilizatori",
            ACCOUNTS: "Conturi BT iPay",
            DOCUMENT_SERIES: "Serii documente",
            DOCUMENT_REGISTERS: "Registre documente",
            RESONSIBILITIES: "Responsabilitați",
            DECISIONS: "Hotărâri",
            URBANISM_REGULATIONS: "Reglementări",
            AI: "AI",
        },
        ADD_EDIT_FORM: {
            NAME: "Nume organizație",
            TYPE: "Tip",
            DESCRIPTION: "Descriere",
            COUNTY: "Județ",
            CITY: "Localitate",
            STATUS_FIELD: "Status",
            TEST_INST: "Organizație de test",
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
            TYPES: {
                COUNTY_COUNCIL: "Consiliul Județean",
                CITY_HALL: "Primărie",
                SERVICES: "Servicii",
            },
            PLACEHOLDER: "Introduceți descrierea organizației",
        },
        ADD_MODAL: {
            HEADER: "Adaugă organizație",
        },
        BUTTON: {
            ADD: "Adaugă",
            CANCEL: "Renunță",
            SAVE: "Salvează",
            UPDATE: "Modifică",
        },
        FUNCTIONS: {
            SEARCH: {
                PLACEHOLDER: "Caută functie",
                ERASE_BUTTON: "Șterge",
            },
            TABLE_HEADER: {
                NAME: "Nume Funcție",
                DESCRIPTION: "Descriere",
                ACTIONS: "Acțiuni",
            },
            TOOLTIPS: {
                EDIT: "Editare",
                DELETE: "Ștergere",
                USERS: "Utilizatori",
                RESPOSABILITIES: "Asociere responsabilități",
            },
        },
        ERRORS: {
            ORG: "Eroare la generarea listei de instituții!",
            SINGLE_ORG: "Eroare la generarea datelor pentru instituție!",
            FUNCTIONS: "Eroare la generarea listei de funcții!",
            UPDATE_ORG: "Eroare la modificarea instituției.",
            ADD_ORG: "Eroare la adăugarea instituției.",
            DELETE_ORG: "Această instituție nu poate fi ștearsă fiindcă există utilizatori asociați",
            PROTECTED_FIELDS: "Doar un super administrator poate modifica tipul, județul, UAT-ul sau marcajul de test al organizației.",
        },
        SUCCESS: {
            UPDATE_ORG: "Instituția a fost modificată cu succes.",
            ADD_ORG: "Instituția a fost adaugată cu succes.",
            DELETE_ORG: "Instituția a fost ștearsă cu succes.",
        },
        ORG_SELECTION_FORM: {
            HEADER: "Selectare organizație activă",
        },
        NAME_FORMAT: {
            COUNTY_COUNCIL_CLUJ: "Consiliul Județean Cluj",
            CITY_HALL: "Primăria {name}",
        },
        ORGANISATION_TREE: {
            SEARCH: {
                PLACEHOLDER: "Caută departament/serviciu/compartiment/funcție/utilizator",
            },
            LEGEND: "Legendă",
            COLLAPSE_ALL: "Ascunde tot",
            EXPAND_ALL: "Deschide tot",
            SHOW_INACTIVE: "Afișează inactive",
            MODAL: {
                ADD_TITLE: "{parent} - Adaugă {type}",
                EDIT_TITLE: "{node} - Editează {type}",
            },
            TYPES: {
                COMPARTMENT: "compartiment",
                SERVICE: "serviciu",
                FUNCTION: "funcție",
                USER: "utilizator",
                DEPARTMENT: "departament",
            },
            TOOLTIPS: {
                EDIT_DEPARTMENT: "Editează departament",
                ADD_SERVICE: "Adaugă serviciu",
                ADD_COMPARTMENT: "Adaugă compartiment",
                EDIT_SERVICE: "Editează serviciu",
                EDIT_COMPARTMENT: "Editează compartiment",
                EDIT_USER: "Editează utilizator",
            },
        },
    },
    INSTITUTION_AI: {
        LOAD_ERROR: "Setările AI nu au putut fi încărcate.",
        FIELDS: {
            API_KEY: "Cheie API",
            MONTHLY_CAP_USD: "Buget lunar (USD)",
            ALERT_EMAILS: "Emailuri pentru alerte",
            VALIDATED_AT: "Validată la",
        },
        PLACEHOLDERS: {
            API_KEY: "sk-ant-…",
            MONTHLY_CAP_USD: "Buget nelimitat",
            ALERT_EMAILS: "Niciun email setat",
        },
        KEY: {
            TITLE: "Cheie API Anthropic",
            DESCRIPTION: "Folosită pentru traducerile AI ale tuturor organizațiilor. Costurile sunt facturate contului Anthropic căruia îi aparține cheia.",
            STATUS_ACTIVE: "Activă",
            STATUS_NOT_CONFIGURED: "Neconfigurată",
            STATUS_UNREADABLE: "Cheia nu poate fi citită",
            STATUS_REJECTED: "Respinsă",
            DISABLED_TEXT: "Traducerile AI sunt oprite până la salvarea unei chei.",
            SAVE_AND_TEST: "Salvează și testează",
            REPLACE: "Înlocuiește cheia",
            REMOVE: "Șterge cheia",
            REMOVE_CONFIRM: "Ștergeți cheia API?",
            REJECTED: "Anthropic a respins această cheie. Nu s-a salvat nimic.",
            UNAVAILABLE: "Cheia nu a putut fi verificată acum (Anthropic sau platforma nu răspunde). Nu s-a salvat nimic, încercați din nou.",
            INVALID_FORMAT: "Cheia nu are formatul corect (sk-ant-…).",
            UNREADABLE_HINT: "Cheia salvată nu mai poate fi decriptată. Reintroduceți cheia pentru a reporni AI.",
            REJECTED_AUTH_HINT: "Anthropic a respins cheia (invalidă sau revocată). Introduceți o cheie nouă.",
            REJECTED_BILLING_HINT: "Contul Anthropic nu mai are credit. Reîncărcați contul, apoi salvați din nou cheia.",
            STORAGE_HINT: "Cheia este verificată la Anthropic și stocată criptat.",
            BUDGET_AFTER_KEY: "Bugetul și alertele apar după salvarea cheii.",
            SAVED: "Cheia a fost validată și salvată. AI este activ, iar traducerile în așteptare ale tuturor organizațiilor au fost programate.",
            REMOVED: "Cheia API a fost ștearsă. AI este oprit pentru toate organizațiile.",
        },
        BUDGET: {
            TITLE: "Buget și alerte",
            DESCRIPTION: "AI se oprește pentru toate organizațiile când este atins bugetul lunar. Alerte la 50%, 80% și 100%.",
            NO_CAP_WARNING: "Fără buget lunar, cheltuielile sunt nelimitate și nu se trimit alerte.",
            INVALID_EMAIL: "Una dintre adrese nu este validă",
            EMAIL_LIMIT: "Puteți introduce maximum {max} adrese",
            SPEND_THIS_MONTH: "Cheltuieli luna aceasta",
            SPEND_OF_CAP: "{spent} USD din {cap} USD",
            SAVED: "Bugetul și alertele au fost salvate.",
        },
        ERRORS: {
            FORBIDDEN: "Nu aveți acces la setările AI.",
            NOT_MANAGED: "Setările AI sunt gestionate de consiliul județean.",
            TOO_MANY_ATTEMPTS: "Prea multe încercări. Încercați din nou în câteva minute.",
            UNCONFIRMED: "Modificarea nu a putut fi confirmată (platforma nu a răspuns). Setările au fost reîncărcate; verificați-le și încercați din nou dacă este nevoie.",
        },
    },
    DEPARTMENTS: {
        PAGE_HEADER: "Departamente",
        LIST: {
            TITLE: "Lista departamentelor",
        },
        FIELDS: {
            NAME: "Denumire",
            STATUS: "Stare",
            DESCRIPTION: "Descriere",
        },
        PLACEHOLDERS: {
            NAME: "Nume",
            STATUS: "Stare",
            DESCRIPTION: "Descriere",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
        },
        TABLE_HEADER: {
            NAME: "Nume Departament/Serviciu",
            DESCRIPTION: "Descriere",
            STATUS: "Stare",
            ACTIONS: "Acțiuni",
        },
        TOOLTIPS: {
            FUNCTIONS: "Asignare Funcții",
            USERS: "Utilizatori",
        },
        ADD_EDIT_MODAL: {
            HEADER: {
                ADD: "Adaugă departament",
                EDIT: "Modifică departament",
            },
            NAME: "Nume departament",
            DESCRIPTION: "Descriere",
            STATUS: "Stare",
            STATUS_TYPE: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
            TYPES: {
                COUNTY_COUNCIL: "Consiliul Județean",
                CITY_HALL: "Primărie",
                SERVICES: "Servicii",
            },
            PLACEHOLDER: "Introduceți descrierea departamentului",
        },
        ASSOCIATED_FCT_MODAL: {
            HEADER: "Asignare Funcții",
            ERRORS: {
                LIST: "Eroare la generarea listei de funcții asociate!",
                ADD_FUNCTION: "Eroare la adaugarea funcției la departament.",
            },
        },
        ASSOCIATED_USERS_MODAL: {
            HEADER: "Asignare Utilizatori",
            ERRORS: {
                LIST: "Eroare la generarea listei de utilizatori asociați!",
                ADD_FUNCTION: "Eroare la adăugarea utilizatorului la departament.",
            },
        },
        ERRORS: {
            DEP_LIST: "Eroare la generarea listei de departamente!",
            ADD: "Eroare la adăugarea departamentului.",
            UPDATE: "Eroare la modificarea departamentului.",
        },
        SUCCESS: {
            ADD: "Departamentul a fost adaugat cu succes.",
            UPDATE: "Departamentul a fost modificat cu succes.",
        },
        BUTTON: {
            ADD_DEPARTMENT: "Adaugă departament",
        },
    },
    FUNCTIONS: {
        PAGE_HEADER: "Funcții",
        LIST: {
            TITLE: "Lista funcțiilor",
            SYSTEM_FUNCTIONS: "Funcțiile - {systemFunctions} - sunt create automat de sistem.",
        },
        FIELDS: {
            NAME: "Denumire",
            ALIAS: "Alias",
            DESCRIPTION: "Descriere",
        },
        PLACEHOLDERS: {
            NAME: "Nume",
            DESCRIPTION: "Descriere",
        },
        ASSOCIATED_RESPOSABILITIES_MODAL: {
            HEADER: "Asignare Responsabilități",
            BODY: {
                TOP: "Funcția",
            },
        },
        ADD_EDIT_FORM: {
            HEADER_ADD: "Adaugă funcție",
            HEADER_EDIT: "Editează funcție",
            NAME: "Denumire",
            NAME_DESCRIPTION: "Introduceți și un alias. Acesta va fi afișat pe semnătură.",
            ALIAS: "Alias",
            DESCRIPTION: "Descriere",
            PLACEHOLDER: "Introduceți descrierea funcției",
            ALIAS_PLACEHOLDER: "Introduceți aliasul funcției.",
            SYSTEM_FUNCTIONS: "Funcțiile de sistem nu sunt editabile.",
        },
        SUCCESS: {
            ADD: "Funcția a fost adaugată cu succes.",
            UPDATE: "Funcția a fost modificată cu succes.",
            DELETE: "Funcția a fost ștearsă cu succes.",
        },
        BUTTON: {
            ADD_FUNCTION: "Adaugă funcție",
        },
    },
    TERRITORIAL_UNIT_ALLOCATION: {
        HEADER: "Asignare UAT",
        FIELDS: {
            TU_NAME: "Denumire",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
        },
        PLACEHOLDERS: {
            TU_NAME: "Nume",
        },
        MODAL: {
            HEADER: "Adaugă UAT",
            OBS: "UAT-urile asignate nu apar în listă",
        },
        BUTTON: {
            ADD_UAT: "Adaugă UAT",
        },
        TABLE_EMPTY_TEXT: "Nu sunt UAT-uri asignate pentru acest utilizator.",
    },
    ADMIN_USERS_MODAL: {
        HEADER: "Listă de conturi utilizatori",
        PLACEHOLDER: "Caută utilizator",
        TABLE_HEADER: {
            LAST_NAME: "Nume",
            FIRST_NAME: "Prenume",
            FUNCTION: "Funcție",
            STATUS: "Stare",
            STATUS_ACTIVE: "Activ",
            STATUS_INACTIVE: "Inactiv",
        },
        FUNCTIONS: {
            ERRORS: {
                LIST: "Eroare la generarea listei de utilizatori pentru o funcție!",
            },
        },
        DEPARTMENTS: {
            ERRORS: {
                LIST: "Eroare la generarea listei de utilizatori pentru un departament!",
            },
        },
    },
    ACCOUNTS: {
        BUTTONS: {
            ADD_ACCOUNT: "Adaugă cont",
            CANCEL: "Renunță",
            INVITE: "Invită prin email",
            RESEND_LINK: "Retrimite link",
            SAVE: "Salvează",
        },
        ENUMS: {
            ROLES: {
                ADMINISTRATOR: "Administrator",
                EDITOR: "Editor",
            },
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
                PENDING: "Trimis",
            },
        },
        FIELDS: {
            CREATED_BY_NAME: "Creat de",
            EMAIL: "E-mail",
            FIRST_NAME: "Prenume",
            LAST_NAME: "Nume",
            PHONE: "Telefon",
            STATUS: "Status",
            ROLE: "Rol",
            USER_NAME: "Nume",
        },
        LABELS: {
            CREATED_BY: "Creat de",
            USER: "Utilizator",
        },
        LIST: {
            ACTIONS: "Acțiuni",
            EDIT: "Editează",
            HEADER: "Conturi conectate",
        },
        MODALS: {
            EDIT_ACCOUNT: "Editează contul",
            ADD_NEW_ACCOUNT: "Adaugă un cont nou",
        },
        NOTIFIERS: {
            EDITED_SUCCESS: "Contul a fost actualizat!",
            INVITE_TEXT: "O invitație a fost trimisă cu succes pe adresa de e-mail <strong>{email}</strong>. După validarea contului aceasta va apărea în cadrul organizației",
            INVITE_TITLE: "Invitație trimisă",
            RESEND_SUCCESS: "Linkul a fost retrimis!",
        },
        PLACEHOLDERS: {
            CHOOSE: "Alege",
            ROL: "Rol",
            SEARCH_NAME: "Cauta numele",
            STATUS: "Status",
        },
        TITLE: "Administrare conturi",
    },
    COLLECTOR_ACCOUNTS: {
        PAGE_HEADER: "Conturi BT iPay",
        LIST: {
            TITLE: "Lista conturilor BT iPay",
        },
        FIELDS: {
            NAME: "Denumire cont",
            BANK: "Banca",
            USERNAME: "Username BT iPay",
            PASSWORD: "Parola BT iPay",
            STATUS: "Stare",
        },
        PLACEHOLDERS: {
            NAME: "Denumire cont",
            BANK: "Banca",
            USERNAME: "Username BT iPay",
            PASSWORD: "Parola BT iPay",
            STATUS: "Stare",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
        },
        TABLE_HEADER: {
            NAME: "Denumire cont",
            BANK: "Banca",
            USERNAME: "Username BT iPay",
            PASSWORD: "Parola BT iPay",
            STATUS: "Stare",
            ACTIONS: "Acțiuni",
        },
        STATUS_TYPE: {
            ACTIVE: "Activ",
            INACTIVE: "Inactiv",
        },
        TOOLTIPS: {
            EDIT: "Editare",
            DELETE: "Ștergere",
        },
        MANAGE_ACCOUNT_MODAL: {
            HEADER: {
                EDIT: "Editeaza Cont BT iPay",
                ADD: "Adauga Cont BT iPay",
            },
            FORM: {
                NAME: "Nume",
                BANK: "Banca",
                USERNAME: "Username BT iPay",
                PASSWORD: "Parola BT iPay",
                STATUS: "Stare",
            },
        },
        CONFIRMATION_MESSAGE: "Esti sigur ca vrei sa stergi contul colector?",
        SUCCESS: {
            DELETE: "Contul Colector a fost sters cu succes.",
            ADD: "Contul colector a fost adaugat cu succes.",
            UPDATE: "Contul colector a fost modificat cu succes.",
        },
        BUTTON: {
            ADD_COLLECTOR_ACCOUNT: "Adaugă cont",
        },
    },
    BENEFICIARIES: {
        DGEVP: {
            CONNECT: "Conectare",
            CONNECT_TITLE: "Conectare DGEVP",
            VALIDATE: "Valideaza",
            INFO: "Info DGEVP: Din motive de securitate acest continut este disponibil doar pentru utilizatorii care au primit acces pe baza de IP de la DGEVP.",
        },
        BUTTONS: {
            ADD_ACCOUNT: "Adaugă beneficiar",
            CANCEL: "Renunță",
            SAVE: "Salvează",
        },
        FIELDS: {
            BENEFICIARY: "Beneficiar",
            IDENTIFIER: "Nume, CNP sau CIF",
            CREATED_BY_NAME: "Creat de",
            EMAIL: "E-mail",
            FIRST_NAME: "Prenume",
            LAST_NAME: "Nume",
            ID_CARD_SERIAL: "Serie CI",
            ID_CARD_NUMBER: "Număr CI",
            ID_CARD_EXPIRATION_DATE: "Data expirării",
            ID_CARD_ISSUED_DATE: "Data eliberării",
            ID_CARD_ISSUER: "Eliberat de",
            PHONE: "Telefon",
            STATUS: "Status",
            ROLE: "Rol",
            USER_TYPE: "Tip persoană",
            PERSONAL_NUMERIC_CODE: "CNP",
            USER_NAME: "Nume",
            LOCALITY: "Municipiu / Oraș / Comună",
            PAYMENT: "Plata",
            EMPLACEMENT_LOCALITY: "Localitate",
            USER_TYPE_NAME: "Tip persoană",
            COUNTY: "Județ",
            VILLAGE: "Localitate",
            SECTOR: "Sector",
            STREET: "Strada",
            STREET_NUMBER: "Număr stradă",
            POSTAL_CODE: "Cod poștal",
            STAIRCASE: "Scara",
            BLOCK: "Bloc",
            FLOOR: "Etaj",
            APARTMENT: "Apartament",
            USE_PROFILE_DATA: "Folosește date profil",
            PASSPORT_NUMBER: "Nr. pașaport",
            CITY: "Oraș",
            ADDRESS: "Adresă",
            LICENSE: "Licență",
            COMPANY_NAME: "Denumire entitate",
            IBAN: "Cont IBAN",
            BANK: "Deschis la",
            UNIQUE_REGISTRATION_CODE: "CIF sau CUI",
            REGISTRATION_NUMBER: "Număr înregistrare Oficiul Registrul Comerțului",
            USERNAME: "Utilizator",
            PASSWORD: "Parola",
        },
        LABELS: {
            CREATED_BY: "Creat de",
            USER: "Utilizator",
        },
        LIST: {
            ACTIONS: "Acțiuni",
            EDIT: "Editează",
            HEADER: "Beneficiari",
            DELETE: "Șterge",
        },
        MODALS: {
            EDIT_ACCOUNT: "Editează beneficiar",
            ADD_NEW_ACCOUNT: "Adaugă un beneficiar nou",
        },
        NOTIFIERS: {
            ADDED_SUCCESS: "Beneficiarul a fost adăugat!",
            EDITED_SUCCESS: "Beneficiarul a fost actualizat!",
            DELETE_SUCCESS: "Beneficiarul a fost șters cu succes!",
        },
        PLACEHOLDERS: {
            CHOOSE: "Alege",
            ROL: "Rol",
            SEARCH_NAME: "Cauta numele",
            STATUS: "Status",
        },
        TITLE: "Administrare beneficiari",
        SUCCESS: {
            DELETE: "Beneficiarul a fost șters cu succes!",
        },
    },
    TAX_CATEGORY: {
        LIST: {
            TITLE: "Categorii de taxare",
        },
        FILTER: {
            TITLE: "Categorii de taxare",
        },
        ADD_BUTTON: "Categorie noua",
        FIELDS: {
            NAME: "Denumire",
            STATUS: "Status",
        },
        FORM: {
            EDIT_TITLE: "Editeaza categorie",
            ADD_TITLE: "Categorie noua",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
        },
        PLACEHOLDERS: {
            NAME: "Cauta dupa denumire",
            STATUS: "Status",
        },
    },
    COMPLAIN_TYPE: {
        LIST: {
            TITLE: "Tipologii de sesizări",
        },
        ADD_BUTTON: "Tipologie nouă",
        FIELDS: {
            NAME: "Denumire",
            STATUS: "Status",
            COMPLAIN_DOCUMENT_SERIES_TYPE: "Tip serie de document",
            TENANT_ID: "Organizație",
        },
        FORM: {
            EDIT_TITLE: "Editează tip sesizare",
            ADD_TITLE: "Tip sesizare nouă",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
            STATUS: "Status",
        },
    },
    COMPLAIN: {
        LIST: {
            TITLE: "Sesizări",
            TABLE_HEADER: "Istoric sesizări",
            ADD_BUTTON: "Sesizare nouă",
            NO_ASSIGNEE: "Nealocată",
        },
        STAFF_LIST: {
            TITLE: "Sesizări",
            TABLE_HEADER: "Sesizări",
            ADD_BUTTON: "Control nou",
        },
        FIELDS: {
            COMPLAIN_TYPE: "Tip sesizare",
            LOCALITY: "Localitate",
            ADDRESS: "Adresă",
            ADDRESS_DETAILS: "Detalii adiționale locație",
            DESCRIPTION: "Descrierea sesizării",
            FIRST_NAME: "Prenume",
            LAST_NAME: "Nume",
            EMAIL: "E-mail",
            PHONE: "Telefon",
            STATUS: "Status",
            REPORTED_BY: "Creat de",
            REPORTED_FOR: "Persoana de contact",
            IDENTIFICATION_NUMBER: "Cod intrare",
            CREATED_DATE: "Data",
            USE_PROFILE_DATA: "Folosește datele profilului meu",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            MESSAGE_COMMENT: "Mesajul tău",
            RESPONSE_TEMPLATES: "Template-uri de răspuns",
            DISMISSED_COMMENT: "Mesaj template",
            UAT: "Municipiu / Oraș / Comună",
            ASSIGNED_TO: "Soluționat de",
        },
        FORM: {
            TITLE: "Formular sesizare nouă",
            TITLE_CLASSIFY: "Clasare sesizare",
            TITLE_RESOLVED: "Soluționare sesizare",
            COMPLAIN_DETAIL_SECTION_TITLE: "Detalii sesizare",
            USER_DETAIL_SECTION_TITLE: "Detalii persoană contact",
            ATLAS_PREVIEW_SECTION_TITLE: "Locație",
            DOCUMENTS_SECTION_TITLE: "Încarcă documente / fotografii",
            VIEW_DOCUMENTS_SECTION_TITLE: "Vizualizare documente / fotografii",
            UPLOAD_DOCUMENT_BUTTON: "Încarcă document",
            SUBMIT_BUTTON: "Trimite sesizarea",
            VIEW_GOOGLE_MAPS_BUTTON: "Vizualizare in Google Maps",
            CLASSIFY_BUTTON: "Clasare",
            RESOLVED_BUTTON: "Soluționează",
            EMPTY_DOCUMENT_LABEL: "Nu există documente atașate",
            RESOLVE_BUTTON: "Trimite răspuns - Soluţionată",
            RESPONSE: "Răspuns sesizare",
            PREVIEW_TITLE: "Previzualizare notificare",
            NOTIFICATION_TEMPLATE_TEXT: "Sesizarea de tipul '{type}' având numarul unic de înregistrare {number} creată de {user}, a fost clasată în Ghișeul Unic, motivul fiind:",
            FILE_PLACEHOLDER_NAME: "Fișier {0}",
        },
        TABS: {
            COMPLAIN: "Sesizare",
            DISCUSSIONS: "Activități",
        },
        PLACEHOLDERS: {
            DESCRIPTION: "Mesajul tău",
            STATUS: "Status",
            REPORTED_BY: "Creat de",
            REPORTED_FOR: "Persoana de contact",
            LOCALITY: "Localitate",
            IDENTIFICATION_NUMBER: "Caută după cod",
            ASSIGNED_TO: "Soluționat de",
        },
        ENUMS: {
            STATUS: {
                NEW: "Inregistrată",
                PENDING: "In procesare",
                RESOLVED: "Soluţionată",
                REJECTED: "Respinsă",
                DISMISSED: "Clasată",
            },
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Sesizare trimisă",
            CREATED_SUCCESS_TEXT: "Sesizarea cu numarul <strong>{number}</strong> a fost trimisă cu succes.</br> Dupa o analiza si verificare vei fi notificat in legatura cu rezolvarea acesteia.",
            CLASSIFICATION_MESSAGE: "Sunteţi sigur că doriţi să clasaţi sesizarea?",
            CLASSIFICATION_SUCCESS_TEXT: "Sesizarea a fost clasată.",
            RESOLVE_MESSAGE: "Sunteţi sigur că doriţi să soluţionaţi sesizarea?",
            RESOLVE_SUCCESS_TEXT: "Sesizarea a fost soluţionată.",
            LOCATION_TITLE: "Lipsă locaţie!",
            LOCATION_TEXT: "Te rog alege locaţia/orașul sesizării pe hartă pentru a depune sesizarea.",
        },
    },
    FORM_FIELDS: {
        SAVE_BTN: "Salvează",
        INVITE_BTN: "Invită prin email",
        CANCEL_BTN: "Renunţă",
        FIRST_NAME: "Prenume",
        LAST_NAME: "Nume",
        FULL_NAME: "Nume Prenume",
        EMAIL: "Email",
        PHONE: "Telefon",
        DEPARTMENT: "Departament",
        ORGANISATION: "Instituţie",
        ROLE: "Rol",
        TAG_ID: "Număr legitimaţie",
        TAG_RELEASED_BY: "Legitimaţie eliberată de",
        EXTERNAL_ENROLLMENT_ID: "External ID (Enrollment)",
        FUNCTION: "Funcţie",
        RESPONSIBILITIES: "Responsabilităţi",
        PERMISSIONS: "Permisiuni",
        STATUS: "Status",
        IS_ORGANISATION_ADMIN: "Administrator organizație",
        MESSAGES: {
            ACCOUNT_CREATED: "Contul a fost creat",
            ACCOUNT_UPDATED: "Contul a fost modificat",
            ACCOUNT_NOT_CREATED: "A aparut o eroare la crearea contului",
            ACCOUNT_NOT_UPDATED: "A aparut o eroare la modificarea contului",
            NO_FUNCTIONS_SELECTED: "Nu a fost selectată nicio funcție",
            ASSIGNMENT_NO_FUNCTIONS: "Repartizarea {assignmentNumber} ({departmentName}) trebuie să aibă selectată cel puțin o funcție.",
            ASSIGNMENTS_NO_FUNCTIONS: "Următoarele repartizări trebuie să aibă selectată cel puțin o funcție: {assignmentDetails}",
            NO_ASSIGNMENTS: "Nu au fost adăugate repartizări.",
        },
        ASSIGNED_TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT-uri asignate",
        SERVICE: "Serviciu",
        COMPARTMENT: "Compartiment",
        SERVICE_COMPARTMENT: "Compartiment din interiorul serviciului",
        FUNCTIONS: "Funcții",
        SELECTED_FUNCTIONS_SUMMARY: "Funcții",
        DEPARTMENT_FUNCTIONS: "Funcții din departament",
        ASSIGNMENT: "Selectează din repartizările existente",
        ALREADY_ASSIGNED: "Deja repartizat",
        SERVICES: "Servicii",
        SERVICE_FUNCTIONS: "Funcții din serviciu",
        COMPARTMENTS: "Compartimente",
        COMPARTMENT_FUNCTIONS: "Funcții din compartiment",
        SERVICE_COMPARTMENTS: "Compartimente subordonate serviciului",
        SERVICE_COMPARTMENTS_SECTION_TITLE: "Compartimente subordonate servicilor",
        SERVICE_COMPARTMENT_FUNCTIONS: "Funcții din compartiment al serviciului",
        NO_COMPARTMENTS_AVAILABLE: "Nu există compartimente disponibile",
        NO_DEPARTMENTS_AVAILABLE: "Nu există departamente disponibile",
        NO_SERVICES_AVAILABLE: "Nu există servicii disponibile",
        NO_FUNCTIONS_AVAILABLE: "Nu există funcții disponibile",
        NO_SERVICE_COMPARTMENTS_AVAILABLE: "Nu există compartimente de serviciu disponibile",
        NO_DEPARTMENT_FUNCTIONS_AVAILABLE: "Nu există funcții de departament disponibile",
        NO_SERVICE_FUNCTIONS_AVAILABLE: "Nu există funcții de serviciu disponibile",
        NO_COMPARTMENT_FUNCTIONS_AVAILABLE: "Nu există funcții de compartiment disponibile",
        NO_SERVICE_COMPARTMENT_FUNCTIONS_AVAILABLE: "Nu există funcții de compartiment al serviciului disponibile",
        PERSONAL_INFORMATION: "Date personale",
        IDENTIFICATION_AND_ORGANIZATION: "Detalii organizație",
        ORGANIZATIONAL_ASSIGNMENTS: "Repartizări organizaționale",
        DEPARTMENT_AND_STRUCTURE: "Structură departament",
        FUNCTIONS_AND_ROLES: "Asignare funcții în departament",
        FUNCTIONS_AND_ROLES_STAFF: "Funcții în departament",
        SELECT_SERVICES: "Selectează servicii",
        SELECT_COMPARTMENTS: "Selectează compartimente",
        SELECT_SERVICE_COMPARTMENTS: "Selectează compartimente subordonate serviciului",
        NO_DEPARTMENT: "Fără departament selectat",
        NO_RESPONSIBILITIES: "Nu există responsabilități disponibile",
        NO_TERRITORIAL_UNITS: "Nu există UAT-uri asignate",
    },
    FUNCTIONARY: {
        LIST: {
            TITLE: "Lista funcționarilor",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
                PENDING: "În așteptare",
            },
        },
        FIELDS: {
            FIRST_NAME: "Prenume",
            LAST_NAME: "Nume",
            EMAIL: "Email",
            STATUS: "Status",
            FULL_NAME: "Nume Prenume",
            DEPARTMENTS: "Departamente",
            SERVICES: "Servicii",
            COMPARTMENTS: "Compartimente",
            SERVICE_COMPARTMENTS: "Sub-Compartimente",
            FUNCTIONS: "Funcții",
            ACCOUNT_TYPE: "Tip cont",
            ADMIN: "Administrator",
            STAFF: "Funcționar",
        },
        PLACEHOLDERS: {
            EMAIL: "Email",
            STATUS: "Status",
            FULL_NAME: "Nume Prenume",
            DEPARTMENTS: "Departament",
            FUNCTIONS: "Funcție",
            SERVICES: "Serviciu",
            COMPARTMENTS: "Compartiment",
            SERVICE_COMPARTMENTS: "Sub-Compartiment",
            LAST_NAME: "Nume",
        },
        HEADER_LIST: "Administrare conturi funcționari",
        ADD_BTN: "Adaugă cont",
        ADD_ACCOUNT_HEADER: "Adaugă cont nou",
        EDIT_ACCOUNT_HEADER: "Modificare cont",
        TABLE_HEADER: {
            ACTIONS: "Acțiuni",
        },
        DELETE_ACCOUNT_MESSAGE: "Ești sigur că vrei să ștergi contul de funcționar?",
        DELETED_ACCOUNT_SUCCESS: "Contul a fost șters",
        RESET_PASS_SUCCESS: "S-a trimis un link de resetare a parolei pe adresa de e-mail <strong>{email}</strong>.",
        CHANGE_STATUS_SUCCESS: "Statusul contului a fost modificat",
        DENY_DELETE_ACCOUNT: "Contul nu poate fi șters",
        CHANGE_ACCOUNT_STATUS: "<p>Ești sigur că vrei să schimbi statusul contului?<p><small>Status curent: <b>{status}</b></small>",
        RESET_PASSWORD: "Resetare parolă",
        RESET_PASSWORD_CONFIRM: "Ești sigur că vrei să resetezi parola?",
        CHANGE_ACCOUNT_STATUS_ACTION: "Activare/dezactivare cont",
        DENY_RESET_PASSWORD: "Parola nu poate fi resetată pentru un cont inactiv",
        PERMISSIONS_TOOLTIP: "Permisiuni",
        PERMISSIONS: {
            HEADER: "Listă permisiuni",
            FILTER_PLACEHOLDER: "Caută după denumire",
            PERMISSION_NAME_LABEL: "Denumire",
        },
        TOOLTIPS: {
            TERRITORIAL_UNIT_ALLOCATION: "Adăugare/Ștergere UAT-uri",
        },
        UNKNOWN: {
            SERVICE: "Serviciu necunoscut",
            SERVICE_COMPARTMENT: "Sub-compartiment necunoscut",
            COMPARTMENT: "Compartiment necunoscut",
        },
    },
    RESPONSE_TEMPLATES: {
        LIST: {
            TITLE: "Template-uri de raspuns",
            ACTIONS: "Actiuni",
        },
        ADD_BUTTON: "Adauga template",
        FIELDS: {
            TITLE: "Titlu",
            CATEGORY: "Categorie",
            MESSAGE: "Mesaj template",
        },
        FORM: {
            EDIT_TITLE: "Editeaza template",
            ADD_TITLE: "Adauga template",
        },
        ENUMS: {
            CATEGORY: {
                COMPLAINS: "Sesizari",
                APPLICATIONS: "Cereri",
                NOTICE: "Avize",
            },
        },
        PLACEHOLDERS: {
            TITLE: "Cauta dupa titlu",
            CATEGORY: "Categorie",
            MESSAGE: "Mesaj template",
        },
        CATEGORY: {
            COMPLAINS: "sesizare",
            APPLICATIONS: "cerere",
            NOTICE: "aviz",
        },
    },
    TRANSLATIONS: {
        LIST: {
            TITLE: "Traduceri",
            ACTIONS: "Acțiuni",
            OVERRIDE: "Corectează manual",
            RETRANSLATE: "Retraduce",
            RETRANSLATE_SELECTED: "Retraduce ({count})",
        },
        FIELDS: {
            NAMESPACE: "Domeniu",
            ENTITY_ID: "Entitate",
            PATH: "Câmp",
            SOURCE_TEXT: "Sursă (RO)",
            TEXT: "Traducere",
            CONTENT: "Căutare text",
            LANGUAGE: "Limbă",
            STATUS: "Status",
            ORIGIN: "Origine",
            TRANSLATED_AT: "Actualizat",
            SOURCE_TERM: "Termen sursă (RO)",
            TARGET_TERM: "Termen tradus",
            NOTES: "Note",
            TERM: "Termen",
            UPDATED_AT: "Actualizat",
        },
        PLACEHOLDERS: {
            NAMESPACE: "Domeniu",
            ENTITY_ID: "Id entitate",
            CONTENT: "Caută în sursă și traducere",
            LANGUAGE: "Limbă",
            STATUS: "Status",
            ORIGIN: "Origine",
            SOURCE_TERM: "Termen sursă",
            TARGET_TERM: "Termen tradus",
            NOTES: "Note",
            TERM: "Caută termen",
        },
        ENUMS: {
            LANGUAGE: {
                HU: "Maghiară",
                EN: "Engleză",
            },
            STATUS: {
                PUBLISHED: "Publicată",
                STALE: "Învechită",
                FAILED: "Eșuată",
                UNTRANSLATABLE: "Fără traducere",
                NO_API_KEY: "Fără cheie API",
            },
            ORIGIN: {
                MACHINE: "Automată",
                HUMAN: "Manuală",
            },
        },
        OVERRIDE: {
            TITLE: "Corectare manuală",
            NOTE: "O corectare manuală nu este niciodată suprascrisă de o retraducere automată.",
            SUCCESS: "Traducerea a fost corectată.",
            REJECTED: "Traducerea nu a putut fi salvată: {reason}",
            SOURCE_LABEL: "Text sursă (RO)",
            TEXT_LABEL: "Traducere",
        },
        RETRANSLATE: {
            QUEUED: "Retraducerea a fost programată.",
            QUEUED_COUNT: "Programate pentru retraducere: {count}.",
            PARTIALLY_FAILED: "Programate pentru retraducere: {queued}. Nu au putut fi programate: {failed}.",
        },
        GLOSSARY: {
            TITLE: "Glosar traduceri",
            ADD_BUTTON: "Adaugă termen",
            RETRANSLATE_ALL_BUTTON: "Retraduce tot",
            FUTURE_ONLY_NOTE: "Modificările din glosar afectează doar traducerile viitoare. Traducerile existente rămân neschimbate până la o retraducere.",
            FORM: {
                ADD_TITLE: "Adaugă termen",
                EDIT_TITLE: "Editează termen",
            },
            RETRANSLATE_MODAL: {
                TITLE: "Retraduce toate formularele",
                SCOPE_LABEL: "Limbi retraduse",
                ONLY_LANGUAGE: "Doar {language}",
                BOTH_LANGUAGES: "Ambele limbi",
                COST_ESTIMATE: "Cost estimat: ~{cost} USD pentru {forms} formulare.",
                COST_UNAVAILABLE: "Costul estimat nu este disponibil momentan.",
                CONFIRM: "Pornește retraducerea",
            },
        },
        DASHBOARD: {
            TITLE: "Panou traduceri",
            CATALOGUE_COVERAGE: "Acoperire catalog — {language}",
            FORMS_OPTED_IN: "Formulare traductibile",
            SPEND: "Cheltuieli luna aceasta",
            SPEND_OF_CAP: "{spent} USD din {cap} USD",
            USAGE_UNAVAILABLE: "Datele de consum AI nu sunt disponibile momentan.",
            STATUS_BREAKDOWN: "Statusuri pe limbă",
            SPEND_PANEL: "Consum AI",
            REQUESTS: "Cereri",
            REFUSED: "Refuzate",
            CACHE_HIT: "Cache hit",
            BY_PURPOSE: "Pe scop",
            PURPOSE: {
                BACKFILL: "Traducere inițială",
                CHURN: "Actualizări conținut",
                LAZY_FILL: "La cerere",
            },
            BY_LANGUAGE: "Pe limbă",
            NO_DATA: "—",
        },
    },
    TAXES: {
        BUTTONS: {
            ADD_TAX: "Adaugă taxă",
        },
        FIELDS: {
            NAME: "Denumire",
            ENTRY_DATE: "Data intrării în vigoare",
            JUSTIFICATION: "HCL/NR/DATA",
            CATEGORY: "Categorie",
            FIXED_VALUE: "Valoare fixă",
            PERCENTAGE_VALUE: "Valoare procentuală",
            PRICE_CALCULATION_MODEL: "Tipul de calcul",
            START: "Început",
            END: "Final",
            VALUE: "Valoare",
        },
        LABELS: {},
        LIST: {
            ACTIONS: "Acțiuni",
            EDIT: "Editează",
            HEADER: "Lista taxelor",
        },
        MODALS: {
            ADD_TITLE: "Adaugă taxă",
            EDIT_TITLE: "Editează taxă",
            HCL: "HCL / Altă justificare",
            ADD: "Adaugă",
            SAVE: "Salvează",
            CANCEL: "Renunță",
        },
        NOTIFIERS: {
            SAVED: "Taxa a fost salvată",
            EDITED: "Taxa a fost actualizată",
            INVALID_RANGES: "Intervalele sau valorile nu sunt valide",
        },
        PLACEHOLDERS: {
            NAME: "Denumire",
            CATEGORY: "Categorie",
        },
        ENUMS: {
            PRICE_CALCULATION_MODEL: {
                FIXED: "Fix",
                RANGE: "Intervale",
                MIXED: "Mix",
                PERCENTAGE: "Procentual",
            },
        },
    },
    DOCUMENT_SERIES: {
        BUTTONS: {
            ADD_SERIES: "Adaugă serie",
        },
        FIELDS: {
            NAME: "Denumire",
            SEPARATOR: "Separator",
            DESCRIPTION: "Descriere",
            PREFIX: "Prefix",
            REJECTED_PREFIX: "Prefix adresă răspuns",
            CURRENT_INDEX: "Index curent",
            CATEGORY: "Categorie/Registre",
            YEARLY_RESET: "Resetare anuală",
            ACTIVE: "Activ",
            SERIES_TYPE: "Tip serie",
            REJECTED_INDEX: "Index adresă răspuns",
        },
        LIST: {
            EDIT: "Editează",
            HEADER: "Lista seriilor de documente",
        },
        MODALS: {
            ADD_TITLE: "Adaugă serie document",
            EDIT_TITLE: "Editează serie document",
            ADD: "Adaugă",
            SAVE: "Salvează",
            CANCEL: "Renunță",
        },
        NOTIFIERS: {
            SAVED: "Seria de documente a fost salvată",
            EDITED: "Seria de documente a fost actualizată",
            LOCATION_ALREADY_ADDED: "Locatia este deja adaugată",
        },
        PLACEHOLDERS: {
            NAME: "Denumire",
        },
    },
    DOCUMENT_REGISTERS: {
        BUTTONS: {
            ADD_REGISTER: "Adaugă registru",
        },
        FIELDS: {
            NAME: "Denumire",
            DESCRIPTION: "Descriere",
            REGISTER_TYPE: "Tip registru",
            IS_CUSTOM: "Registru personalizat",
            APPLICATION_TYPE_IDS: "Tipologii de cerere",
            DOCUMENT_SERIES_IDS: "Seriile de documente",
        },
        LIST: {
            VIEW: "Vizualizează",
            EDIT: "Editează",
            DELETE: "Șterge",
            HEADER: "Lista registrelor de documente",
        },
        MODALS: {
            ADD_TITLE: "Adaugă registru document",
            EDIT_TITLE: "Editează registru document",
            ADD: "Adaugă",
            SAVE: "Salvează",
            CANCEL: "Renunță",
        },
        NOTIFIERS: {
            SAVED: "Registrul de documente a fost salvat",
            EDITED: "Registrul de documente a fost actualizat",
            DELETED: "Registrul de documente a fost șters",
        },
        VALIDATION: {
            REQUIRED_SELECTION_TITLE: "Selecție obligatorie",
            REQUIRED_SELECTION_TEXT: "Selectați cel puțin o opțiune pentru {field}.",
            NO_APPLICATION_TYPES_TEXT: "Seriile de documente selectate nu au tipuri de cerere. Selectați serii de documente care au cel puțin un tip de cerere.",
            MAX_COLUMNS_TITLE: "Număr maxim de coloane",
            MAX_COLUMNS_TEXT: "Ați selectat {selected} de coloane. Un registru poate conține cel mult {max} coloane.",
            RECOMMENDED_COLUMNS_TITLE: "Număr mare de coloane",
            RECOMMENDED_COLUMNS_TEXT: "Ați selectat {selected} de coloane. Mai mult de {recommended} de coloane pot reduce performanța. Puteți selecta până la {max} de coloane.",
            MIN_COLUMNS_TITLE: "Coloane obligatorii",
            MIN_COLUMNS_TEXT: "Selectați cel puțin o coloană pentru registru.",
        },
        PLACEHOLDERS: {
            NAME: "Denumire",
            DESCRIPTION: "Descriere",
            APPLICATION_TYPE: "Selectați tipul de aplicație",
            DOCUMENT_SERIES: "Selectați seria de documente",
            SEARCH_APPLICATION_TYPES: "Căutați tipologii de cerere",
        },
    },
    ORG_RESPONSIBILITIES: {
        BUTTONS: {
            ADD_RESPONSIBILITY: "Adaugă responsabilitate",
        },
        LIST: {
            TITLE: "Responsabilități",
        },
        FILTER: {
            TITLE: "Listă Responsabilități",
        },
        FIELDS: {
            RESPONSIBILITY_NAME: "Denumire",
            RESPONSIBILITIES: "Responsabilități",
        },
        PLACEHOLDERS: {
            RESPONSIBILITY_NAME: "Caută dupa denumire",
            RESPONSIBILITIES: "Responsabilități",
        },
        FORM: {
            ADD_TITLE: "Adaugă responsabilitate",
            EDIT_TITLE: "Modifică responsabilitate",
            SELECTED_RESPONSIBILITY: "Responsabilitate selectată",
            PERMISSIONS: "Permisiuni",
            CLONE_TITLE: "Clonează responsabilitate",
        },
        CLARIFICATION: {
            ADD: "Responsabilitatea se poate adăuga dacă există responsabilitate și permisiuni selectate.",
            EDIT: "Responsabilitatea se poate modifica doar dacă există permisiuni selectate.",
        },
    },
    RESPONSIBILITY: {
        FILTER: {
            TITLE: "Responsabilități",
        },
        FIELDS: {
            NAME: "Denumire",
            DESCRIPTION: "Descriere",
            CREATED_DATE: "Data inserării",
            UPDATED_DATE: "Ultima actualizare",
            ACTIONS: "Acțiuni",
        },
        PLACEHOLDERS: {
            NAME: "Caută dupa denumire",
            PERMISSIONS: "Caută Permisiuni",
        },
        FORM: {
            ASSOCIATED_PERMISSIONS: "Permisiuni asociate",
            EDIT_TITLE: "Editează responsabilitate",
            ADD_TITLE: "Adaugă responsabilitate",
        },
        LOGS: {
            TITLE: "Istoric",
        },
    },
    APPLICATION: {
        LIST: {
            TITLE_STAFF: "Registratură generală",
            TITLE: "Cereri",
            TABLE_HEADER: "Listă cereri",
            ADD_BUTTON: "Cerere nouă",
            REFRESH_BUTTON: "Reîncarcă",
            REPORT_BUTTON: "Generează raport",
            ADD_DOCUMENT_BUTTON: "Document",
            DOCUMENT_CREATED_HEADER: "Documente create",
            DOCUMENT_RECEIVED_HEADER: "Documente primite",
            DOCUMENT_PUBLIC_HEADER: "Acte publice",
            PAYMENTS_HEADER: "Plăți înregistrate",
            NO_ASSIGNEE: "Nealocată",
            SIGN_DOCUMENT_BULK: "Semnează documente",
            SIGN_DOCUMENT_BULK_PERSONALIZED: "Semnează personalizat documente",
            SIGN_DOCUMENT_BULK_STS: "Semnează documente cu STS",
            CONFIRM_DELETE_TEXT: "Ești sigur că vrei să ștergi această cerere? Cererile șterse nu mai pot fi accesate!",
            REFRESH_DOCUMENT_BUTTON: "Reîncarcă",
            REFRESH_PAYMENTS_BUTTON: "Reîncarcă",
            OFFLINE_APPLICATION: "Ghișeu",
            ASSIGN_MULTIPLE: "Alocare multiplă",
        },
        FIELDS: {
            APPLICATION_TYPE_NAME: "Selectează tipul cererii",
            ORGANISATION_NAME: "Selectează instituția",
            APPLICATION_REGISTER_TYPE_NAME: "Selectează tipul documentului",
            APPLICATION_TYPE_NAME_COLUMN: "Tipologie",
            ORGANISATION_NAME_COLUMN: "Instituție",
            APPLICATION_TYPE_PURPOSE: "Selectează scopul cererii",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "Tip UAT",
            PAYMENT: {
                CREATED_DATE: "Dată înregistrare",
                AMOUNT: "Sumă",
                CURRENCY: "Monedă",
                DESCRIPTION: "Detalii",
                PAYMENT_TYPE: "Tip plată",
                STATUS: "Status",
                EMAIL: "Email",
                CLIENT_USER_NAME: "Nume client",
                CLIENT_USER_EMAIL: "Email client",
                CLIENT_USER_PERSONAL_NUMERIC_CODE: "CNP",
                PRODUCT_IDENTIFIER_TYPE_DESCRIPTION: "Descriere",
                BT_PAYMENT_ID: "ID tranzacție",
                APPLICATION_TYPE_NAME: "Tip cerere",
                RECEIPT_FILE_ID: "Dovadă plată",
            },
            STATUS: "Status",
            LOCALITY: "Municipiu / Oraș / Comună",
            EMPLACEMENT_LOCALITY: "Localitate",
            FIRST_NAME: "Prenume",
            LAST_NAME: "Nume",
            ID_CARD_SERIAL: "Serie CI",
            ID_CARD_NUMBER: "Număr CI",
            ID_CARD_EXPIRATION_DATE: "Data expirării",
            ID_CARD_ISSUED_DATE: "Data eliberării",
            ID_CARD_ISSUER: "Eliberat de",
            EMAIL: "E-mail",
            PHONE: "Telefon",
            SIGNER_FUNCTION_CURRENT: "Semnatar curent",
            SIGNER_FUNCTION_NEXT: "Semnatar următor",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Cerere parinte",
            IDENTIFICATION_NUMBER: "Cod intrare",
            CREATED_DATE: "Dată creare",
            APPLICATION_DATE: "Dată intrare",
            LAST_REVIEW_DATE: "Ultima completare",
            ISSUED_DATE: "Dată finalizare",
            RESPONSE_DUE_IN: "Timp rămas",
            CADASTRAL_NUMBER: "Nr. cadastral",
            USER_TYPE_NAME: "Tip persoană",
            PERSONAL_NUMERIC_CODE: "CNP",
            COUNTY: "Județ",
            VILLAGE: "Localitate",
            SECTOR: "Sector",
            STREET: "Strada",
            STREET_NUMBER: "Număr stradă",
            POSTAL_CODE: "Cod poștal",
            STAIRCASE: "Scara",
            BLOCK: "Bloc",
            FLOOR: "Etaj",
            APARTMENT: "Apartament",
            REAL_ESTATE_TYPE: "Tip amplasament",
            AUTHORISATION_CODE: "TNA",
            SUBSIDIARY: "Filiala",
            LAND_AREA: "Suprafața terenului",
            OTHER_IDENTIFICATION: "Altă identificare",
            CREATED_BY: "Creat de",
            FILE_TYPE: "Tip document",
            RESOLVED_DATE: "Data soluționării",
            PIN: "Cod confirmare",
            USE_PROFILE_DATA: "Folosește date profil",
            PASSPORT_NUMBER: "Nr. pașaport",
            CITY: "Oraș",
            ADDRESS: "Adresă",
            LICENSE: "Licență",
            COMPANY_NAME: "Denumire entitate",
            IBAN: "Cont IBAN",
            BANK: "Deschis la",
            UNIQUE_REGISTRATION_CODE: "CIF sau CUI",
            REGISTRATION_NUMBER: "Număr înregistrare Oficiul Registrul Comerțului",
            FILENAME: "Nume document",
            IS_CONTACT_PERSON: "Solicitantul este persoana de contact",
            TITLE: "Titlu",
            MESSAGE: "Mesaj",
            COMMENTS: "Comentarii",
            CITIZEN_REVIEW: "Vă rugăm să enumerați modificările aduse cererii",
            ASSIGNED_TO: "Responsabil",
            ASSIGNMENT_NOTE: "Notă alocare",
            CLARIFICATION_COMMENT: "Mențiuni",
            MESSAGE_COMMENT: "Mesajul tău public",
            CONTACT_PERSON: "Persoană contact",
            BENEFICIARY: "Beneficiar",
            BENEFICIARY_LEGAL: "Firma",
            PAYMENT_STATUS: "Plată",
            IS_PAID: "Plată",
            IS_SIGNED: "Semnătură",
            TOTAL_TAX: "Total",
            ALLOCATED_DOCUMENT_SERIES: "Cod iesire",
            FIRST_VIZA_SERIES_NUMBER: "Cod Viza CFP",
            SECOND_VIZA_SERIES_NUMBER: "Cod Viza Legalitate",
            REJECTION_VIZA_SERIES_NUMBER: "Cod Viza Respingere",
            SCOPE_CU: "Cuprins",
            PAYMENT_TYPE: "Tip de plată",
            PAYMENT_TYPE_CARD: "Card online",
            PAYMENT_TYPE_OP: "Ordin de plată",
            PAYMENT_TYPE_DISCOUNT: "Scutire plată",
            TRANSACTION_NUMBER: "Număr tranzacție",
            QUICK_SEARCH_VALUES: "Căutare rapidă",
            REJECTED_REASON: "Motivul respingerii - vizibil doar la funcționari",
            PERSONAL_NUMERIC_CODE_OR_CIF: "CNP/CIF",
            DOCUMENT_SERIES_REGISTERS: "Categorie / Registre",
            STATUS_RESOLUTION: "Rezolutie",
            PROJECT_ID: "Project ID",
            CATEGORY_TYPE: "Categorie",
        },
        ENUMS: {
            STATUS_RESOLUTION: {
                PENDING_DOCUMENT_REGENERATION: "Regenerare document",
                PENDING_APPLICATION_ALLOCATED: "Cerere alocata",
                PENDING_CLARIFICATION_RESPONSE: "Raspuns clarificare",
                PENDING_CLARIFICATION_REJECTED: "Document clarificari respinsa",
            },
            STATUS: {
                REGISTERED: "Înregistrată",
                NEW: "Nouă",
                PENDING: "În verificare",
                RESOLVED: "Soluționată",
                REJECTED: "Respinsă",
                APPROVED: "În lucru",
                DRAFT: "Draft",
                GENERATED: "Generat",
                SIGNED: "Semnat",
                SIGN_PENDING: "În semnare",
                CLOSED: "Finalizată",
                REVIEW: "În clarificări",
                REJECTED_IN_PROGRESS: "În respingere",
                ERROR: "Eroare",
                SEALED: "Sigilat",
                INTERNAL: "Intern",
                SEAL_ERROR: "Eroare sigilare",
                SEAL_PENDING: "În sigilare",
                SIGN_APPLICANT_USER_PENDING: "În semnare solicitant",
                WAITING_FOR_CITIZEN: "Necesită clarificare",
                CLARIFICATION_PENDING: "Verificare clarificare",
                CLARIFICATION_SIGN_PENDING: "Semnare clarificare",
                CLARIFICATION_SIGNED: "Clarificare semnată",
                CLARIFICATION_SEALED: "Clarificare sigilată",
                CLARIFICATION_APPROVED: "Clarificare în lucru",
                PROCESSED: "Procesat",
            },
            REAL_ESTATE_TYPE: {
                LAND: "Teren",
                LAND_CONSTRUCTIONS: "Teren + Constructii",
            },
            PAYMENT_TYPE: {
                DISCOUNT: "Scutire plată",
                LINK: "Link",
                CARD: "Card",
                OP: "Ordin plată",
                OFFICE: "Casierie",
                MANUAL: "Plată adăugată",
            },
            PAYMENT_STATUS: {
                CREATED: "În așteptare",
                SUCCESSFUL: "Procesată",
                FAILED: "Eșuată",
            },
            PAYMENT_METHOD: {
                TRANSFER: "Transfer bancar",
                CASH: "Numerar",
                POS: "Card la ghișeu",
                OTHER: "Altă modalitate",
            },
        },
        PLACEHOLDERS: {
            TYPE_OF_SUBMISSION: "Depusă",
            DIGITALIZED_APPLICATION: "Depusă la Ghișeu",
            ONLINE_APPLICATION: "Depusă online",
            BENEFICIARY: "Nume si prenume PF",
            BENEFICIARY_LEGAL: "Firma PJ",
            BENEFICIARY_PNC_OR_UNIQUE_CODE: "CNP/CIF beneficiar",
            SERVICE: "Alege",
            ALLOCATED_STAFF: "Alege",
            IDENTIFICATION_NUMBER: "Cod intrare",
            APPLICATION_TYPE_NAME: "Tip cerere",
            ORGANISATION_NAME: "Instituție",
            CADASTRAL_NUMBER: "Nr CF",
            APPLICATION_TYPE_PURPOSE: "Scopul cererii",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            STATUS: "Status",
            COUNTY: "Județ",
            LOCALITY: "Localitate",
            RESPONSE_DUE_IN: "Timp rămas",
            VILLAGE: "Localitate",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "Tip UAT",
            CREATED_BY: "Creat de",
            EMPLACEMENT_LOCALITY: "Localitate",
            COMMENTS: "Comentarii",
            MESSAGE: "Mesaj",
            ASSIGNED_TO: "Responsabil",
            ASSIGNMENT_NOTE: "Notă pentru responsabil (opțional)",
            EMAIL: "E-mail",
            QUICK_SEARCH_VALUES: "Nr. cerere",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Cerere parinte",
            DOCUMENT_SERIES_REGISTERS: "Categorie/Registre",
            PAYMENT: {
                CREATED_DATE: "Dată înregistrare",
                AMOUNT: "Sumă",
                CURRENCY: "Monedă",
                DESCRIPTION: "Detalii",
                PAYMENT_TYPE: "Tip plată",
                STATUS: "Status",
                EMAIL: "Email",
                CLIENT_USER_NAME: "Nume client",
                CLIENT_USER_EMAIL: "Email client",
                CLIENT_USER_PERSONAL_NUMERIC_CODE: "CNP",
                PRODUCT_IDENTIFIER_TYPE_DESCRIPTION: "Descriere",
                BT_PAYMENT_ID: "ID tranzacție",
                APPLICATION_TYPE_NAME: "Tip cerere",
            },
            STATUS_RESOLUTION: "Rezolutie",
        },
        FORM: {
            TITLE: "Formular cerere nouă",
            SUBMIT_BUTTON: "Trimite cererea",
            SAVE_AS_DRAFT_BUTTON: "Salvează ca draft",
            CONTINUE_BUTTON: "Continuă",
            FILL_APPLICATION_BUTTON: "Completează cererea",
            CANCEL_BUTTON: "Anulează cererea",
            DETAILS_SECTION: "Detalii cerere",
            TAXES_BUTTON: "Calculează taxe",
            TAXES_ERROR: "Vă rugăm selectați tipul cererii și completați suprafața terenului",
            WIZARD_TITLE: "Depunere cerere",
            GO_BACK: "Înapoi",
            GENERATE_DOCUMENT: "Finalizează document",
            NO_TEMPLATE: "Nu există un template pentru acest tip de cerere",
            PAY_BUTTON: "Plătește",
            SEND_LINK_BUTTON: "Trimite link plată",
            SIGN_BUTTON: "Semnează și depune",
            APPLY_BUTTON: "Depune cerere",
            SEND_MESSAGE_BUTTON: "Trimite mesajul",
            PREVIEW_DOC: "Previzualizare",
            SEND_REVIEW: "Trimite clarificări",
            PENDING_RELATED_APPLICATIONS: "Avizul de primar în lucru",
            PENDING_INTERNAL_APPLICATIONS: "Documente interne în lucru",
            HELP_DESCRIPTION: "Dacă ai nevoie de ajutor accesează pagina",
            HELP_FREQUENT_QUESTIONS: "Întrebări frecvente",
            DOWNLOAD_BUTTON: "Descarcă",
            VALIDATE_FILE_BUTTON: "Validează și salvează fișier",
            GIS_ATTACHMENTS: "Anexe GIS",
            GENERATE_BUTTON: "Generează cerere",
            FINALIZE_BUTTON: "Finalizează",
            TAKE_DATA_FROM_CONNECTED_APPLICATIONS: "Preia Date",
            SIGNATURE_TITLE: "Zona este destinată configurării semnatarilor documentului",
            SIGNATURE_DESCRIPTION: "Zona este destinată configurării semnatarilor documentului. </br> ORDINEA DE SEMNARE ESTE DE JOS IN SUS ȘI DE LA STÂNGA LA DREAPTA. </br> Numărul indică ordinea semnării 1 = primul semnatar",
            SAVE_AS_DRAFT_TITLE: "Atenție: părăsind pagina, modificările se vor pierde!",
            SAVE_AS_DRAFT_CONFIRM: "Vrei să salvezi înainte de a continua?",
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Cerere trimisă",
            CREATED_SUCCESS_TEXT: "Cererea cu numărul {number} a fost trimisă cu succes. După o analiză și verificare vei fi notificat în legătură cu rezolvarea acesteia.",
            DRAFT_SAVED_SUCCESS: "Cererea a fost salvată ca draft",
            CHOOSE_SIGN_PACKAGE: "Vă rugăm alegeți pachetul de semnături",
            OFFLINE_SIGN_FAILED: "Documentele nu sunt semnate",
            PAYMENT_FAILED: "Plată eșuată",
            PAYMENT_SUCCESS: "Plata a fost finalizată cu succes",
            INVALID_PROFILE_FOR_SIGNING_TITLE: "Datele din profil nu sunt valide",
            INVALID_PROFILE_FOR_SIGNING_TEXT: "Te rugăm să verifici CNP-ul și datele cărții de identitate din secțiunea <b>Profilul meu</b> necesare pentru semnarea online!",
            INVALID_PROFILE_FOR_SIGNING_BUTTON_TEXT: "Mergi la Profilul meu",
            INVALID_STAFF_ENROLLMENT_TITLE: "A apărut o eroare la procesul de semnare",
            INVALID_STAFF_ENROLLMENT_TEXT: "Te rugăm să te înrolezi pentru a putea semna",
            INVALID_STAFF_ENROLLMENT_BUTTON_TEXT: "Mergi la Profilul meu",
            DUPLICATE_BENEFICIARY_PNC: "Beneficiarul cu același CNP ({pnc}) este deja adăugat.",
            DUPLICATE_BENEFICIARY_REG_CODE: "Beneficiarul cu același CIF/CUI ({unique_registration_code}) si CNP este deja adăugat.",
            GENERATE_OFFLINE_PACKAGE: "Cererea se descarcă. Vă rugăm așteptați!",
            REVIEW_SENT: "Clarificările au fost trimise",
            REVIEW_NOT_SENT: "A apărut o eroare la trimiterea clarificărilor. Te rugăm sa încerci din nou",
            UPLOADING_FILES: "Fișierele sunt în curs de încărcare",
            AUTOSAVE_LOADER_TEXT: "Cererea se salvează automat 1 dată la 10 minute pentru a nu pierde datele introduse.",
            MISSING_UAT: "Localitatea selectată pentru amplasament(e) nu e disponibilă",
            UNAUTHORIZED_PAYMENT: "Ne cerem scuze, momentan nu se poate plăti această cerere. Tipologia de cerere este momentan inactivă.",
            INACTIVE_APPLICATION_TYPE: "Tipologia de cerere este inactivă. Această cerere nu mai poate fi plătită sau depusă.",
            GENERATION_ERROR: "A apărut o eroare la generarea documentului!",
            GENERATION_ERROR_TEXT: "Vă rugăm să reîncercați trimiterea clarificărilor.",
            SENDING_ERROR: "A apărut o eroare. Vă rugăm să reîncercați depunerea cererii mai târziu",
            BULK_SIGN_LIMIT: "Vă rugăm să nu selectați mai mult de {number} cereri pentru semnare bulk",
            REVIEW_APPLICATION_TYPE: "Vă rugăm să setați din secțiunea admin nota de clarificări aferentă",
            INVALID_GIS_FILE: "Fișierul încărcat nu este valid. Vă rugăm să încărcați alt fișier!",
            DOC_RECEIVED_BULK_SIGN_LIMIT: "Maxim {number} documente pot fi semnate o dată.",
            TAKE_DATA_FROM_CONNECTED: "Vor fi preluate și suprascrise datele care se regăsesc într-un singur document conex. Ești sigur că vrei să preiei datele?",
            CLARIFICATION_SIGNED: "Clarificarea a fost semnată și trimisă cu succes.",
        },
        VIEW: {
            TITLE_STAFF: "Registru cereri",
            TITLE: "Cereri",
            SAVE_AS_DRAFT_BUTTON: "Salvează ca draft",
            REASSIGN_STAFF: "Realocare cerere",
            ASSIGN_STAFF: "Alocare cerere",
            SEARCH_PLACEHOLDER_USERS: "Caută după numele funcționarului",
            MODIFY_APPLICATION_TYPE: "Modifica tipologia registratura",
            SEND_TO_REVIEW: "Trimite spre consultare",
            REVIEW_STATUS: "Consultare",
            ASSIGN_REVIEWER: "Alege consultant",
            REASSIGN_REVIEWER: "Realege consultant",
            SEND_TO_REVIEW_DOCUMENT_MESSAGE: "Ești sigur că vrei să trimiți spre consultare acest document?",
            SEND_RESPONSE: "Trimite răspuns",
            APPLICATION_DETAILS_SECTION_TITLE: "Detalii cerere",
            BENEFICIARY_DETAILS_SECTION_TITLE: "Detalii beneficiari",
            BENEFICIARY_DETAILS_TITLE: "Beneficiar",
            REAL_ESTATE_DETAILS_SECTION_TITLE: "Detalii imobil",
            REAL_ESTATE_EMPLACEMENT_DETAILS_SECTION_TITLE: "Detalii amplasament",
            APPLICANT_DETAILS_SECTION_TITLE: "Detalii solicitant / proiectant",
            PAYMENT_DETAILS_SECTION_TITLE: "Plăti",
            ATLAS_DETAILS_SECTION_TITLE: "Previzualizare din atlas teritorial",
            ATTACHMENTS_DETAILS_SECTION_TITLE: "Documente",
            CITIZEN_ATTACHMENTS_DETAILS_SECTION_TITLE: "Documente cetățean",
            ATTACHMENTS_SECTION_OUTPUT: "Acte Emise",
            ATTACHMENTS_SECTION_INPUT: "Acte Depuse",
            ATTACHMENTS_SECTION_PUBLIC: "Acte publice",
            ATTACHMENTS_SECTION_REVIEW: "Clarificări",
            NEXT_STEP: "Pasul următor",
            SIGN_DOCUMENT: "Semnează document",
            SIGN_DOCUMENT_PERSONALIZED: "Semnează personalizat document",
            SIGN_DOCUMENT_STS: "Semnează document cu STS",
            ASSIGN_STAFF_MESSAGE: "Ești sigur că vrei să preiei această cerere?",
            APPROVE_DOCUMENT: "Aprobă",
            REJECT_DOCUMENT: "Respinge",
            APPROVE_DOCUMENT_MESSAGE: "Ești sigur că vrei să aprobi această cerere?",
            REJECT_DOCUMENT_MESSAGE: "Ești sigur că vrei să respingi această cerere?",
            GENERATE_DOCUMENT_MESSAGE: "Documentul a fost generat",
            GENERATE_DOCUMENT_ERROR: "Documentul nu poate fi generat",
            SIGN_DOCUMENT_ERROR: "Documentul nu poate fi semnat",
            SIGN_SUCCESS: "Documentul a fost semnat",
            AUTOSAVE_SUCCESS: "Salvat cu succes",
            AUTOSAVE_FAILED: "Erroare la salvare",
            SEND_CLARIFICATIONS: "Necesită clarificări",
            CREATE_INTERNAL_DOCUMENT: "Creează document intern",
            RETURN_DOCUMENT: "Regenerare document",
            RETURN_DOCUMENT_MESSAGE: "Sunteți sigur că vreți să returnați acest document? Această acțiune este ireversibilă și presupune regenerarea actului.",
            SIGN_ATTACHMENTS_BUTTON: "Semnează anexe",
            SIGN_ATTACHMENTS_BUTTON_PERSONALIZED: "Semnează personalizat anexe",
            SIGN_ATTACHMENTS_BUTTON_STS: "Semnează anexe cu STS",
            DOWNLOAD_COMPRESSION: "Descarcă .zip",
            VIEW_INTERNAL_DOCUMENTS: "Vizualizează documente interne",
            CLOSE_APPLICATION: "Finalizează cererea",
            CREATE_PAYMENT_LINK: "Trimite link plată",
            UPLOAD_FILES: "Vă rugăm să încărcați documentele necesare în secțiunea de Anexe de mai jos",
            PROCESS_ERROR: "Eroare proces",
            SUBPROCESS_ERROR: "Eroare subproces",
            START_PROCESS: "Pornește proces",
            START_SUBPROCESS: "Pornește subproces",
            SEAL_ATTACHMENTS_BUTTON: "Sigilează anexe",
            ASSIGN_MULTIPLE_DIFFERENT_APPLICATION_TYPE_ERROR: "Cererile se pot aloca multiplu doar dacă sunt din aceeași tipologie.",
            SEND_TO_CLARIFICATION_MESSAGE: "Procesul de clarificare a fost inițiat",
            SEND_TO_CLARIFICATION_CITIZEN_MESSAGE: "Clarificarea a fost trimisă",
            SEND_CLARIFICATION_ERROR: "Eroare la trimiterea clarificării",
            WAITING_FOR_CITIZEN: "În așteptarea răspunsului cetățeanului",
            CLARIFICATION_REVIEW_STATUS: "În clarificări",
            FORM_DATA_ERROR: "A apărut o eroare la generarea datelor formularului",
            FILE_UPLOAD_ERROR: "A apărut o eroare la încărcarea fișierelor",
            CLARIFICATION_ID_MISSING: "Clarificarea nu a putut fi identificată",
            PREVIEW_DOCUMENT_ERROR: "Documentul nu poate fi previzualizat",
            SEAL_DOCUMENT_ERROR: "Documentele nu pot fi sigilate",
        },
        INIT_SIGN_MODAL: {
            TITLE: "Personalizare semnătură digitală",
            MESSAGE: "Adaugă o imagine complementară semnăturii",
            MAX_FILE_SIZE: "Maxim 10MB (png, jpg, jpeg)",
            FILE_UPLOAD_INFO_MESSAGE: "Încarcă imaginea prin drag and drop sau prin click",
            FILE_UPLOAD_ERROR_INVALID: "Fișierul este invalid!",
            FILE_UPLOAD_ERROR_SIZE: "Fișierul este prea mare!",
        },
        CONFIRM_SIGN_MODAL: {
            TITLE: "Validare semnătură digitală",
            MESSAGE_SENT: "S-a trimis un SMS la numărul de telefon <strong>{0}</strong>. Adaugă codul primit, pentru a semna cererea folosind semnătura electronică și a trimite cererea.",
            STS_SIGNING: "Vei primi un email sau notificare push pe aplicația mobilă StSign (dacă ai selectat confirmarea). Autorizează și apoi semnează cererea.",
        },
        REJECT_VIZA_MODAL: {
            REJECTION_TITLE: "Respingere Viză",
            REJECTION_COMMENT: "Motivul respingerii: ",
        },
        GENERATE_REPORT_MODAL: {
            DEFAULT_COLUMNS: {
                STATUS: "Status",
                PROJECT_IDS: "Project ID",
                APPLICATION_TYPE_NAME: "Tip cerere",
                IDENTIFICATION_NUMBER: "Numar de identificare",
                APPLICATION_DATE: "Data cererii",
                TERRITORIAL_ADMINISTRATIVE_UNIT_NAME: "UAT",
                REAL_ESTATE_TARGET: {
                    COUNTY: "Judet",
                    TERRITORIAL_ADMINISTRATIVE_UNIT: "Unitate administrativ-teritoriala",
                    LAND_AREA: "Suprafata",
                },
                PAYMENT_DATE: "Data platii",
                TOTAL: "Total",
                ORDER_NUMBER: "Numar de ordine",
                ISSUED_DATE: "Data emiterii",
                ALLOCATED_DOCUMENT_SERIES: "Serie document alocata",
                OP_PAYMENT_ID: "Id plata (OP)",
                PAYMENT_DETAILS: {
                    PAYMENT_TYPE: "Tip plata",
                    PAYMENT_DATE: "Data platii (OP)",
                },
            },
            GENERATE: "Generează",
            NAME_DESCRIPTION: "Selectați un raport predefinit anterior sau introduceți un nume nou",
            NAME: "Nume",
            NAME_PLACEHOLDER: "Introdu sau alege",
            APPLICATION_TYPE_PLACEHOLDER: "Selectați una sau mai multe tipologii",
            APPLICATION_TYPE_NAME: "Tip cerere",
            APPLICATION_TYPE_NAME_PLACEHOLDER: "Alege",
            DATE_RANGE: "Interval raport",
            COLUMNS: "Coloane raport",
            SAVE_AS_PREDEFINED: "Salvează ca raport predefinit",
            MAX_APPLICATION_TYPES_TITLE: "Număr maxim de tipologii",
            MAX_APPLICATION_TYPES_TEXT: "Se pot alege maxim 5 tipologii pentru un raport",
            MAX_COLUMNS_TITLE: "Număr maxim de coloane",
            MAX_COLUMNS_TEXT: "Se pot alege maxim 50 coloane pentru un raport",
            INVALID_DATE_RANGE_TITLE: "Interval de date invalid",
            INVALID_DATE_RANGE_TEXT: "Selectați o dată de început și una de sfârșit valide",
            END_BEFORE_START_TEXT: "Data de sfârșit nu poate fi înainte de data de început",
        },
        TABS: {
            APPLICATION: "Detalii cerere",
            DOCUMENTS: "Documente",
            ACTIVITY: "Activități",
            ACTIVITY_SUBTAB_ACTIVITIES: "Activități",
            ACTIVITY_SUBTAB_COMMENTS: "Comentarii",
            PAYMENTS: "Plăți",
            DOCUMENT_CREATED: "Acte depuse",
            DOCUMENT_RECEIVED: "Acte emise",
            DOCUMENT_PUBLIC: "Acte publice",
            DOCUMENT_REVIEW: "Clarificări",
            DOCUMENT_INTERNAL: "Interne",
            REAL_ESTATE: "Imobil",
            TAXES: "Taxe",
            BENEFICIARY: "Beneficiar",
            NEW_APPLICATION: "Detalii",
            SIGN: "Semnătură",
            SUMMARY: "Rezumat",
            CERTIFICAT_URBANISM: "Certificat urbanism",
            APPLICATION_FORM: "Completează cerere",
            REGISTRY_DETAILS: "Detalii înregistrare",
            CLARIFICATIONS: "Clarificări",
        },
        TERRITORIAL_ATLAS: {
            HEADER: "Previzualizare din atlas teritorial",
            SUBTITLE: "Harta se populează pe măsură ce se adaugă amplasamente.",
            GENERATE_BUTTON: "Vizualizează",
            REAL_ESTATES_LABEL: "Vizualizează amplasamentul",
            PLACEHOLDER: "Introdu datele imobilului apoi apasa butonul “Genereaza” pentru previzualizarea hartii.",
            NOT_FOUND: "Ne pare rău numărul cadastral nu a fost găsit. Incercați din nou!",
            ERROR: "Ne pare rău sincronizarea nu a fost cu succes. Incercați din nou!",
            INACTIVE: "Numărul cadastral este inactiv în evidențele ANCPI.",
            PRESET_SELECT_PLACEHOLDER: "Preseturi de vizibilitate",
        },
        PAYMENT: {
            SECTION_TITLE: "Plătește",
            TITLE: "Alege modalitatea de plată",
            HELP_TEXT_CARD: "Pentru depunerea cererii online taxele se pot plăti online cu card bancar. Procesul de plată se poate face de la distanță, iar pentru aceasta aveți nevoie de confirmarea plății conform setărilor avute de banca emitentă a cardului.",
            HELP_TEXT_LINK: "Pentru depunerea cererii online taxele se pot plăti de către beneficiarul real printr-un link de plată trimis pe email la adresa specificată. Plata se poate face de la distanță, online, cu un card bancar accesand link-ul primit pe email-ul beneficiarului.",
            HELP_TEXT_EXEMPT: "Scutirea aleasă acoperă toate taxele, nu este necesară o modalitate de plată.",
            HELP_TEXT_NO_FEES: "Cererea nu are taxe de achitat, nu este necesară o modalitate de plată.",
            STATUS_PAID: "achitat",
            STATUS_UNPAID: "neachitat",
            STATUS_UNPROCESSED: "neprocesat",
            SELECT: {
                ONLINE: "card bancar",
                LINK: "link beneficiar",
            },
            RECEIPT_DEFAULT_FILE_NAME: "Dovadă plată.pdf",
            LINK_EMAIL_REQUIRED: "Pentru trimiterea link-ului de plată este necesară adresa de email a beneficiarului.",
        },
        PAYMENT_ORDER: {
            FIELDS: {
                ORDER_NUMBER: "Număr ordin",
                PAYMENT_DATE: "Data plății",
            },
        },
        PAYMENT_LINK: {
            TITLE: "Link de plată",
        },
        MANUAL_PAYMENT: {
            ACTIONS: {
                RECORD: "Înregistrează plata",
                ADD: "Adaugă plată încasată",
                CHECK: "Verifică la bancă",
                HISTORY: "Istoric",
            },
            HINTS: {
                VALID_UNTIL: "expiră la {date}",
                LINK_EXPIRED: "expirat la {date}",
                INITIAL_TYPE: "inițial: {type}",
                ADDED: "plată adăugată",
                PREVIOUS_STATUS: "anterior: {status}",
                RECORDED_BY_INSTITUTION: "Înregistrată de instituție",
                RECORDED_MANUALLY: "înregistrată manual",
            },
            LABELS: {
                AMOUNT: "Sumă",
                STATUS: "Stare",
                STATUS_NOW: "Stare curentă",
                STATUS_BEFORE: "Stare anterioară",
                INITIAL_TYPE: "Tip inițial",
                SENT_TO: "Trimis către",
                VALID_UNTIL: "Valabil până la",
                REQUEST_DATE: "Data cererii",
            },
            FORM: {
                RECORD_TITLE: "Înregistrează plata",
                ADD_TITLE: "Adaugă plată încasată",
                APPLICATION: "Cererea {number}",
                PAYMENT_REQUEST: "Cerere de plată",
                REQUEST_LINK: "Link trimis la {email}",
                REQUEST_CARD: "Plată cu cardul",
                AMOUNT_DUE: "Sumă de plată",
                APPLICATION_TOTAL: "Total cerere",
                COLLECTED_SO_FAR: "Încasat până acum",
                METHOD: "Modalitate de plată",
                PAID_AT: "Data plății",
                DOCUMENT_NUMBER: {
                    TRANSFER: "Nr. ordin de plată",
                    CASH: "Nr. chitanță",
                    POS: "Nr. bon POS",
                    OTHER: "Nr. document",
                },
                OPTIONAL: "opțional",
                METHOD_DESCRIPTION: "Descrie modalitatea",
                AMOUNT: "Sumă încasată",
                DESCRIPTION: "Detalii",
                DESCRIPTION_DEFAULT: "Taxe",
                PAYER: "Plătitor",
                PROOF: "Dovada plății",
                NOTE: "Observații",
                SUBMIT_RECORD: "Înregistrează plata",
                SUBMIT_ADD: "Adaugă plata",
                PAID_AT_FUTURE: "Data plății nu poate fi în viitor.",
                AMOUNT_INVALID: "Suma trebuie să fie mai mare decât zero, cu cel mult două zecimale.",
                NOTE_TOO_LONG: "Cel mult {max} de caractere.",
                PENDING_WARNING: "Această cerere are o plată de {amount} în așteptare, din {date}. Dacă plata pe care o adaugi este chiar aceea, renunță și folosește „Înregistrează plata” pe rândul ei.",
                PENDING_WARNING_MANY: "Această cerere are mai multe plăți în așteptare: {payments}. Dacă plata pe care o adaugi este una dintre ele, renunță și folosește „Înregistrează plata” pe rândul ei.",
                PENDING_ITEM: "{amount} din {date}",
                CONFIRM_RECORD: "Înregistrezi plata de {amount} prin {method} pentru cererea {application}?",
                CONFIRM_ADD: "Adaugi o plată încasată de {amount}, {method}, pentru cererea {application}?",
                RECORDED: "Plata a fost înregistrată.",
                ADDED: "Plata a fost adăugată.",
                PROOF_UPLOAD_FAILED: "Fișierul nu a putut fi încărcat. Nimic nu a fost salvat. Încearcă din nou sau elimină fișierul.",
            },
            HISTORY: {
                TITLE: "Istoric plată",
                EMPTY: "Nu există istoric pentru această plată.",
                ACTORS: {
                    BANK: "Banca",
                    SYSTEM: "Sistem",
                    CITIZEN: "Solicitant",
                    STAFF: "Funcționar",
                },
                EVENTS: {
                    LINK_SENT: "Link de plată trimis",
                    CARD_STARTED: "Plată cu cardul pornită",
                    PAID_ONLINE: "Plătită online",
                    FAILED_AT_BANK: "Eșuată la bancă",
                    EXEMPTION: "Scutire de plată",
                    RECORDED: "Plată înregistrată manual",
                    ADDED: "Plată adăugată",
                    BANK_CHECKED: "Verificată la bancă",
                },
                DETAILS: {
                    EXEMPTION: "cererea nu are taxe de achitat",
                },
                BANK_RESULTS: {
                    CONFIRMED: "Banca a confirmat plata.",
                    NOT_PAID: "Banca nu a înregistrat nicio plată.",
                    EXPIRED: "Plata nu a fost făcută. Comanda a expirat la bancă.",
                    DECLINED: "Plata nu a fost făcută. Banca a refuzat-o sau încercările s-au epuizat.",
                    REFUNDED: "Banca raportează că suma a fost returnată plătitorului.",
                    UNAVAILABLE: "Banca nu a răspuns.",
                    ALREADY_PROCESSED: "Plata era deja procesată.",
                },
            },
            CHECK: {
                CONFIRMED_TITLE: "Banca confirmă plata",
                CONFIRMED_TEXT: "Plata de {amount} a fost marcată „Procesată”, iar cererea apare achitată.",
                NOT_PAID_TITLE: "Banca nu a înregistrat nicio plată",
                NOT_PAID_TEXT: "Nu s-a modificat nimic.",
                NOT_PAID_TEXT_LINK: "Linkul este valabil până la {date}. Nu s-a modificat nimic.",
                NOT_PAID_TEXT_LINK_EXPIRED: "Linkul a expirat la {date}. Nu s-a modificat nimic.",
                EXPIRED_TITLE: "Plata nu a fost făcută",
                EXPIRED_TEXT: "Comanda a expirat la bancă. Poți înregistra plata, dacă a fost făcută altfel.",
                EXPIRED_TEXT_LINK: "Linkul a expirat la bancă. Poți trimite un link nou sau poți înregistra plata, dacă a fost făcută altfel.",
                DECLINED_TITLE: "Plata nu a fost făcută",
                DECLINED_TEXT: "Banca a refuzat plata sau încercările s-au epuizat. Poți înregistra plata, dacă a fost făcută altfel.",
                DECLINED_TEXT_LINK: "Banca a refuzat plata sau încercările s-au epuizat. Poți trimite un link nou sau poți înregistra plata, dacă a fost făcută altfel.",
                REFUNDED_TITLE: "Suma a fost returnată",
                REFUNDED_TEXT: "Banca raportează că suma a fost plătită și apoi returnată plătitorului. Nu s-a modificat nimic.",
                UNAVAILABLE_TITLE: "Banca nu a răspuns",
                UNAVAILABLE_TEXT: "Încearcă din nou peste câteva minute. Nu s-a modificat nimic.",
                ALREADY_PROCESSED_TITLE: "Plata este deja procesată",
                ALREADY_PROCESSED_TEXT: "Cererea a fost adusă la zi.",
            },
            BANNER: {
                TEXT: "Starea de plată a cererii nu corespunde plăților din listă.",
                BUTTON: "Actualizează cererea",
                DONE: "Cererea a fost actualizată.",
                UP_TO_DATE: "Cererea este deja la zi cu plățile.",
            },
        },
        DISCOUNTS: {
            TITLE: "Alege o scutire de plată",
            NO_DISCOUNT: "Nici o scutire",
            HELP_TEXT: "Pentru depunerea cererii online se poate aplica o scutire de la plata taxelor conform codului fiscal și legilor aflate în vigoare.",
            DESCRIPTION_HEADER: "Scutirea se aplică doar pentru:",
            DESCRIPTION_WARNING: "Pentru aplicarea cu succes a scutirii cererea trebuie să fie însoțită de acte doveditoare atașate ca și anexe la această cerere.",
        },
        MODALS: {
            ADD: "Adaugă",
            CANCEL: "Renunță",
            SAVE: "Salvează",
            SIGN_STATUS: {
                TITLE: "Status semnare",
                IDENTIFICATION_NUMBER: "Cod de intrare",
                LOCALITY: "Municipiu/Oraș/Comună",
                SIGNING_BY: "În curs de semnare la:",
                LAST_SIGNING_DATE: "Data ultimei semnări",
                CITIZEN_SIGNING: "Cetățean",
                LAST_SIGNING_DATE_CITIZEN: "Data semnare cetățean",
            },
            COMMENT_TITLES: {
                APPROVE: "Aprobat de către: {userName}, comentariu: {comment}",
                REJECT: "Respins de către: {userName}, motiv: {comment}",
                RETURN: "Regenerat de către: {userName}, motiv: {comment}",
                REJECT_VIZA: "Respinsă de către: {userName}. ",
            },
        },
        SIGNATURE: {
            TITLE: "Alege modalitatea de semnare",
            SECTION_TITLE: "Semnează cererile și anexele",
            TABS: {
                ONLINE: "Semnare online",
                OFFLINE: "Semnare offline",
            },
            ONLINE: {
                HELP_TEXT: "Pentru depunerea cererii online aceasta va fi semnată digital prin semnătură digitală. Procesul de semnare se poate face de la distanță, iar pentru aceasta aveți nevoie de o semnătură digitală.",
                INFO_TEXT: "Pentru a intermedia achiziționarea certificatului digital pentru semnături de la certSIGN, vom folosi datele de identificare din contul tău. Le vei furniza o singură dată, iar pe baza lor va fi creat un cod unic de identificare care va garanta autenticitatea solicitărilor tale.",
                PACKAGE_LABEL: "Costul acestora va fi inclus în total.",
                SUMMARY_DIGITAL_SIGNATURE_LABEL: "Semnături digitale",
                SUMMARY_REQUIRED_SIGNATURES: "Necesare",
                SUMMARY_AVAILABLE_SIGNATURES: "Disponibile",
                SUMMARY_LEFTOVER_SIGNATURES: "Vor rămane",
                SUMMARY_TEXT: "Semnătură electronică la distanță",
            },
            OFFLINE: {
                HELP_TEXT: "Alege \"SEMNARE ONLINE\" dacă dorești să achiziționezi un certificat pentru semnăturile digitale necesare, sau \"SEMNARE OFFLINE\" dacă deții deja unul de la un furnizor autorizat.",
                INFO_TEXT: "Descarcă documentul pe dispozitivul tău, semnează-l și încarcă documentul pentru a continua. Nota bene: este nevoie de semnătură digitală validată cu certificat calificat, nu electronică (sau olografă).",
                ACTION_DOWNLOAD_TITLE: "Descarcă cererea",
                ACTION_DOWNLOAD_SUBTITLE: "care trebuie semnată digital",
                ACTION_UPLOAD_TITLE: "Încarcă cererea",
                ACTION_UPLOAD_SUBTITLE: "care trebuie semnată digital",
                STEP_DOWNLOAD: "Descarcă",
                STEP_SIGN: "Semnează",
                STEP_VERIFY: "Verificare",
                STEP_CHECKED: "Documente ok",
                SUMMARY_TEXT: "Semnătură electronică personală",
                UPLOAD_NOTIFICATION: "O dată cu încărcarea documentelor semnate, cererea nu va mai putea fi modificată. Ești sigur ca vrei să continui?",
            },
            OFFICE: {
                SUMMARY_TEXT: "Semnătură olografă",
            },
        },
        CLARIFICATION_MODAL: {
            TITLE: "Trimitere răspuns",
        },
        SEND_REVIEW_MODAL: {
            TITLE: "Trimitere clarificări",
        },
        SUMMARY: {
            SIGN_TYPE_TITLE: "Modalitate de semnare",
            APPLICATION_DETAIL_TITLE: "Detalii cerere",
            PAYMENT_TYPE_TITLE: "Modalitate de plată",
            SIGN_TYPE_FOOTER: "Asigurat prin CertSign",
            APPLICATION_OBJECTIVE: "Obiectivul cererii",
            APPLICANT: "Solicitant",
            PAYMENT_TYPE: "Card online",
            PAYMENT_TYPE_OP: "Ordin de plată",
            PAYMENT_TYPE_LINK: "Link de plată",
            FILE_NAME: "Ordin de plată",
            PAYMENT_TYPE_HELP_TEXT: "După inițierea plății, vei fi redirecționat către procesatorul de plăți pentru a efectua plata.",
            PAYMENT_TYPE_HELP_TEXT_FAILED: "Plata nu a putut fi efectuată.",
            PAYMENT_TYPE_HELP_TEXT_SUCCESS: "Plata a fost efectuată cu succes.",
            PAYMENT_TYPE_LINK_HELP_TEXT_SUCCESS: "Linkul de plată a fost trimis cu succes.",
            PAYMENT_TYPE_LINK_HELP_TEXT: "Pe emailul specificat se va trimite un link de plată care va redirecționa beneficiarul către procesatorul de plăți pentru a efectua plata.",
            PAYMENT_TYPE_HELP_OP_TEXT_SUCCESS: "Ordinul de plată a fost încărcat cu succes.",
            PAYMENT_DISCOUNT: "Scutire plată",
            PAYMENT_DISCOUNT_TEXT: "Sunteți scutit de la plată. După confirmare, veți fi redirecționat către pagina cererii.",
            PAYMENT_DISCOUNT_TEXT_SUCCESS: "Scutirea de plată a fost înregistrată.",
            PAYMENT_NO_FEES: "Fără taxe",
            PAYMENT_NO_FEES_TEXT: "Cererea nu are taxe de achitat. După confirmare, veți fi redirecționat către pagina cererii.",
            PAYMENT_NO_FEES_TEXT_SUCCESS: "Cererea nu a avut taxe de achitat.",
            DETAILS: "Desfășurător",
            CERTIFICATE_TOTAL_TAXES: "Total costuri certificate digitale",
            TOTAL_TAXES: "Total taxe și avize",
            SECTION_TITLE: "Revizuiește și trimite cererea",
            TOTAL: "Total",
            SELECTED_REAL_ESTATES_TEXT: "nici un imobil ales | + 1 imobil ales | + {count} imobile alese",
            PAY_AS_YOU_GO_SUMMARY_TEXT: "Semnatură digitală",
            TAX_TEXT: "Taxă",
            DISCOUNT: "Scutire",
        },
        ENROLLMENT_DETAILS: {
            PERSON: {
                HEADER: "Tip persoană",
                INDIVIDUAL: "Persoană fizică",
                LEGAL: "Persoană juridică",
            },
            CITIZENSHIP: {
                HEADER: "Cetățenie",
                ROMANIAN: "Cetățean romȃn",
                FOREIGNER: "Cetățean străin",
            },
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Adresă domiciliu",
            CONTACT: "Contact",
            ADDRESS_COUNTY: "Județul",
            ADDRESS_STREET: "Str.",
            ADDRESS_NUMBER: "nr.",
            ADDRESS_STAIRCASE: "scara",
            ADDRESS_APARTMENT: "ap.",
        },
        SEND_SUCCESS_TITLE: "Felicitări, solicitarea ta a fost trimisă fără a genera risipă de hârtie! Până acum am salvat <span>{treeNumbers}</span> de copaci.",
        SEND_SUCCESS_TEXT: "Cererea cu numarul <strong>{number}</strong> a fost înregistrată cu succes.</br> După ce o analizăm și verificăm, vei fi notificat (aici și prin email) în legatură cu rezolvarea acesteia.",
        PAYMENT_SUCCESS_TITLE: "Plata a fost înregistrată cu succes.",
        PAYMENT_FAILED_TITLE: "Plata nu a putut fi procesată.",
        PAYMENT_SUCCESS_TEXT: "Plata nu finalizează automat cererea. Continuă pentru semnarea și depunerea cererii.",
        PAYMENT_FAILED_TEXT: "Poți relua plata din cerere.",
        PAYMENT_FAILED_LINK_TEXT: "Contactează instituția pentru a primi un link nou de plată.",
        PAYMENT_STEP_PAY: "Plată",
        PAYMENT_STEP_SIGN: "Semnare",
        PAYMENT_STEP_SUBMIT: "Depunere",
        MISSING_PAYMENT_CALLBACK_PAYLOAD: "A apărut o eroare la procesarea plății, te rugăm încearcă din nou.",
        RESPONSE_MODAL: {
            APPROVE_APPLICATION_TITLE: "Notificare aprobare",
            REJECT_APPLICATION_TITLE: "Motiv respingere",
        },
        MODIFY_APPLICATION_TYPE_MODAL_TITLE: "Modifica tipologie Registratura",
        MODIFY_APPLICATION_TYPE_MODAL_LABEL: "Tipologie cerere",
        MODIFY_APPLICATION_TYPE_MODAL_PLACEHOLDER: "Selecteaza o noua tipologie",
        ASSIGN_MODAL_TITLE: "Asignare Cerere",
        ASSIGN_REVIEWER_MODAL_TITLE: "Alege consultant",
        APPROVE_REJECT_MODAL_TITLE: "Răspuns consultare",
        ASSIGN_SUCCESS: "Cererea a fost asignată la <strong>{name}</strong> cu succes!",
        ASSIGN_ERROR: "Cererea nu a putut fi asignata la <strong>{name}</strong>",
        ASSIGN_MULTIPLE_SUCCESS: "Cele {count} de cereri selectate au fost asignate la <strong>{name}</strong> cu success!",
        ASSIGN_MULTIPLE_ERROR: "Cele {count} de cereri selectate nu au putut fi asignate la <strong>{name}</strong>",
        SIGN_CONFIRMATION: {
            INVALID_PIN: "Codul nu este valid, vă rugăm reîncercați",
            PIN_EXPIRED: "Codul a expirat, vă rugăm reîncercați",
            SESSION_EXPIRED: "Sesiunea a expirat, vă rugăm reîncercați",
            ERROR: "A apărut o eroare, vă rugăm reîncercați",
            BULK_FAILED: "Următoarele cereri nu pot fi semnate {0}",
        },
        SIGN_AND_APPLY_LOADER: {
            TITLE: "Depunerea durează câteva momente",
            TEXT: "Te rugăm să aștepți, depunerea cererii este în progres și poate dura câteva minute, fără a genera risipă de hârtie și timp.",
        },
        UPLOAD_DOCUMENTS_MODAL: {
            TITLE: "Adaugă documente",
        },
        CREATE_PAYMENT_MODAL: {
            TITLE: "Creează plată",
            BUTTON: "Trimite",
        },
        DELETE_CONFIRMATION: "Ești sigur că dorești să ștergi acest document?",
        INFO_TEXT: {
            FIRST_CITIZEN_REVIEW_DATE: "Prima clarificare primită",
            LAST_CITIZEN_REVIEW_DATE: "Ultima clarificare primită",
            FIRST_STAFF_REVIEW_DATE: "Prima clarificare trimisă",
            LAST_STAFF_REVIEW_DATE: "Ultima clarificare trimisă",
        },
        COPY_FILE_MODAL: {
            TITLE: "Setează nume fișier",
        },
        BULK_COPY_FILE_MODAL: {
            TITLE: "Selectează fișierele copiate",
            CONFIRM_MSG: "Sunteti sigur ca vreti sa copiati toate fisierele?",
        },
        DYNAMIC_FORMS: {
            GENERATE_BUTTON: "Generează",
            CONFIGURE_POSITIONS: "Zonă de stabilire a semnăturilor",
            CONFIGURE_POSITIONS_DESCRIPTIONS: "Zonă dedicată configurării semnăturilor care vor aparea pe documentul final și a ordinii de semnare. </br> Acest proces digitalizat înlocuiește mapa clasică de semnături utilizată în format fizic.",
            NUMBER_OF_ROWS: "Rânduri",
            NUMBER_OF_COLUMNS: "Coloane",
            SIGN_TEXT_PREFIX: "Semnatură",
            SIGN_TEXT_ASSIGNED_STAFF: "Funcționar alocat",
            ADD_SIGNATURE: "Alege semnatar",
            SELECT_SIGNATURE: "Caută semnatură",
            SAVE_CHANGES: "Salvează modificările",
            SAVE_AS_NEW_TEMPLATE: "Salvează ca șablon nou",
            TEMPLATE_NAME: "Nume șablon",
            TEMPLATE_INFO_TEXT: "Selectați un șablon predefinit anterior sau introduceți un nume nou",
            TEMPLATE_PLACEHOLDER: "Alege șablon",
            OVERWRITE_WARNING: "Salvarea modificărilor va suprascrie șablonul selectat. Dorești să continui?",
            SELECT_AT_LEAST_ONE_TEMPLATE: "Selectează un șablon pentru care dorești să salvezi modificarile",
            CONFIGURE_AT_LEAST_ONE_SIGNATURE: "Configurează cel puțin o semnatură pentru a putea salva modificarile",
            NO_TEXT_IN_DOCUMENT: "Vă rugăm să introduceți text în document înainte de generare",
            SIGNATURES_LOST: "Modificarea configurației rândurilor sau a coloanelor va duce la pierderea semnaturilor deja configurate. Dorești sa continui?",
            DOCUMENT_DETAILS_TITLE: "Detalii document",
            DOCUMENT_DETAILS_DESCRIPTION: "Zonă dedicată conținutului documentului",
            SELECT_TEMPLATE_DESCRIPTION: "Alege un șablon predefinit pentru a încărca conținutul și semnatarii",
            INFO_TITLE: "Instrucțiuni privind configurarea semnăturilor pe formularele electronice - Ghișeul Unic",
            INFO_DESCRIPTION: "<div style='text-align: left'>În partea dreaptă a interfeței aplicației se află secțiunea destinată <b>configurării semnăturilor</b> care vor fi aplicate pe documentul generat. </br></br> <b>Ordinea de semnare (fluxul de aprobare)</b> </br> </br> <li>Indexul de semnare atribuit fiecărei persoane determină ordinea în care semnăturile sunt aplicate pe document.</li> <li>Exemplu: <ul style='margin-top: 8px'>Persoana cu index <b>1</b> va semna prima.</ul><ul>Persoana cu index <b>2</b> va semna a doua, etc.</ul></li><li>Acest index poate fi modificat manual în configurator, după adăugarea semnăturilor.</li> </br> <b>Ordinea de afișare în document (poziția vizuală)</b> </br> </br> <li><b>Poziționarea semnăturilor în pagină</b> este dată de <b>ordinea în care acestea apar în lista din configurator</b>, indiferent de index.</li> <li>Această ordine determină aranjarea semnăturilor în coloană sau pe rânduri, în funcție de formatul ales.</li> </br> <b>Regula obligatorie: Poziția Președintelui</b> </br> </br> <li>Președintele trebuie să fie întotdeauna primul în listă, adică prima semnătură afișată vizual pe document, în partea de sus sau în stânga (în funcție de layout).</li><li>Această poziție NU este influențată de indexul de semnare.</li><li>Chiar dacă Președintele semnează ultimul, el trebuie să apară primul în lista de semnături afișată.</li></div>",
            GENERATE_SUCCESS: "Generarea s-a realizat cu success",
            SAVE_DRAFT_SUCCESS: "Draftul a fost salvat",
            TEMPLATE_SUCCESS: "Sablonul a fost salvat",
            SAVING_DOCUMENT: "Documentul se generează, nu reîncărcați pagina.",
            PRESIDENT_POSITION_WARNING: "Semnătura Președintelui trebuie să fie pe prima linie",
            MAX_ROWS_COLS_MESSAGE: "Vă rugăm să configurați minim 1 și maxim 7 rânduri",
            GENERIC_ERROR_MESSAGE: "A apărut o eroare. Vă rugăm să încercați din nou.",
            NO_SIGNATURES: "Documentul nu are nicio semnătură atașată. Vă rugăm să adăugați cel puțin o semnătură.",
            PRESIDENT_SIGNATURE_WARNING: "Semnătura Președintelui trebuie adăugată pe prima linie (sus), iar acesta trebuie să semneze ultimul, având cel mai mare index în ordinea de semnare.",
        },
        CLARIFICATIONS: {
            NO_CLARIFICATIONS: "Nu există clarificări pentru această cerere",
            NO_SCHEMA: "Schema formularului nu este disponibilă",
            STAFF_REQUEST: "Cerere de clarificări",
            CITIZEN_RESPONSE: "Răspuns cetățean",
            NO_CITIZEN_RESPONSE: "Cetățeanul nu a răspuns încă la această solicitare de clarificări",
        },
        FILTERS: {
            PROJECT_ID_ADD: "Adaugă",
            PROJECT_ID_INVALID: "Caractere invalide pentru filtrul: ",
            PROJECT_ID_DUPLICATE: "Acest filtru este duplicat",
        },
    },
    ARCHIVE: {
        BUTTONS: {
            MANUAL_ARCHIVE: "Arhivare manuală",
            ADD_WORKSPACE: "Adaugă workspace",
            DOWNLOAD: "Descarcă",
        },
        MENU: {
            DASHBOARD: "Dashboard",
            DOCUMENTS: "Documente",
            ADMINISTRATION: "Administrare",
        },
        WORKSPACE: {
            LIST: {
                TITLE: "Workspaces",
            },
            FIELDS: {
                NAME: "Denumire",
                ENTITY_TYPE: "Tip",
                CREATED_DATE: "Arhivare",
                DIMENSION: "Dimensiune",
                FOLDERS_NUMBER: "Nr foldere",
                DESCRIPTION: "Descriere",
            },
            PLACEHOLDERS: {
                NAME: "Denumire",
                ENTITY_TYPE: "Tip",
                CREATED_DATE: "Arhivare",
            },
            FORM: {
                EDIT_TITLE: "Editează workspace",
                ADD_TITLE: "Adaugă workspace",
            },
        },
        SUBFOLDER: {
            LIST: {
                TITLE: "Documente",
            },
            FIELDS: {
                NAME: "Denumire",
                TYPE: "Tip",
                CREATED_DATE: "Arhivare",
                DIMENSION: "Dimensiune",
                DOCUMENT_NUMBER: "Nr Documente",
                WORKSPACE: "Workspace",
                DESCRIPTION: "Descriere",
                DOCUMENT_TYPE_CODE: "Tip document",
            },
            PLACEHOLDERS: {
                NAME: "Denumire",
                ACHIVE_DATE: "Arhivare",
            },
            ACTIONS: {
                EDIT: "Modifică Folder",
                ADD: "Adaugă Folder",
            },
            FORM: {
                WORKSPACE: "Workspace",
                TYPE: "Tip Document corelat",
                NAME: "Denumire Folder",
            },
        },
        DOCUMENTS: {
            LIST: {
                TITLE: "Documente",
            },
            FIELDS: {
                DOCUMENT_NAME: "Denumire",
                DOCUMENT_TYPE_NAME: "Tip",
                DOCUMENT_SIZE: "Dimensiune",
                CREATED_DATE: "Data creării",
                UPDATED_DATE: "Data modificării",
            },
            PLACEHOLDERS: {
                NAME: "Denumire",
                ACHIVE_DATE: "Arhivare",
            },
            ACTIONS: {
                EDIT: "Modifică Folder",
                ADD: "Adaugă Folder",
            },
        },
        DOCUMENT: {
            TITLE_MANUAL_ARCHIVE: "Arhivare manuală",
            TITLE_VIEW_ARCHIVE: "Vizualizare arhivă",
            HEADERS: {
                ATTACHMENTS: "Atașamente",
                DETAILS: "Detalii",
                METADATA: "Metadate",
            },
            FIELDS: {
                WORKSPACE: "Workspace",
                DOCUMENT_NAME: "Nume Document",
                DOCUMENT_FOLDER: "Folder",
                DOCUMENT_TYPE: "Tip document",
            },
        },
        CONFIRMATION_TEXT: "Pentru consistența datelor va rugam sa verificați ca acestea sunt valide si conforme cu documentele arhivate. Pentru orice modificari ulterioare va rugam sa contactati un administrator al sistemului. Sunteti sigur ca doriti sa salvati documentul?",
        MESSAGES: {
            SUCCESS: "Arhivare manuală realizată cu succes!",
            ERRORS: "Eroare la arhivarea manuală!",
        },
        ATTACHMENTS: {
            PLACEHOLDER: "fișiere selectate",
            EMPTY: "Nu există documente atașate.",
            EMPTY_WARNING: "Pentru a salva, arhiva trebuie sa conțină fișiere atașate.",
            LABEL: "Fișier",
            ADD_BUTTON: "Adaugă atașament",
        },
        REPORTS: {
            WORKSPACE_LABEL: "Workspace",
            WORKSPACE_DIMENSION: {
                TITLE: "Total spațiu arhivat",
                DESCRIPTION: "Raport workspace",
            },
            EXPIRATION: {
                TITLE: "Termen expirare",
                DESCRIPTION: "Documentele ce urmează să expire",
                MONTHLY: "Luna aceasta",
                WEEKLY: "Săptămâna aceasta",
            },
            WORKSPACE_DOCUMENTS: {
                TITLE: "Total număr documente arhivate",
                DESCRIPTION: "Raport workspace",
            },
            WORKSPACE_FOLDERS_DIMENSION: {
                TITLE: "Total dimensiune documente arhivate per workspace",
                CHART_LABELS_TITLE: "Listă foldere",
                DESCRIPTION: "Raport foldere din workspace",
            },
            WORKSPACE_FOLDERS_DOCUMENTS: {
                TITLE: "Total număr documente arhivate per workspace",
                CHART_LABELS_TITLE: "Listă foldere",
                DESCRIPTION: "Raport foldere din workspace",
            },
            WORKSPACE_PROGRESS_ANNUAL: {
                TITLE_DOC: "Progres de arhivare {period} - documente",
                TITLE_DIMENSION: "Progres de arhivare {period} - dimensiune",
                TITLE_DESCRIPTION_DOC: "Fișiere arhivate",
                TITLE_DESCRIPTION_DIMENSION: "Dimensiune fișiere arhivate",
                TOTAL_DESCRIPTION_DOC: "Documente în perioada selectată",
                TOTAL_DESCRIPTION_DIMENSION: "Dimensiune în perioada selectată",
                CHART_TITLE: "Analiză",
                Y_AXIS_DOC: "Documente",
                Y_AXIS_DIMENSION: "Dimensiune",
            },
        },
        PERIOD: {
            ANNUALY: "anual",
            MONTHLY: "lunar",
            WEEKLY: "săptămânal",
        },
    },
    FORMS: {
        LIST: {
            TITLE: "Interfețe formulare",
            ADD_BUTTON: "Adaugă formular",
            TABLE_HEADER: "Modele interfețe formulare",
        },
        FIELDS: {
            NAME: "Denumire",
            STATUS: "Stare",
            DESCRIPTION: "Descriere",
            TRANSLATABLE: "Se traduce automat (HU, EN)",
        },
        BUTTONS: {
            ADD: "Adaugă",
            DELETE: "Șterge",
        },
        PLACEHOLDERS: {
            NAME: "Nume",
            STATUS: "Stare",
        },
        ENUMS: {
            STATUS: {
                DRAFT: "Draft",
                PUBLISHED: "Public",
            },
        },
        CREATE_MODAL: {
            TITLE: "Salvare interfață formular",
        },
        COMPONENTS: {
            FIELDS: {
                input: "Câmp text",
                textarea: "Zonă text",
                number: "Număr",
                radio: "Radio",
                checkbox: "Bifă",
                time: "Oră",
                date: "Dată",
                rate: "Evaluare",
                color: "Culoare",
                select: "Selecție",
                switch: "Comutator",
                slider: "Cursor",
                text: "Text",
                blank: "Personalizat",
                fileupload: "Fișier",
                imgupload: "Imagine",
                editor: "Editor",
                cascader: "Cascadă",
                table: "Sub-tabel",
                grid: "Grilă",
                section: "Secțiune",
                inline: "Inline",
                tabs: "Tab-uri",
                divider: "Separator",
                file: "Fișier",
                html: "HTML",
                "beneficiary-list": "Beneficiar",
                "applicant-form": "Solicitant",
                "application-detail-form": "Detalii cerere",
                "real-estate-list": "Imobil",
                "decision-list": "Hotărâri",
                attachments: "Atașamente",
                "urbanism-regulation-picker": "Reglementări",
                "related-application": "Documente de legătură",
                "offender-list": "Contravenient",
                "witness-list": "Martor",
                "realty-list": "Detalii construcție",
                "staff-form": "Detalii funcționar",
                "gis-attachments": "Anexe GIS",
                "ac-tax-validator": "Valoare minima investitie",
                richtexteditor: "Editor HTML",
                "locality-list": "Detalii amplasamente",
                "buildings-list": "Corpuri",
                "urbanism-regulations-list": "Detalii RLU",
                "gis-intersections": "Intersecții GIS",
                "document-expiry": "Valabilitate document",
                "document-extension": "Prelungire document",
                "repeatable-grid": "Repetă tabel",
            },
            BASIC: {
                TITLE: "Componente de bază",
            },
            ADVANCE: {
                TITLE: "Componente avansate",
            },
            LAYOUT: {
                TITLE: "Aranjare (Layout)",
            },
            CUSTOM: {
                TITLE: "Componente personalizate",
            },
        },
        DESCRIPTION: {
            CONTAINER_EMPTY: "Trageți și plasați elementul din stânga pentru a adăuga componente",
            CONFIG_EMPTY: "Vă rugăm să adăugați o componentă",
            TABLE_EMPTY: "Trageți și plasați elementul din stânga pentru a adăuga componente",
            UPLOAD_JSON_INFO: "Mai jos este formatul JSON, puteți să-l înlocuiți cu propriul cod JSON",
        },
        MESSAGE: {
            COPY_SUCCESS: "Copiat cu succes",
            COPY_FAILED: "Copierea a eșuat",
            VALID_JSON: "JSON valid",
            INVALID_JSON: "JSON invalid",
            VALID_ERROR: "Vă rugăm să completați toate câmpurile obligatorii.",
            UPLOAD_MAX_FILES: "Numărul de fișiere încărcate este {max}",
        },
        PLACEHOLDER: {
            PASTE_JSON: "Inserați JSON...",
        },
        ACTIONS: {
            IMPORT: "Importă JSON",
            CLEAR: "Șterge",
            PREVIEW: "Previzualizare",
            JSON: "Generează JSON",
            CODE: "Generează cod",
            GET_DATA: "Obține date",
            RESET: "Resetează",
            COPY_DATA: "Copiază date",
            CANCEL: "Anulează",
            CONFIRM: "Confirmă",
            ADD_OPTION: "Adaugă opțiune",
            ADD_COLUMN: "Adaugă coloană",
            ADD_TAB: "Adaugă tab",
            UPLOAD: "Încarcă",
            ADD: "Adaugă",
        },
        CONFIG: {
            FORM: {
                TITLE: "Atribute formular",
            },
            WIDGET: {
                TITLE: "Atribute componentă",
                MODEL: "ID",
                NAME: "Nume",
                ALIAS: "Alias",
                META: "Meta",
                WIDTH: "Lățime",
                HEIGHT: "Înălțime",
                SIZE: "Dimensiune",
                LABEL_WIDTH: "Lățime etichetă",
                CUSTOM: "Personalizat",
                PLACEHOLDER: "Placeholder",
                LAYOUT: "Aranjare (Layout)",
                BLOCK: "Bloc",
                INLINE: "În linie",
                CONTENT_POSITION: "Poziție conținut",
                LEFT: "Stânga",
                RIGHT: "Dreapta",
                CENTER: "Centru",
                SHOW_INPUT: "Afișează câmp de intrare",
                MIN: "Minim",
                MAX: "Maxim",
                STEP: "Pas",
                MULTIPLE: "Selecție multiplă",
                FILTERABLE: "Căutabil",
                ALLOW_HALF: "Permite jumătate",
                SHOW_ALPHA: "Suportă opțiuni de transparență",
                SHOW_LABEL: "Afișează etichetă",
                OPTION: "Opțiune",
                STATIC_DATA: "Date statice",
                REMOTE_DATA: "Date la distanță",
                REMOTE_FUNC: "Funcție la distanță",
                VALUE: "Valoare",
                LABEL: "Etichetă",
                OPTION_LABEL_HELP: "Valoarea se salvează în cerere și se folosește în condiții. Eticheta este textul pe care îl vede cetățeanul și care se traduce.",
                CHILDREN_OPTION: "Sub-opțiune",
                DEFAULT_VALUE: "Valoare implicită",
                LIMIT: "Număr maxim de încărcări",
                IMAGE_ACTION: "Adresă încărcare imagine",
                TIP: "Text informativ",
                ACTION: "Adresă încărcare",
                DEFAULT_TYPE: "Tip de date",
                STRING: "Text",
                OBJECT: "Obiect",
                ARRAY: "Matrice",
                NUMBER: "Număr",
                BOOLEAN: "Boolean",
                INTEGER: "Întreg",
                FLOAT: "Zecimal",
                URL: "URL",
                EMAIL: "E-mail",
                HEX: "Hexazecimal",
                GUTTER: "Spațiere grilă",
                COLUMN_OPTION: "Configurare coloane",
                SPAN: "Întindere grilă",
                JUSTIFY: "Aliniere orizontală",
                JUSTIFY_START: "Început",
                JUSTIFY_END: "Sfârșit",
                JUSTIFY_CENTER: "Centru",
                JUSTIFY_SPACE_AROUND: "Spațiu în jur",
                JUSTIFY_SPACE_BETWEEN: "Spațiu între",
                ALIGN: "Aliniere verticală",
                ALIGN_TOP: "Sus",
                ALIGN_MIDDLE: "Mijloc",
                ALIGN_BOTTOM: "Jos",
                TYPE: "Tip",
                DEFAULT: "Implicit",
                CARD: "Tab-uri",
                BORDER_CARD: "Card cu margine",
                TAB_POSITION: "Poziție tab",
                TOP: "Sus",
                BOTTOM: "Jos",
                TAB_OPTION: "Configurare etichetă",
                TAB_NAME: "Nume tab",
                CUSTOM_CLASS: "Clasă personalizată",
                ATTRIBUTE: "Acțiune atribut",
                DATA_BIND: "Legare date",
                HIDDEN: "Ascuns",
                READONLY: "Doar citire",
                DISABLE: "Dezactivat",
                CALCULATOR: "Calculator",
                PRESELECTION: "Preselectare",
                CONVERT_NUMBER_TO_TEXT: "Convertește număr în text",
                CONVERT_NUMBER_TO_TEXT_FROM_FIELD: "Convertește număr în text din câmpul:",
                SUM_NUMBERS: "Sumă numere",
                SUM_NUMBERS_FROM_FIELDS: "Sumă numere din câmpurile:",
                MULTIPLY_NUMBERS: "Înmulțire numere",
                MULTIPLY_NUMBERS_FROM_FIELDS: "Înmulțire numere din câmpurile:",
                SUM_MONTHS: "Sumă luni",
                SUM_MONTHS_FROM_FIELDS: "Sumă luni din câmpurile:",
                DIFF_MONTHS: "Diferență luni",
                DIFF_MONTHS_FROM_FIELDS: "Diferență luni din câmpurile:",
                DIFF_DAYS: "Diferență zile",
                DIFF_DAYS_FROM_FIELDS: "Diferență zile din câmpurile:",
                PERCENTAGE_VALUE: "Valoare procentuală",
                PERCENTAGE_VALUE_FROM_FIELDS: "Valoare procentuală din câmpurile:",
                EDITABLE: "Câmpul text este editabil",
                CLEARABLE: "Afișează buton de ștergere",
                ALLOW_CONTROL: "Folosește săgețile pentru selectarea timpului",
                IS_DELETE: "Poate fi șters",
                IS_EDIT: "Poate fi editat",
                SHOW_PASSWORD: "Afișează parola",
                VALIDATE: "Validare",
                REQUIRED: "Obligatoriu",
                CITIZEN_ID_CARD_VALIDATION: "CI obligatoriu (PF)",
                LEGAL_ENTITY_ID_CARD_VALIDATION: "CI obligatoriu (PJ)",
                LEGAL_ENTITY_BANK_DETAILS_VALIDATION: "Detalii bancare obligatorii (PJ)",
                PATTERN_PLACEHOLDER: "Completați expresia regulată",
                PATTERN_MESSAGE_PLACEHOLDER: "Mesaj de validare pentru expresia regulată",
                NEW_OPTION: "Opțiune nouă",
                TAB: "Tab",
                VALIDATOR_REQUIRED: "Obligatoriu",
                VALIDATOR_TYPE: "Format invalid",
                VALIDATOR_PATTERN: "Model nepotrivit",
                COLLAPSIBLE: "Colapsabil",
                COLLAPSED: "Colapsat (implicit)",
                SECTION_TITLE: "Titlu",
                IS_CONDITIONED: "Este condiționat",
                CONDITION: "Condiție",
                FONT_SIZE: "Dimensiune font",
                IS_BOLD: "Bold",
                HIDE_LABEL: "Ascunde eticheta",
                IS_SHARED: "Este partajat",
                SHOW_TOOLTIP: "Afișează tooltip",
                TOOLTIP_TEXT: "Text tooltip",
                ROWS: "Rânduri",
                MAX_ROWS: "Rânduri maxime",
                PLAINTEXT: "Doar citire",
                ACCEPTED_FILE_TYPES: "Tipuri de fișiere acceptate",
                MAX_FILE_SIZE: "Dimensiune maximă fișier până la {0} MB",
                FILE_SIZE: "Dimensiune fișier",
                FILE_TYPE: "Tip fișier",
                MAX_FILES: "Număr maxim de fișiere",
                ADVANCED_CONDITIONS: "Condiții avansate",
                CONDITION_EXPRESSION: "Expresie condiție",
                CONDITION_FIELD: "Câmp",
                CONDITION_OPERATION: "Operație",
                CONDITION_VALUE: "Valoare",
                AUTOCOMPLETE_FORM: "Autocompletare formular",
                LOAD_ALL_GUEST_APPLICATIONS: "Toate actele emise indiferent de depunator",
                LOAD_ALL_ORG_APPLICATIONS: "Toate actele emise indiferent de organizatie",
                LOAD_EXTERNAL_DOCUMENTS: "Incarcă rezervările de serie",
                FORCE_SHOW_DOCUMENT_UPLOAD_BTN: "Arată tot timpul butonul de upload",
                DOCUMENT_KEY: "Cheie document",
                CUSTOM_NOTFOUND_MESSAGE: "Mesaj de eroare personalizat",
                COEFFICIENTS: "Coeficienți",
                UAT: "UAT",
                VILLAGE: "Localitate",
                COEFF_VALUE: "Valoare coeficient",
                AC_TAX_CATEGORIES: "Taxa per sistem constructiv",
                AC_TAX_A: "Sistem constructiv A(beton)",
                AC_TAX_B: "Sistem constructiv B(lemn, piatra)",
                AC_TAX_C: "Sistem constructiv C(anexe)",
                AC_TAX_OTHER: "Altele",
                RU_SCOPE: "Scop Ru",
                UTR_PDF_DOCUMENT_TEMPLATE: "Formularul tipizat folosit la generearea PDFului din UTR",
                MIN_INSTANCES: "Instanțe minime",
                MAX_INSTANCES: "Instanțe maxime",
                OPERATION_EQUAL: "Egal",
                OPERATION_NOT_EQUAL: "Diferit",
                OPERATION_INCLUDES: "Conține",
                OPERATION_NOT_INCLUDES: "Nu conține",
                OPERATION_GREATER_THAN: "Mai mare decât",
                OPERATION_LESS_THAN: "Mai mic decât",
                OPERATION_GREATER_THAN_OR_EQUAL: "Mai mare sau egal",
                OPERATION_LESS_THAN_OR_EQUAL: "Mai mic sau egal",
                DEFAULT_OPTION: "Opțiunea {0}",
                DEFAULT_TEXT: "Acesta este un text",
                RU_SCOPE_OTHER: "Altele",
            },
        },
        UPLOAD: {
            PREVIEW: "previzualizare",
            EDIT: "înlocuiește",
            DELETE: "șterge",
        },
    },
    APPLICATION_TYPE: {
        LIST: {
            TITLE: "Tipologii registratură",
        },
        ADD_BUTTON: "Tipologie nouă",
        FIELDS: {
            NAME: "Denumire",
            STATUS: "Status",
            DESCRIPTION: "Descriere",
            FORM_CITIZEN: "Interfață formular cetățean",
            FORM_STAFF: "Interfață formular funcționar",
            REJECT_FORM_STAFF: "Interfață formular respingere funcționar",
            CLARIFICATION_FORM_CITIZEN: "Interfață formular clarificări cetățean",
            CLARIFICATION_FORM_STAFF: "Interfață formular clarificări funcționar",
            DOCUMENT_TEMPLATE: "Formular tipizat funcționar",
            REJECT_DOCUMENT_TEMPLATE: "Formular tipizat respingere funcționar",
            CLARIFICATION_DOCUMENT_TEMPLATE: "Formular tipizat clarificări funcționar",
            CLARIFICATION_DOCUMENT_TEMPLATE_CITIZEN: "Tipizat clarificări cetățean",
            REVIEW_DOCUMENT_TEMPLATE: "Formular tipizat clarificări cetățean",
            PUBLIC_DOCUMENT_TEMPLATE: "Formular tipizat document public",
            APPLICATION_DOCUMENT_TEMPLATE: "Formular tipizat cetățean",
            DOCUMENT_SERIES_TYPE: "Tip serie document ieșire",
            APPLICATION_DOCUMENT_SERIES_TYPE: "Tip serie document intrare",
            FIRST_VIZA_SERIES_TYPE: "Tip serie Viză CFP",
            SECOND_VIZA_SERIES_TYPE: "Tip serie Viză Legalitate",
            REJECTION_VIZA_SERIES_TYPE: "Tip serie respingere Viză",
            TAX_CATEGORY: "Categorie de taxare",
            CONSTRUCTION_TAX_CATEGORY: "Categorie de taxare 1 (metadata construction_value)",
            LAND_TAX_CATEGORY: "Categorie de taxare 2 (metadata land_value)",
            EXTRA_TAX_CATEGORY: "Categorie de taxare 3 (altă taxă aplicată pe valoare)",
            APPLICATION_TYPE_REF: "Documente referință",
            ARCHIVE_DOCUMENT_TYPE_CODE: "Tip document arhivă",
            WORKFLOW: "Proces",
            SUB_WORKFLOW: "Subproces",
            TENANT_ID: "Organizație",
            IS_AUTO: "Tipologie automată",
            REMAINING_PERIOD: "Timp rămas",
            ORDER: "Prioritate în listă (ordine)",
            DISCOUNTS: "Discount-uri disponibile",
            UATS: "UAT-uri disponibile",
            IS_INTERNAL: "Tipologie document",
            IS_INBOUND_CATEGORY: "Intrare",
            IS_INTERNAL_CATEGORY: "Intern",
            IS_OUTBOUND_CATEGORY: "Ieșire",
            IS_DYNAMIC_FORM: "Tipologie formular dinamic",
            HAS_DIGITAL_SEAL: "Aplică sigiliu CertSign pe actul emis",
            HAS_STS_DIGITAL_SEAL: "Aplică sigiliu STS pe actul emis",
            IS_GENERATING_PROJECT_ID: "Generează Project ID",
            DIGITAL_SEAL_CUSTOM_IMAGE_ID: "Adaugă o imagine suplimentară pentru sigiliu",
            REVIEW_APPLICATION_TYPE_ID: "Nota de clarificări aferentă",
            INTERNAL_APPLICATION_TYPE_ID: "Document intern aferent",
            DEPARTMENTS: "Departamente",
            FUNCTIONS: "Funcții",
            OPTION_APPLICATION: "Cerere",
            OPTION_DOCUMENT: "Document",
            USAGE_CATEGORIES: "Categorii de folosință",
            VISIBLE_FOR: "Vizibil pentru",
            DOMAIN: "Domenii",
            ENTIRE_ORGANIZATION: "Toată organizația",
            EXPIRY_NOTIFICATION_ENABLED: "Notificare expirare documente",
            DAYS_BEFORE_EXPIRY: "Perioadă de notificare(zile)",
            IS_EXPIRY_EXTENSION_TYPE: "Tip cerere de prelungire a expirării",
            IS_PCUEL_SYNCED: "Sincronizată în PCUEL",
            THIRD_PARTY_EMAILS: "Emailuri terți",
        },
        FORM: {
            EDIT_TITLE: "Editează tip cerere",
            ADD_TITLE: "Tip cerere nouă",
            USAGE_CATEGORY: "Categorie de folosință",
            MAX_FILE_SIZE: "Maxim 10MB (png, jpg, jpeg)",
            FILE_UPLOAD_INFO_MESSAGE: "Încarcă imaginea prin drag and drop sau prin click",
            FILE_UPLOAD_ERROR_INVALID: "Fișierul este invalid!",
            FILE_UPLOAD_ERROR_SIZE: "Fișierul este prea mare!",
            DEPARTMENTS_TREE: "Vizibil pentru (departamente, funcții, servicii, compartimente)",
            INVALID_EMAIL: "Email invalid",
            DUPLICATE_EMAIL: "Email deja adaugat",
            THIRD_PARTY_EMAILS_PLACEHOLDER: "Introdu email",
            THIRD_PARTY_EMAILS_ADD_BUTTON: "Adaugă",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
            DOMAIN: {
                URBANISM: "Urbanism",
                ADMINISTRATION: "Administrație",
                CITY_HALL: "Primării",
                APPROVALS: "Avizatori",
                ROADS: "Transport",
                ECONOMIC: "Economic",
                SUBORDINATION: "Subordonate",
                MAPS: "Hărți",
                INVESTMENTS: "Investiții",
                TOURISM: "Turism",
                EVENTS: "Închirieri",
            },
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
            STATUS: "Status",
            NO_REF_DOC: "Nici un document de referință",
            NO_DISCOUNTS: "Nici un discount",
            APPLY_DISCOUNT: "Aplică discount pentru UAT rural",
            IS_TAX_FIXED: "Taxă per cerere (fără amplasamente)",
            IS_TAX_CATEGORY_CONDITIONAL: "Taxă condiționată de valoare",
            NO_UATS: "Nici un UAT",
            DOMAIN: "Domeniu",
            VISIBLE_FOR_DEPARTMENT: "Departament",
            VISIBLE_FOR_SERVICE: "Serviciu",
            VISIBLE_FOR_COMPARTMENT: "Compartiment",
        },
        MESSAGES: {
            IS_AUTO: "O tipologie automată nu are documente de referință",
        },
    },
    DOCUMENT_TEMPLATE: {
        LIST: {
            TITLE: "Formulare tipizate",
            ADD_BUTTON: "Formular nou",
            TABLE_HEADER: "Modele formulare",
        },
        FIELDS: {
            NAME: "Denumire",
            DESCRIPTION: "Descriere",
            STATUS: "Stare",
            CREATED_DATE: "Data inserării",
            TYPE: "Formular tipizat de sistem",
        },
        PLACEHOLDERS: {
            STATUS: "Stare",
            NAME: "Nume",
            TYPE: "Formular tipizat de sistem",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
        },
        CREATE_MODAL: {
            TITLE: "Salvare formular tipizat",
        },
        EDIT_MODAL: {
            TITLE: "Editare formular tipizat",
        },
        FORM: {
            TITLE: "Template formular",
            DOWNLOAD_BUTTON: "Descarcă",
            FIELDS_LIST_TITLE: "Inserează câmpuri",
            FIELDS_PANE_COLLAPSE: "Ascunde câmpurile",
            FIELDS_PANE_EXPAND: "Afișează câmpurile",
            ORGANISATION_LABEL: "Selectează organizația",
            APPLICATION_TYPES_LABEL: "Selectează tipul de cerere",
            RELATED_APPLICATION_TYPES_LABEL: "Selectează tipul de cerere asociat",
            FORM_TYPE_LABEL: "Selectează tipul de formular",
            CITIZEN_LABEL: "Cetățean",
            STAFF_LABEL: "Funcționar",
            CITIZEN_CLARIFICATION_LABEL: "Clarificări cetățean",
            STAFF_CLARIFICATION_LABEL: "Clarificări funcționar",
            SELECT_TYPE: "Selectează tipologie",
            APPLICATION_TYPE: "Cerere",
            CONTROL_TYPE: "Control",
            FIELD_SEARCH_PLACEHOLDER: "Caută câmp...",
            NO_FIELDS_FOUND: "Niciun câmp găsit",
            SELECT_TYPE_TO_SEE_FIELDS: "Selectați o tipologie pentru a vedea câmpurile",
        },
    },
    PROCESS_EDITOR: {
        HEADER: "Management procese",
        NEW_PROCESS_BTN: "Proces nou",
        GENERAL: {
            HEADER: "Editor de proces",
            HEADER_LIST: "Listă Procese",
            TITLE: "Proces nou",
            SAVE_BTN: "Salvează",
            EDIT_BTN: "Modifică",
            FIELDS: {
                NAME: "Denumire",
                DESCRIPTION: "Descriere",
                STATUS: "Status",
                EXECUTION_SCOPE: "Scop",
            },
            PLACEHOLDERS: {
                NAME: "Caută după denumire",
                DESCRIPTION: "Descriere",
                EXECUTION_SCOPE: "Scop",
                MAIN: "Proces",
                SUBPROCESS: "Subproces",
            },
        },
        TABS: {
            GENERAL: "General",
            STEPS: "Etape",
        },
        STEPS: {
            HEADER: "Editor de proces",
            HEADER_LIST: "Etape create",
            EDIT_MODAL_HEADER: "Modifică etapă",
            ADD_MODAL_HEADER: "Adaugă etapă",
            ADD_BTN: "Adaugă etapă",
            SAVE_LIST_BTN: "Salvează etape",
            PUBLISH_BTN: "Publică",
            PUBLISH_MSG: "Etapa de start nu este prima in listă! Lista nu se poate publica.",
            PUBLISH_CONFIRM_MSG: "Sunteți sigur ca vreți să publicați acest proces? El va fi disponibil pentru a putea fi folosit",
            SHOW_GIS_INTERSECTION_SETTINGS_MODAL: "Setări intersecții GIS",
            EDIT_GIS_INTERSECTION_SETTINGS_MODAL_HEADER: "Modifică mapări metadate GIS pentru pasul \"{0}\"",
            ADD_GIS_INTERSECTION_SETTINGS_MODAL_HEADER: "Salvează setările metadate GIS pentru pasul \"{0}\"",
            EDIT_GIS_INTERSECTION_SETTINGS_VIEW_MODAL_HEADER: "Vizualizează setări",
            VIZA_SERIES_TYPE_FIRST_OPTION: "Viză CFP",
            VIZA_SERIES_TYPE_SECOND_OPTION: "Viză Juridic",
            FIELDS: {
                NAME: "Nume Etapă",
                ACTION_NAME: "Acțiune",
                ACTION_TYPE: "Tip acțiune",
                NEXT_STEP: "Etapa următoare",
                CONDITIONAL_ROUTING: "Rutare condiționată",
                FILE_STATUS: "Status fișier",
                FILE_TYPE: "Tip fișier",
                EXTRA_DOCUMENT_TEMPLATE_ID: "Formular tipizat",
                EXTRA_DOCUMENT_VISIBILITY: "Vizibilitate fisier generat",
                FUNCTION_TYPE: "Funcție",
                SIGN_BY_ASSIGNED_USER: "Semnare de către userul asignat",
                APPLICATION_STATUS: "Status cerere",
                RETURN_ACTION: "Revenire la",
                SIGN_WITH_VIZA: "Semnare cu Aplicare Viză",
                VIZA_SERIES_TYPE: "Tip serie viză",
                CLARIFICATION_STATUS: "Status clarificare",
            },
            PLACEHOLDERS: {
                NAME: "Nume",
                ACTION_NAME: "Actiune",
                ACTION_TYPE: "Tip acțiune",
                NEXT_STEP: "Etapa următoare",
                CONDITIONAL_ROUTING: "Rutare condiționată",
                FILE_STATUS: "Status fișier",
                FILE_TYPE: "Tip fișier",
                EXTRA_DOCUMENT_TEMPLATE_ID: "Formular tipizat",
                EXTRA_DOCUMENT_VISIBILITY: "Vizibilitate fisier generat",
                FUNCTION_TYPE: "Funcție",
                APPLICATION_STATUS: "Status cerere",
                CLARIFICATION_STATUS: "Status clarificare",
                VIZA_SERIES_TYPE: "Tip serie viză",
            },
            ACTIONS: {
                START: "Start",
                END: "Sfârșit",
            },
            GIS_INTERSECTIONS: {
                ADD_MAPPINGS: "Adaugă metadate",
                SAVE_MAPPINGS: "Salvează metadate",
                MAPPINGS_LIST_DESC: "Mapări existente",
                GIS_VALUE_LABEL: "Valoare GIS",
                GIS_VALUE_LABEL_EXTENDED: "Valoarea atributului GIS",
                FIELDS: {
                    TENANT_ID: "Organizație",
                    TENANT_NAME: "Organizație",
                    LAYER_ID: "Feature Layer GIS",
                    LAYER_NAME: "Feature Layer GIS",
                    SUBLAYER_ID: "SubLayer GIS",
                    SUBLAYER_NAME: "SubLayer GIS",
                    GIS_ATTRIBUTE_ID: "Atribut GIS",
                    GIS_ATTRIBUTE_NAME: "Nume Atribut GIS",
                    METADATA_NAME: "Nume metadată ghișeu",
                    INTERSECTION_TYPE: "Tip intersecție",
                    METADATA_COMPLETION_METHOD: "Mod completare metadată",
                    GIS_ATTRIBUTE_VALUE_OVERRIDE: "Valoare manuală",
                },
                PLACEHOLDERS: {
                    TENANT_ID: "Organizație",
                    TENANT_NAME: "Organizație",
                    LAYER_ID: "Feature Layer GIS",
                    LAYER_NAME: "Feature Layer GIS",
                    SUBLAYER_ID: "SubLayer GIS",
                    SUBLAYER_NAME: "SubLayer GIS",
                    GIS_ATTRIBUTE_ID: "Atribut GIS",
                    GIS_ATTRIBUTE_NAME: "Nume metadată atribut",
                    METADATA_NAME: "Nume metadată ghișeu",
                    INTERSECTION_TYPE: "Tip intersecție",
                    METADATA_COMPLETION_METHOD: "Mod completare metadată",
                    GIS_ATTRIBUTE_VALUE_OVERRIDE: "Valoare manuală",
                },
                ENUMS: {
                    INTERSECTION_TYPE: {
                        TOTAL: "Intersecție totală",
                        PARTIAL: "Intersecție parțială",
                        NONE: "Neintersectat",
                    },
                    METADATA_COMPLETION_METHOD: {
                        USE_GIS_VALUE: "Valoare actuală din GIS",
                        MANUAL: "Completare manuală",
                    },
                },
            },
            REAL_ESTATE_PLACEMENT: {
                SHOW_SETTINGS_MODAL: "Setări layere plan incadrare",
                EDIT_SETTINGS_MODAL_HEADER: "Modifică setări layere vizibile pentru plan incadrare pentru pasul \"{0}\"",
                ADD_SETTINGS_MODAL_HEADER: "Adaugă setări layere vizibile pentru plan incadrare pentru pasul \"{0}\"",
                ADD_LAYER: "Adaugă Layer",
                CONFIGURED_LAYERS: "Layere configurate",
                FIELDS: {
                    TENANT_ID: "Organizație",
                    LAYER_ID: "ID",
                    LAYER_NAME: "Nume",
                    OPACITY: "Opacitate",
                    SHOW_LABELS: "Afișare Etichete",
                    SUBLAYERS: "Sublayere",
                },
                PLACEHOLDERS: {
                    TENANT_ID: "Selectează Organizație",
                    LAYER_ID: "ID Layer",
                    LAYER_NAME: "Nume Layer",
                },
                LAYER_ALREADY_EXISTS: "Acest layer a fost deja adăugat.",
            },
        },
        ENUMS: {
            STATUS: {
                YES: "DA",
                NO: "NU",
                DRAFT: "Draft",
                ERROR: "Nepublicat",
                PUBLISHED: "Publicat",
                PENDING: "Procesare",
            },
            EXECUTION_SCOPE: {
                MAIN: "Principal",
                SUBPROCESS: "Subproces",
            },
            EXTRA_DOCUMENT_VISIBILITY: {
                PRIVATE: "Privat",
                PUBLIC: "Public",
            },
        },
        TABLE_HEADER: {
            TRANSITION: "Tranziție",
            ACTIONS: "Acțiuni",
        },
        MESSAGES: {
            ALREADY_EXISTS: "Un proces cu această denumire există deja",
        },
    },
    GIS_INTERSECTIONS: {
        LIST_HEADER: "Lista intersecțiilor",
        SINGLE: "Total {total} amplasamente intersectate",
        MULTIPLE: "Total {total} amplasamente intersectate",
        INTERSECTION_GIS_VALUE: "Valoare din GIS",
        INTERSECTION_MANUAL_VALUE: "Valoare manuală",
        INTERSECTION_VIEW_MODAL_TITLE: "Intersecții pentru {0} {1}",
        INTERSECTION_SECTION_TITLE: "Intersecția {0}",
        CARD: {
            METADATA: "Metadată",
            LAYER_NAME: "Layer",
            SUBLAYER_NAME: "Sublayer",
            CADASTRAL_NUMBER: "Nr. cadastral",
            UAT: "Municipiu / Oraș / Comună",
            ATTRIBUTE_NAME: "Atribut GIS",
            VALUE: "Valoare",
        },
        INTERSECTION_TYPE_LABEL: "Tip intersecție",
        INTERSECTION_TYPE: {
            TOTAL: "Intersecție totală",
            PARTIAL: "Intersecție parțială",
            NONE: "Neintersectat",
        },
        COMPLETION_METHOD_LABEL: "Mod completare metadata",
        METADATA_COMPLETION_METHOD: {
            USE_GIS_VALUE: "Valoare actuală din GIS",
            MANUAL: "Completare manuală",
        },
        INTERSECTION_VIEW_MODAL_COUNTER: "Intersecția {0} din {1}",
    },
    PERMISSIONS: {
        HEADER: "Permisiuni",
        FILTER: {
            TITLE: "Listă permisiuni",
        },
        BUTTONS: {
            SET_PERMISSIONS: "Setări Permisiuni",
        },
        FIELDS: {
            NAME: "Nume",
            PERMISSION_NAME: "Denumire",
            DESCRIPTION: "Descriere",
            CATEGORY: "Categorie",
            SCOPE: "Scope",
            ORGANISATIONS: "Organizație",
            SYSTEM_DEFAULT: "Asignare Default",
            DEFAULT_ASSIGNED_TO: "Utilizator Default",
            APPLY_DEFAULT_TO_ORGANISATION: "Organizație Default",
        },
        PLACEHOLDERS: {
            NAME: "Nume",
            PERMISSION_NAME: "Denumire",
            CATEGORY: "Categorie",
        },
        FORM: {
            TITLE: "Setează permisiuni",
            PERMISSIONS: "Permisiuni",
        },
    },
    REAL_ESTATE: {
        FORM: {
            HEADER: "Adaugă amplasament",
            ADD_BTN: "Adaugă amplasament nou",
            ADD_FILE_LABEL: "Adaugă plan cadastral (pdf/zip)",
            ADD_FILE_BTN: "Alege fișiere",
            DUPLICATE_CADASTRAL_NUMBER: "Acest număr cadastral este deja adăugat",
            DUPLICATE_CADASTRAL_NUMBER_PLURAL: "Unele numere cadastrale selectate sunt deja adăugate",
            DIFFERENT_AREA: "Aria introdusă este diferită de cea de la ANCPI",
            WRONG_COUNTY: "Se pot depune cereri doar pe județul {county}",
            CADASTRAL_NUMBER_UNAVAILABLE: "Nu am amplasament cadastrat (intabulat/cu extras CF)",
            DRAW_PARCEL: "Desenează amplasamentul",
            DRAW_SEARCH_INTERSECT: "Deseneaza o zona si alege mai multe parcele",
        },
        VIEW: {
            ADDRESS: "Adresă",
            CONTACT: "Contact",
            CADASTRAL_PLAN: "Plan cadastral",
            NO_FILES: "Nu există fișiere",
            FILES_LABEL: "Fișiere de identificare",
        },
        SKETCH: {
            MODAL_HEADER: "Desenează un amplasament",
            MODAL_HEADER_INTERSECT: "Caută amplasament prin desenare",
            MODAL_HEADER_MIXED: "Desenează sau caută amplasament",
            VIEW_MODAL_HEADER: "Vizualizează amplasament",
            TITLE_UNDER_EDIT: "Folosiți unealta de desenare poligon din bara de instrumente din colțul din dreapta jos al hărții pentru a contura amplasamentul. Faceți click pe hartă pentru a plasa fiecare colț al parcelei, iar pentru a încheia conturul faceți dublu-click pe ultimul punct. După desenare, puteți ajusta conturul trăgând de punctele afișate pe margine sau îl puteți șterge și desena din nou din bara de instrumente. Apăsați 'Adaugă' după ce conturul reflectă corect amplasamentul.",
            TITLE_UNDER_INTERSECT: "Folosiți unealta de desenare poligon din bara de instrumente din colțul din dreapta jos al hărții pentru a contura o zonă care acoperă una sau mai multe parcele. La finalizarea desenului (dublu-click pe ultimul punct), aplicația va căuta automat parcelele aflate în zona desenată; din lista afișată veți putea selecta parcelele pe care doriți să le adăugați.",
            TITLE_UNDER_MIXED: "Folosiți unealta de desenare poligon din bara de instrumente din colțul din dreapta jos al hărții pentru a contura amplasamentul. Dacă zona desenată se suprapune cu una sau mai multe parcele existente, veți putea selecta din lista afișată parcelele pe care doriți să le adăugați; în caz contrar, desenul va fi adăugat ca un amplasament nou.",
            INTERSECT_CANDIDATES_HEADER: "Amplasamente găsite",
            INTERSECT_NO_MATCHES: "Nu a fost găsit niciun amplasament în zona desenată",
            INTERSECT_CADASTRAL_NUMBERS_LABEL: "Numere cadastrale găsite, validate în ANCPI",
            INTERSECT_VALIDATION_SUMMARY: "{valid} validate în ANCPI, {invalid} nevalidate",
            INTERSECT_STATUS_SKETCH: "Nevalidat în ANCPI, va fi adăugat ca schiță",
            INTERSECT_UAT_UNRESOLVED: "UAT nedeterminat",
            INTERSECT_SELECT_ALL: "Selectează tot / Deselectează tot",
        },
        SINGLE: "Total {total} amplasament",
        MULTIPLE: "Total {total} amplasamente",
        REAL_ESTATES: "Amplasamente",
        SKETCHES: "Amplasamente desenate",
        NO_REAL_ESTATES: "Nici un amplasament adăugat",
        DOCUMENTS: "Documente",
        LIST_HEADER: "Lista amplasamentelor",
        MODAL: {
            ADD_HEADER: "Adaugă un amplasament",
            SUMMARY_HEADER: "Lista completă a imobilelor",
            VIEW_COUNTER: "Imobil {0} din {1}",
        },
        DETAILS_MODAL: {
            HEADER: "Detalii amplasament (data interogare ANCPI: {date})",
            SUBHEADER_DESCRIPTION: "A. Partea I. Descrierea imobilului",
            SUBHEADER_REGISTRATIONS_FIRST: "B. Partea II. Proprietari si acte",
            SUBHEADER_REGISTRATIONS_SECOND: "C. Partea III. SARCINI",
            NO_DATA: "Nu există date",
            GENERAL: {
                HEADER: "Date generale",
                UAT: "UAT",
                CADASTRAL_NUMBER: "Nr. cadastral",
                PREVIOUS_CAD_NO: "Nr. cadastral vechi",
                PREVIOUS_LAND_BOOK_NO: "Nr. CF vechi",
                MEASUREAD_AREA: "Suprafața măsurată",
                LEGAL_AREA: "Suprafața legală",
            },
            ADDRESS: {
                HEADER: "Adresă",
                COUNTY: "Județ",
                ADMIN_UNIT: "UAT",
                LOCALITY: "Localitate",
                STREET_TYPE: "Tip stradă",
                STREET_NAME: "Stradă",
                POSTAL_NUMBER: "Nr. poștal",
                BUILDING_NUMBER: "Nr. clădire",
                BUILDING_PART_NUMBER: "Nr. clădire (parte)",
                FLOOR_NUMBER: "Etaj",
                BUILDING_UNIT_NUMBER: "Nr. unitate",
                POSTAL_CODE: "Cod poștal",
            },
            PARCELS: {
                TITLE: "Parcele",
                HEADER: "Parcelă {number}",
                MEASUREAD_AREA: "Suprafața măsurată",
                LEGAL_AREA: "Suprafața legală",
                PROPERTY_TITLE_NO: "Titlu proprietate",
                USE_CATEGORY: "Utilizare",
                IS_AGRICULTURAL: "Agricol",
                INTRAVILAN: "Intravilan",
            },
            BUILDINGS: {
                TITLE: "Construcții",
                HEADER: "Clădire {number}",
                MEASUREAD_AREA: "Suprafața măsurată",
                LEGAL_AREA: "Suprafața legală",
                USE_CATEGORY: "Utilizare",
                LEGAL: "Legal",
            },
            OWNERS: {
                HEADER: "Proprietari",
                NAME: "Nume",
                CNP: "CNP",
                OWNERSHIP_TYPE: "Tip proprietate",
                IS_PART_HOLDER: "Deținătorul unei părți",
                DESCRIPTION: "{registration_type}, drept de {right_type}, dobândit prin {property_transfer_type}, cotă actuală {actual_quota}.",
            },
            REGISTRATIONS: {
                HEADER_FIRST: "Înscrieri privitoare la dreptul de proprietate şi alte drepturi reale",
                HEADER_SECOND: "Înscrieri privind dezmembrămintele dreptului de proprietate, drepturi reale de garanţie şi sarcini",
                DEED_TEXT: "{type} nr. {number}, din {date} emis de {issuer}",
                INTAB_DESCRIPTION: "Intabulare, drept de {right_type} {right_comment}, dobândit prin {transfer_type}, cota actuală {quota}",
            },
        },
        CARD: {
            CADASTRAL_NUMBER: "Nr. cadastral",
            UAT: "UAT",
            LAND_AREA: "Suprafață",
            ADDRESS_COUNTY: "Județul {county}",
            CATEGORY: "Cod categorie",
            MISSING_COORDINATES_MESSAGE: "Lipsă coordonate ANCPI",
        },
    },
    METADATA_MAPPING: {
        FIELDS: {
            METADATA: "Metadata GU",
            ARCHIVE_METADATA_NAME: "Metadata Arhivă Nume",
            ALIAS: "Metadata GU Etichetă",
            ARCHIVE_METADATA_LABEL: "Metadata Arhivă Etichetă",
        },
        PAGE_TITLE: "Mapare Metadate Arhiva cu Metadate GU",
        TABLE_TITLE: "Lista mapărilor existente",
        FORM: {
            ARCHIVE: {
                DOC_TYPE: "Selectează Document",
                METADATA: "Selectează Metadata - Arhivă",
            },
            GU: {
                APP_TYPE: "Selectează tip cerere",
                METADATA: "Selectează Metadata - GU",
            },
        },
        MANDATORY_NOTE: "Opțiunile cu prefixul (M) sunt mandatory (obligatorii).",
        CONFIRMATION_MESSAGE: "Metadata arhiva <strong>{label}</strong> este asociat la metadata GU <strong>{metadata}</strong>. <hr> Doresti suprascrierea cu <strong>{text}</strong>?",
        TABLE_TITLE_FOR: "Lista mapărilor existente pentru {appType}",
    },
    ATLAS: {
        MENU: {
            LAYER_MANAGER: "Atlas",
            MY_APPLICATIONS: "Cererile mele",
            INTEREST_ZONES: "Zone de interes",
            DISTANCE: "Distanță",
            ARIA: "Arie",
            SEARCH: "Căutare",
            HELP: "Ajutor",
            VISIBILITY_MANAGER: "Setări vizibilitate",
            PARCEL_SEARCH: "Căutare imobil",
            ARCGIS_APPS: "Aplicatii GIS",
        },
        LAYER_MANAGER: {
            TITLE: "Manager hartă",
            SEARCH_LAYER: "Caută layere",
            MORE_ACTION: {
                SHARE: "Distribuie",
                EDIT: "Editează",
                EXPORT: "Exportă",
                DELETE: "Șterge",
                PUBLISH: "Publică",
            },
            ATLAS_LABEL: "Layere Atlas",
            APPS_LABEL: "Aplicatii GIS",
            ORGANISATION_LABEL: "Layere organizație",
            PRIVATE_LABEL: "Layerele mele",
            IMPORT_LAYER_LINK: "importă un layer",
            EMPTY_LAYER_TEXT: "Nu există layere",
            EMPTY_ARCGIS_APPS_TEXT: "Nu există aplicații",
            UPLOADING: "Se încarcă...",
            UPLOAD_DONE: "Layerul a fost încărcat cu succes!",
            UPLOAD_ERROR: "Eroare la încărcarea layerului!",
            UPLOAD_MORE: "Doriți să încărcați alt layer?",
            UPLOAD_TRY: "Încercă din nou!",
            DELETE_MODAL_TITLE: "Ești sigur că vrei să ștergi acest layer?",
            DELETE_ARCGIS_APP_MODAL_TITLE: "Ești sigur că vrei să ștergi aceasta aplicație?",
            DELETE_MODAL_SUBTITLE: "Vei renunța la toate datele de pe sublayere.",
            UPLOAD_LAYER: {
                TITLE: "Încarcă acum un layer nou (.ZIP)",
            },
            UPDATE_CONTAINER_TITLE: "Modificare container",
            UPDATE_LAYER_TITLE: "Modifică Layer",
            ADD_LAYER_TITLE: "Adăugare Layer",
            ADD_LAYER_BY_ID_BTN: "Adaugă layer pe baza id-ului",
            TOOLTIP_TEXT: "Layerul este disponibil pe",
            TOOLTIP_URL: "gis.cluj.archi",
            SYSTEM_LAYER: "Layer sistem",
            LAYER_SYNC_SUCCESS: "Layerul a fost actualizat cu succes.",
            LAYER_SYNC_ERROR: "Layerul nu a putut fi actualizat.",
            SHOW_LEGEND: "Arata legendă",
            HIDE_LEGEND: "Ascunde legendă",
            LAYER_TITLE: "Titlu layer",
        },
        LAYER_PRESETS: {
            TITLE: "Teme harta",
            PREDEFINED_TITLE: "Filtre predefinite",
            PERSONAL_TITLE: "Filtrele mele",
            ADD_BTN: "Adaugă filtru",
            PREDEFINED_ADD_BTN: "Adaugă filtru predefinit",
            SAVE_BTN: "Salvează",
            APPLY_BTN: "Aplică",
            DELETE_BTN: "Șterge",
            NAME_PLACEHOLDER: "Nume filtru...",
            EMPTY_TEXT: "Nu există filtre salvate.",
            PREDEFINED_EMPTY_TEXT: "Nu există filtre predefinite.",
            PREDEFINED_SELECT_ORG_CTA: "Selectează instituția",
            SAVE_SUCCESS: "Filtrul a fost salvat.",
            PREDEFINED_SAVE_SUCCESS: "Filtrul predefinit a fost salvat.",
            HELP_TITLE: "Cum funcționează?",
            HELP_TEXT: "Salvează configurația curentă de straturi vizibile ca un filtru numit. Aplică un filtru salvat pentru a restaura rapid aceeași configurație de vizibilitate a straturilor.",
            APPLY_SUCCESS: "Filtrul a fost aplicat.",
            DELETE_SUCCESS: "Filtrul a fost șters.",
            PREDEFINED_DELETE_SUCCESS: "Filtrul predefinit a fost șters.",
            DELETE_CONFIRM_TITLE: "Ștergi filtrul?",
            DELETE_CONFIRM_TEXT: "Această acțiune nu poate fi anulată.",
            PREDEFINED_DELETE_CONFIRM_TITLE: "Ștergi filtrul predefinit?",
            PREDEFINED_DELETE_CONFIRM_TEXT: "Această acțiune nu poate fi anulată.",
        },
        LAYER_SETTINGS: {
            TITLE: "Setări sublayer",
            SELECT_SUBLAYER: "Selectează sublayer",
            SELECT_SUBLAYER_PLACEHOLDER: "-- Alege un sublayer --",
            ALLOW_FEATURES_TABLE: "Permite vizualizarea tabelului de atribute",
            ALLOW_COMMENTS: "Permite comentarii",
            SHOW_ID_COLUMN: "Afișează coloana ID",
            SELECT_ID_COLUMN_FIRST: "Selectează mai întâi o coloană ID în atributele selectate",
            NAME_COLUMN_FORMAT: "Format coloană cap tabel sublayere",
            NAME_COLUMN_FORMAT_PLACEHOLDER: "ex: {field1} - {field2}",
            NAME_FORMAT_INVALID: "Format invalid: câmpurile trebuie să fie din atributele selectate",
            SELECT_ATTRIBUTES: "Selectează atribute vizibile",
            SELECTED_ATTRIBUTES: "Atribute selectate",
            LOADING_ATTRIBUTES: "Se încarcă atribute...",
            ATTRIBUTE_FETCH_ERROR: "Eroare la încărcarea atributelor din ArcGIS",
            ALIAS: "Alias",
            SEARCHABLE: "Căutabil",
            USE_AS_ID: "Folosește ca ID",
        },
        APPLICATIONS_MANAGER: {
            TITLE: "Cererile mele",
        },
        INTEREST_AREAS_MANAGER: {
            TITLE: "Zonele mele de interes",
            TITLE_TOOLTIP: "Pentru a adăuga o nouă zonă de interes, a se folosi opțiunea de măsurare arie din meniul de pe hartă. Pentru finalizare definire arie, faceți dublu click.",
            AREA: "Arie",
            NOTIFICATIONS: "Notificări",
            NOTES: "Notițe",
            PERIMETER: "Perimetru",
            ADD_NEW_ZONE_TITLE: "Adăugare zonă nouă de interes",
            EDIT_NEW_ZONE_TITLE: "Editare zonă de interes",
            NOTES_PLACEHOLDER: "Adaugă informație cheie",
            BUTTONS: {
                NEW_AREA: "Zonă nouă",
            },
            DELETE_CONFIRMATION_TEXT: "Ești sigur că vrei să ștergi zona de interes?",
        },
        INTERSECTION_MANAGER: {
            TITLE: "Locație marcată",
            INFO_LAYER_TEXT: "Informații",
            CU_INFO_LAYER_TEXT: "Certificat urbanism",
            AUTHORIZATION_INFO_LAYER_TEXT: "Autorizație",
            DETAILS_TEXT: "Detalii",
            SIRUTA_LABEL: "SIRUTA",
            COUNTY_NAME_LABEL: "Denumire județ",
            COUNTY_INDICATIV_LABEL: "Indicativ județ",
            UAT_LABEL: "Denumire UAT",
            APPROVAL_YEAR_LABEL: "An aprobare PUG",
            YEAR_OF_EXTENSION_LABEL: "An prelungire PUG",
            NO_YEAR_OF_EXTENSION: "Nu este cazul",
            URBANISM_REGULATION_LABEL: "Reglementări urbanistice",
            APPLICATION_ISSUED_DATE: "Data emiterii",
            APPLICATION_TYPE: "Tip",
            APPLICATION_STATUS: "Status",
            HELP_TEXT: "Nu a fost găsit nici un rezultat, selectează un punct pe hartă!",
            TAB_LABEL: "Intersecție",
            APPLICATION_STATUSES: {
                DRAFT: "Draft",
                NEW: "Nou",
                EMITTED: "Finalizat",
                REJECTED: "Respins",
            },
        },
        INTERSECTION_DETAILS_MODAL: {
            HEADER: "Informații locație marcată",
            RLU_RT: "Regim Tehnic",
            RLU_RJ: "Regim Juridic",
            RLU_RE: "Regim Economic",
            RLU_POT: "POT",
            RLU_CUT: "CUT ",
            RLU_RDA: "Regim de actualizare",
        },
        SUBLAYER_MANAGER: {
            TAB_LABEL: "Detalii strat",
            SUBLAYER_NAME: "Denumire sublayer",
            SUBLAYER_ACTIONS: "Acțiuni",
            EMPTY_SUBLAYERS_TEXT: "Nu există sublayere",
            SCALE_RANGE_SLIDER_TITLE: "Parametri Sublayer",
            SUGGEST_SCALE_RANGE_TEXT: "Sugerați o scală",
            SCALE_RANGE_SLIDER_TEXT: "Scală",
            OPACITY_SLIDER_TEXT: "Opacitate",
            CLUSTERING_CHK_LABEL: "Clustering",
            HEATMAP_CHK_LABEL: "Hartă termografică",
            FEATURES: {
                FEATURES_TABLE: "Listă parcele",
                FEATURE_ATTRIBUTES: "Atribute",
                NAME: "Denumire",
                ACTION: "Acțiune",
                COMMENTS: "Comentarii",
                NO_COMMENTS: "Nu sunt comentarii încă.",
                DELETE: "Șterge",
                DELETE_COMMENT_TITLE: "Șterge comentariu",
                DELETE_COMMENT_MESSAGE: "Sigur doriți să ștergeți acest comentariu? Acțiunea nu poate fi anulată.",
                ADD_PLACEHOLDER: "Adaugă un comentariu...",
                SUBMIT: "Trimite",
                NO_SELECTION: "Selectează o parcelă pentru a vizualiza detaliile și comentariile.",
                SEARCH_PLACEHOLDER: "Caută...",
                CLEAR_FILTER: "Șterge filtrul",
                ID: "ID",
                COMMENTS_UNAVAILABLE_NO_ID: "Această entitate nu are un câmp ID detectabil, comentariile nu sunt disponibile.",
                NO_FEATURES: "Nu a fost găsită nicio parcelă",
                EDITED: "(Editat)",
                EDIT: "Editează",
                VIEW_DETAILS: "Vezi detalii",
                COPY_QR_LINK: "Copiază link QR",
                QR_LINK_COPIED: "Linkul QR a fost copiat",
                QR_LINK_COPY_ERROR: "Linkul QR nu a putut fi copiat",
            },
        },
        SWIPE: {
            SET_LEADING: "Strat comparație (stânga)",
            SET_TRAILING: "Strat comparație (dreapta)",
            SWIPE_LEFT: "Compară stânga",
            SWIPE_RIGHT: "Compară dreapta",
            CLEAR: "Șterge straturile de comparație",
            TOGGLE_ON: "Click pentru a compara straturile",
            TOGGLE_OFF: "Click pentru a opri comparația",
        },
        COMMENTS_MANAGER: {
            COMMENTS: "Comentarii",
            ADD_COMMENT: "Adaugă comentariu",
            DELETE_COMMENT: "Sterge comentariu",
            DELETE_ALL_COMMENTS: "Sterge discutia",
            REPLY_TO_COMMENT: "Răspunde la comentariu",
            EMPTY_COMMENTS_TEXT: "Nu există comentarii",
            INSTRUCTIONS: "Selectează un punct pe hartă prin dublu click",
            CONFIRMATION_MESSAGE_DELETE: "Esti sigur ca vrei sa stergi mesajul?",
            CONFIRMATION_MESSAGE_DELETE_ALL: "Esti sigur ca vrei sa stergi toata discutia?",
        },
        VISIBILITY_MANAGER: {
            TITLE: "Setări vizibilitate",
            ORDER_COLUMN_HEADER: "Ordine",
        },
        CREATE_LAYER_MODAL: {
            HEADER: "Adaugă layer nou",
            ERROR: "Container cu scop RU selectat deja există!",
        },
        HOME_BUTTON: {
            TITLE: "Acasă",
        },
        PARCEL_SEARCH: {
            SHOW_PARCEL_SEARCH: "Caută imobil",
            HIDE_PARCEL_SEARCH: "Închide căutare imobil",
            COUNTY_PLACEHOLDER: "Alege județ",
            UAT_PLACEHOLDER: "Alege UAT",
            CADASTRAL_NUMBER_PLACEHOLDER: "Introdu numarul carții funciare",
            MODAL: {
                HEADER: "Căutare imobil",
            },
            TITLE: "Căutare imobil",
            SEARCH_BTN: "Caută imobil",
            SEARCH_HISTORY_LABEL: "Istoric de căutare",
        },
        LAYER_ATTRIBUTE_SEARCH: {
            TITLE: "Căutare în layere",
            PLACEHOLDER: "UAT / nr. cadastral / nr. cerere",
            LOADING: "Se caută...",
            NO_RESULTS: "Niciun rezultat găsit",
            SUMMARY: "{count} rezultate în {groups} straturi",
        },
        PUBLISH_LAYER_MODAL: {
            HEADER: "Publicare layer",
        },
        ARCGIS_APPS_MODAL: {
            ADD_NEW_APPLICATION: "Adaugă Aplicatie",
            HEADER_EDIT: "Modificare aplicatie GIS",
            HEADER_ADD: "Adaugare aplicatie GIS",
        },
        COMPARE_LAYER_MODAL: {
            HEADER: "Comparare Layere",
            TEMPLATE_LAYER: "Destinație",
            TEMPLATE_LAYER_LABEL: "Structură layer șablon",
            SOURCE_LAYER: "Sursa: {layer}",
            SOURCE_LAYER_LABEL: "Structură layer sursă",
            FORCE_PUBLISH: "Forțează publicarea",
            STATUS: {
                READY: "Layerul este pregătit de publicare.",
                NOT_READY: "Layerul nu poate fi publicat, structura lui nu respectă structura layer-ului șablon.",
            },
        },
        LAYER_DETAILS: {
            TITLE: "Detalii layer {name}",
            GENERAL_INFO: "Informații generale",
            GIS_DETAILS: "Detalii GIS",
            ID: "ID:",
            LAYER_TYPE: "Tip layer:",
            ACCESS_LEVEL: "Nivel acces:",
            CONTAINER_ID: "Container ID:",
            CREATED_DATE: "Created date:",
            RU_SCOPE: "Scop RU:",
            UAT_NAME: "UAT:",
            UAT_ID: "UAT ID:",
            OWNER_ORG_NAME: "Organizație owner:",
            OWNERSHIP_TYPE: "Model ownership:",
            FEATURE_SERVICE_URL: "Feature Service URL:",
            GIS_LAYER_ID: "GIS Layer ID:",
        },
        FIELDS: {
            NAME: "Denumire layer",
            CONTAINER_NAME: "Denumire container",
            ACCESS_LEVEL: "Nivel acces",
            OWNERSHIP_TYPE: "Tip actualizare",
            ORGANIZATION: "Organizație",
            LAYER_TYPE: "Tip layer",
            CONTAINER_LAYER: "Alege container din Atlas",
            RU_SCOPE: "Scop RU",
            UAT: "UAT",
            USE_AS_TEMPLATE: "Adaugă structură pentru toate UAT-urile",
            DECISION: "HCL(prin care a fost promulgat)",
            HAS_DECISION: "Nu se aplică",
            LAYER: "Alege layer din Atlas",
            OWNER: "Owner",
            PUBLISH_NAME: "Nume",
            TEMPLATE_NAME: "Nume",
            GEOMETRY_TYPE: "Tip geometrie",
            STATUS: "Status",
            DECISION_ID: "Alege H.C.L.",
            TEMPLATE_LAYER_ID: "Layer șablon",
            ARCGIS_IMPORTED_ITEM: "Identificator layer GIS",
            ARCGIS_IMPORTED_ITEM_TYPE: "Tip layer GIS",
            TITLE: "Titlu",
            NOTES: "Notițe",
            NOTIFICATION_ENABLED: "Notificări active",
            SURFACE: "Suprafață",
            PERIMETER: "Perimetru",
            ARCGIS_IMPORTED_ITEM_IS_LINKED: "Adăugare fără duplicare",
            PRIVATE_LAYER_OWNERSHIP_TYPE: "Layer privat vs. layer organizatie",
            FEATURE_SERVICE_URL: "GIS feature url",
            GIS_LAYER_ID: "Identificator layer GIS",
            APP_ID: "ID Aplicație",
            APP_NAME: "Nume Aplicație",
            APP_URL: "URL Aplicație",
            CAN_ACCESS_CITIZEN: "Vizibil în \"Previzualizare Atlas\" pentru cetățeni",
            CAN_ACCESS_STAFF: "Vizibil în \"Previzualizare Atlas\" pentru funcționari",
            APPLICATION_TYPE: "Tip cerere asociat",
            APPLICATION_TYPE_HELP_TITLE: "La ce este folosit?",
            APPLICATION_TYPE_HELP_TEXT: "Pinpoint-urile cererilor cu aceste tipuri de cerere vor fi sincronizate cu acest layer.",
            INTEREST_AREA_NOTIFICATIONS: "Activează notificările pentru zone de interes",
            DELETE_PINPOINT_ON_REJECTION: "Șterge pinpoint-ul la respingere",
        },
        ENUMS: {
            LAYER_TYPE: {
                CONTAINER: "Container",
                SIMPLE: "Simplu",
            },
            ACCESS_LEVEL: {
                PRIVATE: "Privat",
                PUBLIC: "Public",
                PROTECTED: "Protected",
            },
            OWNERSHIP_TYPE: {
                CENTRALIZED: "Centralizat",
                DISTRIBUTED: "Distribuit",
            },
            RU_SCOPE: {
                PUG: "PUG",
                PUZ: "PUZ",
                PUD: "PUD",
                OTHER: "Altul",
            },
            STATUS: {
                OK: "Ok",
                MISSING: "Lipsește",
                NEW: "Nou",
                COMPLETED: "Complet",
                PENDING: "În procesare",
            },
            ARCGIS_IMPORTED_ITEM_TYPE: {
                FEATURE_SERVER: "Feature Server",
                SHAPEFILE: "Shapefile",
            },
            PRIVATE_LAYER_OWNERSHIP_TYPE: {
                PLOT_PRIVATE: "Layer privat",
                PLOT_ORGANISATION: "Layer organizatie",
            },
            GEOMETRY_TYPE: {
                POLYGON: "Poligon",
            },
        },
        EDIT_MODAL: {
            LAYER_NAME: "Denumire",
            SUBLAYER_NAME: "Zone urbanistice",
            ACCESS_LEVEL: "Nivel acces",
            OWNER: "Organizație",
            RU_SCOPE: "Scop RU",
            UAT: "UAT",
            TYPE: "Tip",
            STATUS: "Status",
            TEMPLATE: "Template",
            UPLOAD_BROWSE_TXT: "Alege fișier",
            UPLOAD_BROWSE_PLACEHOLDER: "Alege un fișier sau lasă-l aici...",
            DUPLICATE_LAYER_NAME: "Numele layerului deja există!",
            SUBLAYERS_LIST: "Lista sublayere",
        },
        BUTTONS: {
            ADD_SIMPLE_LAYER: "Adaugă layer simplu",
            CLOSE_SIMPLE_LAYER: "Închide adăugare layer simplu",
            UPDATE_CONTAINER: "Modifică container",
        },
        PUBLISH_STATUS: {
            PUBLISHED: "Publicat",
            NOT_PUBLISHED: "Nepublicat",
            NEW: "Nou",
            PENDING: "În procesare",
            ERROR: "Eroare",
            COMPLETED: "Publicat",
            MESSAGE_SUCCESS: "Layerul a fost publicat cu succes în Atlas",
            MESSAGE_FAILED: "Layerul nu a putut fi publicat în Atlas. Vă rugăm reîncercați",
            MESSAGE_CONFIRMATION: "Publicarea durează câteva minute. Poți continua să folosești aplicația în acest timp. Urmarește rezultatul publicarii pe layer dupa ce ai reîncarcat pagina.",
        },
        POPUP_TEMPLATE_INFO_FIELDS: {
            APPLICATION_STATUS: "Status cerere",
            APPLICATION_ID: "Id cerere",
            COLOR: "Culoare",
            CADASTRAL_NUMBER: "Nr. cadastral",
            COMBINED_ID: "Id combinat",
            APPLICATION_TYPE: "Tip cerere",
            APPLICATION_TYPE_NAME: "Nume tip cerere",
            APPLICATION_REQUEST_NUMBER: "Nr. cerere",
            APPLICATION_NUMBER: "Nr. autorizație",
            APPLICATION_REQUEST_DATE: "Dată cerere",
            APPLICATION_ISSUED_DATE: "Dată eliberare",
            REAL_ESTATE_TYPE: "Tip amplasament",
            UAT_ID: "Id UAT",
            COUNTY: "Județ",
            PLACEHOLDER: "UAT/Nr. cadastral/cerere",
        },
        FEATURE_COMMENTS: {
            TITLE: "Comentarii",
            BULK_DELETE: "Șterge selecția",
            CONFIRM_DELETE_TITLE: "Confirmare ștergere",
            CONFIRM_DELETE_TEXT: "Sigur doriți să ștergeți acest comentariu? Acțiunea nu poate fi anulată.",
            CONFIRM_BULK_DELETE_TITLE: "Confirmare ștergere multiplă",
            CONFIRM_BULK_DELETE_TEXT: "Sigur doriți să ștergeți {count} comentarii? Acțiunea nu poate fi anulată.",
            DELETE_SUCCESS: "Comentariul a fost șters cu succes.",
            DELETE_ERROR: "Eroare la ștergerea comentariului.",
            BULK_DELETE_SUCCESS: "{count} comentarii au fost șterse cu succes.",
            BULK_DELETE_ERROR: "Eroare la ștergerea comentariilor.",
            COLUMN_ID: "ID",
            COLUMN_DATE: "Data creării",
            COLUMN_UPDATED_DATE: "Data actualizării",
            COLUMN_USER: "Utilizator",
            COLUMN_OWNER_USER_ID: "Proprietar",
            COLUMN_COMMENT: "Comentariu",
            COLUMN_LAYER_ID: "Layer ID",
            COLUMN_LAYER: "Layer",
            COLUMN_SUBLAYER_ID: "Sublayer ID",
            COLUMN_SUBLAYER: "Sublayer",
            COLUMN_FEATURE_ID: "ID parcelă",
            COLUMN_COMMENTING_USER_NAME: "Utilizator",
            ACTION_VIEW: "Vizualizează",
            ACTION_REPLY: "Răspunde",
            ACTION_DELETE: "Șterge",
            REPLY_TO: "Răspunde la comentariul utilizatorului",
            REPLY_PLACEHOLDER: "Scrie răspunsul...",
            REPLY_SUCCESS: "Răspunsul a fost adăugat cu succes.",
            REPLY_ERROR: "Eroare la adăugarea răspunsului.",
            FILTER_LAYER: "Layer",
            FILTER_SUBLAYER: "Sublayer",
            FILTER_FEATURE_ID: "ID parcelă",
            FILTER_DATE: "Data creării",
            FILTER_USER: "Utilizator",
            FILTER_COMMENT: "Comentariu",
            FILTER_LAYER_ID: "Layer",
            COLUMN_APPLICATION_REQUEST_NUMBER: "Număr cerere",
            FILTER_APPLICATION_REQUEST_NUMBER: "Număr cerere",
            VIEW_ON_MAP: "Vezi pe hartă",
            NO_COMMENTS: "Nu există comentarii.",
            ALL_LAYERS: "Toate layerele",
            ALL_SUBLAYERS: "Toate sublayerele",
            VALIDATION_FIELD_REQUIRED: "Câmpul {field} este obligatoriu",
            VALIDATION_FAILED: "Validarea comentariului a eșuat: {errors}",
        },
        CITIZEN_FEATURES: {
            SECTION_TITLE: "Layerele mele",
            COLLEAGUE_SECTION_TITLE: "Layere colegi",
            COLLEAGUE_MEMBER_FILTER_LABEL: "Membru echipă",
            COLLEAGUE_EMPTY_STATE: "Niciun layer publicat de colegi",
            UPLOAD_BTN: "Încarcă layer",
            EMPTY_STATE: "Nu aveți niciun layer încărcat",
            FORM: {
                CREATE_TITLE: "Încarcă layer nou",
                EDIT_TITLE: "Editează layer",
                UPLOAD_BTN: "Încarcă",
                FILE_PLACEHOLDER: "Selectați fișier .zip",
                FILE_HINT: "Fișierul ZIP trebuie să conțină fișierele: .shp, .dbf, .prj și alte fișiere necesare.",
                FILE_TYPE_ERROR: "Doar fișierele ZIP sunt acceptate",
                REPLACE_HINT: "Pentru a înlocui un shapefile, ștergeți versiunea actuală și încărcați una nouă.",
                PROCESSING: "Se procesează fișierul... Aceasta poate dura câteva minute.",
            },
            FIELDS: {
                NAME: "Denumire",
                DESCRIPTION: "Descriere",
                NOTIFICATIONS_ENABLED: "Activează notificări",
                IS_APP_PREVIEW_ENABLED: "Activează previzualizare în aplicație",
                FILE: "Fișier",
            },
            STATUS: {
                NEW: "Nou",
                PROCESSING: "În procesare",
                COMPLETED: "Finalizat",
                ERROR: "Eroare",
            },
            CONFIRM_DELETE_TITLE: "Confirmă ștergerea",
            CONFIRM_DELETE: "Sigur doriți să ștergeți acest shapefile? Acțiunea nu poate fi anulată.",
            SIDEBAR: {
                TAB_LABEL: "Layerul meu",
                SUBLAYER_SECTION_TITLE: "Sublayere",
                FEATURES_SECTION_TITLE: "Elemente",
                ZOOM_TO_SUBLAYER: "Zoom la sublayer",
            },
        },
        SCALE_WIDGET: {
            LABEL: "Scara 1:",
        },
        COORDINATE_CONVERSION: {
            EASTING: "Est",
            NORTHING: "Nord",
        },
        MAP_EXPORT: {
            EXPORTED_AT: "Exportat: {date}",
            SCALE: "Scara: {scale}",
        },
    },
    DECISION: {
        PAGE_HEADER: "Hotărâri",
        LIST: {
            TITLE: "Listă hotărâri",
            EDIT: "Editează",
            DELETE: "Șterge",
            ADD_EXTENSION: "Adaugă prelungire",
        },
        FIELDS: {
            NAME: "Denumire",
            DESCRIPTION: "Label",
            NUMBER: "Număr",
            ENTRY_DATE: "Data emitere",
            EXPIRATION_DATE: "Data expirare",
            TARGET_ID: "Locație",
            PURPOSE_ID: "Scop",
            COUNTY: "Județ",
            DECISION_ID: "Hotărâre",
            KEY: "Cheie",
        },
        PLACEHOLDERS: {
            NAME: "Denumire",
            TARGET_ID: "Caută după locație",
            PURPOSE_ID: "Caută după scop",
        },
        ADD_EDIT_FORM: {
            HEADER_ADD: "Adaugă hotărâre",
            HEADER_EDIT: "Editează hotărâre",
        },
        SUCCESS: {
            ADD: "Hotărârea a fost adaugată cu succes.",
            UPDATE: "Hotărârea a fost modificată cu succes.",
        },
        BUTTON: {
            ADD_DECISION: "Adaugă hotărâre",
        },
        TOTAL_TEXT: "Total 0 hotărâri| Total 1 hotărâre | Total {total} hotărâri",
        CARD: {
            EXTENSION_LABEL: "Prelungită cu",
            DECISION_LABEL: "Aprobat prin",
            PURPOSE_LABEL: "Faza",
        },
    },
    SYSTEM_SETTINGS: {
        LIST: {
            TITLE: "Listă setări sistem",
        },
        FIELDS: {
            KEY: "Funcționalitate",
            DESCRIPTION: "Descriere",
            DEFAULT_VALUE: "Valoare",
        },
        FORM: {
            EDIT_TITLE: "Editează setarea",
        },
        PLACEHOLDERS: {
            KEY: "Caută după cheie",
        },
        KEYS: {
            MAINTENANCE: "Banner Mentenanță",
            MAINTENANCE_TEXT: "Text Banner Mentenanță",
            SIGN_AND_SEAL_ERROR_TIMER_HOURS: "Număr ore blocaj semnare și ștampilare",
            CITIZEN_MAINTENANCE: "Pagină Mentenanță pentru cetățeni",
            CITIZEN_MAINTENANCE_TEXT: "Text Pagină Mentenanță pentru cetățeni",
        },
    },
    DECISION_TARGET: {
        LIST: {
            TITLE: "Listă locații",
        },
        ADD_BUTTON: "Adaugă locație",
        FIELDS: {
            NAME: "Denumire",
        },
        FORM: {
            EDIT_TITLE: "Editează locație",
            ADD_TITLE: "Locație nouă",
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
        },
    },
    DECISION_PURPOSE: {
        LIST: {
            TITLE: "Listă scopuri",
        },
        ADD_BUTTON: "Adaugă scop",
        FIELDS: {
            NAME: "Denumire",
        },
        FORM: {
            EDIT_TITLE: "Editează scop",
            ADD_TITLE: "Scop nou",
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
        },
    },
    DOCUMENT_SERIES_TYPE: {
        TITLE: "Tipologii de serie",
        LIST: {
            TITLE: "Listă tipologii de serie",
        },
        ADD_BUTTON: "Tipologie nouă",
        FIELDS: {
            NAME: "Denumire",
        },
        FORM: {
            EDIT_TITLE: "Editează tipologie de serie",
            ADD_TITLE: "Tipologie de serie nouă",
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
        },
    },
    REGISTERS_TYPE: {
        TITLE: "Tipologii registre",
        LIST: {
            TITLE: "Listă tipologii registre",
        },
        ADD_BUTTON: "Tipologie nouă",
        FIELDS: {
            NAME: "Denumire",
            DESCRIPTION: "Descriere",
        },
        FORM: {
            EDIT_TITLE: "Editează tipologie de registru",
            ADD_TITLE: "Tipologie de registru nouă",
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
            DESCRIPTION: "Introduceți descrierea",
        },
        FIELDS_SOURCE: {
            CITIZEN: "Cetățean",
            STAFF: "Funcționar",
            CLARIFICATION_CITIZEN: "Clarificări cetățean",
            CLARIFICATION_STAFF: "Clarificări funcționar",
        }
    },
    REGISTERS: {
        TITLE: "Registru",
        STATUS: {
            CLOSED: "Finalizata",
            REJECTED: "Respinsa",
        },
        ACTIONS: {
            EXPORT: "Exportă în CSV",
        },
    },
    PAYMENT_REGISTRY: {
        TITLE: "Plăți",
        LIST: {
            TITLE: "Istoric plăți",
        },
        CALCULATE_TAX: "Calculează preț",
        ADD_PAYMENT_ORDER: "Dispoziție plată",
        FIELDS: {
            NAME: "Denumire",
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
        },
        GENERATE_REPORT: "Raport decont",
    },
    REAL_ESTATE_REGISTER: {
        TITLE: "Date CF",
        LIST_HEADER: "Amplasamente",
        SAVE_SEARCH: "Salvează căutarea",
        TOTAL_REAL_ESTATES: "Total amplasamente",
        ADD_REAL_ESTATE: "Adaugă amplasament nou",
        NO_REAL_ESTATES: "Nu s-au găsit amplasamente",
        NO_REAL_ESTATES_DESCRIPTION: "Nu s-au găsit amplasamente în vizualizarea curentă.",
        REAL_ESTATE_DETAILS: "Detalii amplasament",
        NO_REAL_ESTATE_SELECTED: "Nu sunt amplasamente selectate",
        ALL_REAL_ESTATES: "Toate amplasamentele",
        ADD_MORE_REAL_ESTATES: "Adăugați mai multe amplasamente",
        REMOVE_CONFIRMATION: "Confirmați ștergerea acestui amplasament?",
        SYNC_SUCCESS: "Amplasamentele au fost salvate cu succes.",
        REMOVE_SUCCESS: "Șters cu succes.",
        PLACEHOLDER: "Amplasament {0}",
    },
    TAX_CALCULATOR: {
        TITLE: "Calculator preț",
        FORM_SECTION_TITLE: "Taxă eliberare act",
        SUMMARY_SECTION_TITLE: "Sumar comandă",
        FIELDS: {
            APPLICATION_TYPE: "Tipul actului",
            EXEMPTION: "Scutiri taxe conform Cod Fiscal",
            LAND_AREA: "Suprafața terenului",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
        },
        CALCULATE_BUTTON: "Calculează",
        SUMMARY: {
            OTHER_TAXES_LABEL: "Alte taxe",
            EXEMPTION_LABEL: "Scutiri",
            VAT_LABEL: "TVA",
        },
        TOTAL: "Total de plată",
        DEFAULT_TAX_NAME: "Act",
    },
    ISSUED_DOCUMENT: {
        TITLE: "Acte emise",
        LIST: {
            TITLE: "Emiterile mele",
            TITLE_STAFF: "Registru general al actelor emise",
        },
        FIELDS: {
            DOCUMENT_SERIES: "Nr.ieșire",
            DOCUMENT_NAME: "Tip act",
            ISSUED_DATE: "Data emiterii",
            BENEFICIARY_USER: "Beneficiar",
            ISSUED_YEAR: "Anul",
            ISSUER_USER_FULL_NAME: "Emis de",
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
            DOCUMENT_NAME: "Tip act",
            ISSUED_YEAR: "Anul",
            BENEFICIARY_USER: "Caută după nume",
            DOCUMENT_SERIES: "Caută după număr",
            ISSUER_USER_FULL_NAME: "Emis de",
        },
    },
    CONTROL: {
        PAGE_HEADER: "Registru control",
        CURRENT_LOCATION: "Locație curentă",
        LIST: {
            TITLE: "Controale",
            DOCUMENT_CREATED_HEADER: "Documente create",
            NO_ASSIGNEE: "Nealocat",
        },
        BUTTON: {
            ADD_CONTROL: "Control nou",
            ADD_COMPLAIN: "Adaugă sesizare",
            ADD_LOCATION: "Adaugă locație",
            NEXT_STEP: "Pasul următor",
            DELETE_LOCATION: "Șterge locație",
            CLOSE_CONTROL: "Clasare",
            GENERATE_PVCC: "Generează PVCC",
            ADD_DOCUMENT: "Document",
            SAVE: "Salvează",
            PREVIEW: "Previzualizează",
        },
        FIELDS: {
            CREATED_DATE: "Dată creare",
            CONTROL_ID: "Cod Intrare",
            COMPLAIN_REF: "Ref Sesizare",
            CREATED_BY: "Creat de",
            STATUS: "Status",
            COMPLAIN_NUMBER: "Nr. sesizare",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            ADDRESS: "Adresă",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "Tip UAT",
            LOCALITY: "Municipiu / Oraș / Comună",
            FIRST_NAME: "Prenume",
            LAST_NAME: "Nume",
            EMAIL: "E-mail",
            PHONE: "Telefon",
            IDENTIFICATION_NUMBER: "Cod intrare",
            CONTROL_DATE: "Dată intrare",
            CADASTRAL_NUMBER: "Număr cadastru",
            USER_TYPE_NAME: "Tip persoană",
            PERSONAL_NUMERIC_CODE: "CNP",
            COUNTY: "Județ",
            VILLAGE: "Localitate",
            SECTOR: "Sector",
            STREET: "Strada",
            STREET_NUMBER: "Număr stradă",
            POSTAL_CODE: "Cod poștal",
            STAIRCASE: "Scara",
            BLOCK: "Bloc",
            FLOOR: "Etaj",
            APARTMENT: "Apartament",
            REAL_ESTATE_TYPE: "Tip amplasament",
            AUTHORISATION_CODE: "TNA",
            SUBSIDIARY: "Filiala",
            LAND_AREA: "Suprafața terenului",
            OTHER_IDENTIFICATION: "Altă identificare",
            FILE_TYPE: "Tip document",
            RESOLVED_DATE: "Data soluționării",
            PASSPORT_NUMBER: "Nr. pașaport",
            CITY: "Oraș",
            LICENSE: "Licență",
            COMPANY_NAME: "Companie",
            UNIQUE_REGISTRATION_CODE: "CUI",
            FILENAME: "Nume document",
            TITLE: "Titlu",
            MESSAGE: "Mesaj",
            COMMENTS: "Comentarii",
            ALLOCATED_DOCUMENT_SERIES: "Cod ieșire",
            EMPLACEMENT_LOCALITY: "Localitate",
            OBJECTIONS: "Obiecțiuni contravenient",
            ID_CARD_SERIAL: "Serie CI",
            ID_CARD_NUMBER: "Număr CI",
            ID_CARD_EXPIRATION_DATE: "Data expirării",
            ID_CARD_ISSUER: "Eliberat de",
            CONSTRUCTION_TYPE: "Tip imobil",
            CONTROL_TYPE_NAME: "Tip control",
            ID_CARD_RELEASE_DATE: "Data emiterii",
            REGISTRATION_NUMBER: "Nr. înregistrare",
            PERSON_TYPE: "În calitate de",
            CONTRAVENTION_NUMBER: "Nr tichet",
            CONTRAVENTION_SERIES: "Serie tichet",
            CONTROL_PERSON: "Selectează un martor predefinit",
        },
        PLACEHOLDERS: {
            CONTROL_ID: "Cod Intrare",
            COMPLAIN_REF: "Ref Sesizare",
            CREATED_BY: "Creat de",
            STATUS: "Status",
            IDENTIFICATION_NUMBER: "Cod intrare",
            CADASTRAL_NUMBER: "Nr CF",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            COUNTY: "Județ",
            LOCALITY: "Localitate",
            VILLAGE: "Localitate",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "Tip UAT",
            EMPLACEMENT_LOCALITY: "Localitate",
            COMMENTS: "Comentarii",
            MESSAGE: "Mesaj",
            EMAIL: "E-mail",
        },
        ENUMS: {
            STATUS: {
                REGISTERED: "Înregistrat",
                RESOLVED: "Soluţionat",
                CLOSED: "Clasat",
                GENERATED: "Generat",
                ERROR: "Eroare",
                DRAFT: "Draft",
            },
            PERSON_TYPE: {
                INVESTITOR: "Investitor",
                EXECUTANT: "Executant",
                PROIECTANT: "Proiectant",
            },
        },
        LABEL: {
            CONTROL_ID: "Numar registru",
        },
        FORM: {
            ADD_TITLE: "Adaugă control",
            EDIT_TITLE: "Control nr. {0}",
            NEW_CONTROL: "Control nou",
        },
        PREPARATION: {
            HEADER: "Detalii sesizare",
            COMPLAIN_LIST_TAGS: "Listă cod intrare sesizări",
            WARNING: "Pentru a adăuga un control adaugă o locaţie sau selectează din lista de sesizări !",
            LIST: "Listă locaţii",
            PREVIEW_MAP: "Previzualizare din atlas teritorial",
            FORM: {
                LOCATION: "Locaţie",
                COMPLAIN_DESCRIPTION: "Conform sesizare",
                MODAL_HEADER: "Date locaţie sesizare",
            },
            SEARCH_FOR: "sesizări",
        },
        MODALS: {
            ADD: "Adaugă",
            CANCEL: "Renunță",
            SAVE: "Salvează",
        },
        NOTIFIERS: {
            DUPLICATE_OFFENDER_PNC: "Contravenientul cu același CNP ({pnc}) este deja adăugat.",
            DUPLICATE_WITNESS_PNC: "Martorul cu același CNP ({pnc}) este deja adăugat.",
            DUPLICATE_OFFENDER_PASSPORT: "Contravenientul cu același număr de pașaport ({passport}) este deja adăugat.",
            DUPLICATE_WITNESS_PASSPORT: "Martorul cu același număr de pașaport ({passport}) este deja adăugat.",
            CADASTRAL_NUMBER_NOT_FOUND: "Ne pare rău, numărul cadastral nu a fost găsit. Incercați din nou!",
            CADASTRAL_NUMBER_ERROR: "Ne pare rău, sincronizarea nu a fost cu succes. Incercați din nou!",
            DEFAULT_ERROR_MESSAGE: "A apărut o eroare, vă rugăm reîncercați",
            GENERATE_DOCUMENTS_WARN: "Generare PVCC",
            GENERATE_DOCUMENTS_WARN_TEXT: "Vă rugăm să salvați modificările făcute înainte de a genera documentul. Dupa generarea documentelor, controlul nu va mai putea fi modificat. Sunteți sigur că doriți să continuați?",
            GENERATION_COMPLETED: "Generare cu succes!",
            GENERATION_COMPLETED_TEXT: "Documentele generate se pot vizualiza în secțiunea 'Documente'.",
            GENERATION_ERROR: "A apărut o eroare la generare!",
            GENERATION_ERROR_TEXT: "Vă rugăm reîncercați generarea documentelor.",
            CLOSE_CONTROL_SUCCESS: "Controlul a fost clasat cu succes!",
            CLOSE_CONTROL_SUCCESS_TEXT: "În urma clasării, acesta nu mai poate fi modificat.",
            CLOSE_CONTROL_WARN: "Clasare control",
            CLOSE_CONTROL_WARN_TEXT: "Un control clasat nu va mai putea fi modificat. Sunteți sigur că doriți să continuați?",
            PREVIEW_DOCUMENTS_WARN: "Previzualizare PVCC",
            PREVIEW_DOCUMENTS_WARN_TEXT: "Vă rugăm să salvați modificările făcute, înainte de a previzualiza documentul.",
        },
        UPLOAD_DOCUMENTS_MODAL: {
            TITLE: "Adaugă documente",
        },
        TABS: {
            CONTROL_PREPARATION: "Pregătire control",
            DATA_COLLECTION: "Colectare date",
            DOCUMENTS: "Documente",
            ACTIVITIES: "Activități",
        },
    },
    DASHBOARD: {
        APPLICATIONS_STATUS: {
            HEADER: "Status Cereri",
            PERIOD: "Ultimele 30 zile",
            REGISTERED: "Înregistrate",
            PROCESSING: "În procesare",
            CLARIFICATIONS: "Clarificări",
        },
        TOP_USERS: {
            HEADER: "Top utilizatori",
        },
        REGISTRED_APPLICATIONS: {
            HEADER: "Cereri înregistrate",
            DESCRIPTION: "Raport cereri depuse vs soluționate",
            PERIOD: "Ultimele 12 luni",
            SUBMITTED: "Depuse",
            APPLICATIONS_COUNT: "Număr cereri",
        },
        SOLVED_APPLICATIONS: {
            HEADER: "Cereri soluționate",
            DESCRIPTION: "Procentaj soluționări din totalul depunerilor",
            APPLICATIONS_TYPE_HEADER_LEGAL: "Top tipuri de cereri",
            APPLICATIONS_TYPE_HEADER_STAFF: "Cereri pe UAT",
        },
        RECENT_APPLICATIONS: {
            HEADER: "Cereri recente",
            BUTTON: {
                VIEW_ALL_APPLICATIONS: "Vezi toate cererile",
            },
            MISSING: "Momentan nu există nici o cerere depusă. Depune acum o cerere online.",
        },
        RECENT_ISSUED_DOC: {
            HEADER: "Acte emise recent",
            BUTTON: {
                VIEW_ALL_ISSUED_DOC: "Vezi toate emiterile",
            },
        },
        PERFORMANCE: {
            HEADER: "Performanţă",
            ABOVE_AVG: "Peste medie",
            NORMAL: "Normal",
            BELLOW_AVG: "Sub medie",
            RESOLUTION_AVG: "Media",
            OBJECTIVE_HEADER: "Obiectiv termen de soluţionare",
        },
        TOTALS: {
            NEW: "Total noi",
            SOLVED: "Total soluţionate",
            IN_OPERATION: "Total în operare",
            PERCENT: "Procent total",
            TOP_USERS: "Top funcţionari repartizaţi",
        },
        TYPES: {
            STATS: "Statistică",
            NEW: "Noi",
            SOLVED: "Soluţionate",
            IN_OPERATION: "În operare",
            TOTAL_LABEL: "Total",
            DAYS: "Zile",
            SOLUTION_TERM: "Termen soluţionare",
            APPLICATIONS_PER_UATS: "Cereri pe Unitatea Administrativ Teritorială",
        },
        RECENT_NOTIFICATIONS: {
            MISSING: "Nu aveţi nici o notificare.",
        },
        FIELDS: {
            START_DATE: "Data start",
            END_DATE: "Data sfârșit",
        },
        REGISTERED_APPLICATIONS: {
            HEADER: "Cereri înregistrate",
            DESCRIPTION: "Raport cereri noi vs soluționate",
        },
        DOMAIN_TITLE: "Cu ce te putem ajuta astăzi?",
        DOMAIN_SUBTITLE: "Te scăpăm de drumurile la ghișeu.",
        DOMAIN_SUBTITLE_SECOND: "Poți depune și urmări cererile tale 100% digital, simplu și sigur. Fără hârtii!",
        DOMAIN_SEARCH_APPLICATION_TYPE_PLACEHOLDER: "Caută cerere",
        DOMAIN_NO_SEARCH_RESULTS: "Nicio cerere găsită.",
        DOMAIN_ACCESS_BUTTON: "Accesează",
        DOMAINS: [
            {
                key: "urbanism",
                title: "Urbanism",
                description: "Certificate de urbanism, autorizații de construire, avize arhitect-șef, certificate de atestare a edificării, recepții, ș.a.",
            },
            {
                key: "administration",
                title: "Administrație",
                description: "Juridic, acte ale autorității deliberative, ș.a.",
            },
            {
                key: "city_hall",
                title: "Primării",
                description: "Corespondeța inter-instuțională între primării și consiliul județean",
            },
            {
                key: "approvals",
                title: "Avizatori",
                description: "Cereri pentru diversele instituții și entități care emit avize și acorduri (ISU, gaze naturale, apa, ș.a.)",
            },
            {
                key: "roads",
                title: "Transport",
                description: "Avize drumuri județene, investiții drumuri județene, transport public județean, signalistică",
            },
            {
                key: "economic",
                title: "Economic",
                description: "Finanțări аcordate de Consiliul Județean Cluj, plăți, resurse umane, guvernanță corporativă, ș.a.",
            },
            {
                key: "subordination",
                title: "Subordonate",
                description: "Biblioteci, instituții de cultură, spitale, societăți aparținând de Consiliul Județean Cluj",
            },
            {
                key: "maps",
                title: "Hărți",
                description: "Aplicații GIS, hărți diverse, Atlasul Teritorial, ș.a.",
            },
            {
                key: "investments",
                title: "Investiții",
                description: "Contracte în derulare, achiziții publice, fonduri europene, proiecte, ș.a.",
            },
            {
                key: "tourism",
                title: "Turism",
                description: "Vizitarea Castelului Bánffy, trasee turistice, Centrul Național de Informare Turistică, Salvamont",
            },
            {
                key: "events",
                title: "Închirieri",
                description: "Cereri închiriere spații, organizare evenimente (Cluj Arena, Agro Transilvania, ș.a.)",
            },
            {
                key: "sesizari",
                title: "Sesizări",
                description: "Drumuri județene, informații de interes public, câini fără stăpân, nereguli",
            },
        ],
        DOMAIN_APPLICATION_TYPES_COUNT: "cereri | cerere | cereri",
    },
    URBANISM_REGULATION_ZONES: {
        LIST: {
            TITLE: "Reglementări urbanistice",
        },
        ADD_BUTTON: "Reglementare nouă",
        FIELDS: {
            NAME: "Denumire",
            KEY: "Cheie",
            TYPE: "Scop RU",
            TENANT: "UAT",
            DISPLAY_NAME: "Denumire atlas",
        },
        FORM: {
            EDIT_TITLE: "Editează reglementare",
            ADD_TITLE: "Reglementare nouă",
        },
        ENUMS: {
            TYPE: {
                PUG: "PUG",
                PUZ: "PUZ",
                PUD: "PUD",
            },
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
            KEY: "Caută după cheie",
            TENANT: "UAT",
            TYPE: "Scop RU",
        },
    },
    URBANISM_REGULATIONS: {
        TITLE: "Editare categorii RLU pentru {0}",
        FIELDS: {
            CONTENT: "Conţinut",
            CONTENT_HTML: "Conținut public - Acesta este conținutul disponibil în Atlas cetățeanului",
        },
        ITEM_DETAILS: "Detalii",
        EMPTY_ITEMS_LABEL: "Nu există categorii atașate",
        EDIT_ITEM_FORM: "Editare {0} {1}",
    },
    URBANISM_REGULATIONS_PICKER: {
        SECTION_TITLE: "Precompletare manuală a reglementărilor urbanistice",
        TITLE: "Precompletare manuală",
        COMPLETE_BUTTON: "Selectează reglementările",
        NO_DATA_FOUND: "Nu există reglementări urbanistice de afișat",
        PREVIEW_HEADER: "Previzualizare",
        SELECT_HEADER: "Selectează zonă",
        SELECT_PLACEHOLDER: "Caută după denumire",
        ENTRY_NOT_DEFINED: "Nu este definit",
        PREVIEW_HELP_TEXT: "Selectează o zonă din lista alăturată pentru a previzualiza conținutul",
        COULD_NOT_SUBMIT_MESSAGE: "A apărut o eroare, verificați dacă reglementările urbanistice sunt configurate corect.",
        FORCE_UPDATE_LABEL: "Suprascrie datele",
        HELP_TEXT_COMPLETED: "Documentul a fost pre-completat pe baza configurărilor din Atlasul Teritorial ",
        HELP_TEXT_NOT_COMPLETED: "Documentul nu a putut fi pre-completat automat deoarece nu s-au găsit informaţii în Atlasul Teritorial",
        HELP_TEXT_FORCE_UPDATE: "Toate câmpurile vor fi suprascrise cu valori noi",
        HELP_TEXT_NOT_FORCE_UPDATE: "Doar câmpurile goale vor fi completate cu valori noi",
    },
    INTERNAL_DOCUMENTS: {
        LIST: {
            TITLE: "Registru documente",
            SUB_TITLE: "Listă documente",
            NO_ASSIGNEE: "Nealocată",
            DOCUMENTS_HEADER: "Documente",
            SIGN_TITLE: "Registru documente de semnat",
            SIGN_DOCUMENT_BULK: "Semnează documente",
            SIGN_DOCUMENT_BULK_PERSONALIZED: "Semnează personalizat documente",
            SIGN_DOCUMENT_BULK_STS: "Semnează documente cu STS",
        },
        ADD_BUTTON: "Creează document",
        VIEW_APPLICATION_BUTTON: "Vizualizare cerere {number}",
        INTERNAL_DOCUMENTS_REVIEW_WARNING: "Acest document este intern, nu ajunge la cetățean!",
        FIELDS: {
            APPLICATION_TYPE_NAME_COLUMN: "Tip document",
            IDENTIFICATION_NUMBER: "Cod intrare",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Număr cerere",
            CREATED_DATE: "Dată creare",
            APPLICATION_DATE: "Dată finalizare",
            RESPONSE_DUE_IN: "Timp rămas",
            FILE_TYPE: "Tip document",
            ASSIGNED_TO: "Responsabil",
            ALLOCATED_DOCUMENT_SERIES: "Cod ieșire",
            STATUS: "Status",
            CADASTRAL_NUMBER: "Nr. CF",
            APPLICATION_TYPE_NAME: "Tip document intern",
            REVIEW_COMMENT: "Mențiuni",
            APPLICATION_NUMBER: "Număr cerere",
            PIN: "Cod confirmare",
            CREATED_BY: "Creat de",
            FILENAME: "Nume document",
        },
        PLACEHOLDERS: {
            BENEFICIARY: "Beneficiar",
            IDENTIFICATION_NUMBER: "Cod intrare",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Număr cerere",
            APPLICATION_TYPE_NAME: "Tip cerere",
            CREATED_BY: "Creat de",
            ASSIGNED_TO: "Responsabil",
            STATUS: "Status",
            CADASTRAL_NUMBER: "Nr. cadastral",
            ALLOCATED_DOCUMENT_SERIES: "Cod ieșire",
        },
        FORM: {
            NEW_DOCUMENT: "Document intern nou",
            EDIT_TITLE: "Document {0}",
            DOCUMENT_TYPE_HEADER: "",
            CONTINUE_BTN: "Continuă",
            SAVE_BTN: "Salvează",
            SAVE_AS_DRAFT_BUTTON: "Salvează ca draft",
            PREVIEW_DOC: "Previzualizare",
            FIND_APPLICATION_TITLE: "Caută cerere",
            SEARCH_FOR: "cereri",
            ADD_DOCUMENT: "Adaugă document",
            UPLOAD_DOCUMENT_TITLE: "Adaugă document",
            SIGN_DOCUMENT_TITLE: "Semnează document",
            REFRESH_DOCUMENT: "Reîncarcă",
            SIGNATURES_PANE_EXPAND: "Afișează panoul de semnături",
            SIGNATURES_PANE_COLLAPSE: "Ascunde panoul de semnături",
        },
        TABS: {
            APPLICATION_DETAILS: "Detalii cerere",
            DOCUMENT_DETAILS: "Detalii document",
            DOCUMENTS: "Documente",
            ACTIVITIES: "Activități",
        },
        VIEW: {
            SAVE_AS_DRAFT_BUTTON: "Salvează ca draft",
            REASSIGN_STAFF: "Realocă responsabil",
            ASSIGN_STAFF: "Alocă responsabil",
            SEND_RESPONSE: "Trimite răspuns",
            NEXT_STEP: "Pasul următor",
            SIGN_DOCUMENT: "Semnează document",
            SIGN_DOCUMENT_PERSONALIZED: "Semnează personalizat document",
            SIGN_DOCUMENT_STS: "Semnează document cu STS",
            ASSIGN_STAFF_MESSAGE: "Ești sigur că vrei să preiei acest document?",
            APPROVE_DOCUMENT: "Aprobă",
            REJECT_DOCUMENT: "Respinge",
            APPROVE_DOCUMENT_MESSAGE: "Ești sigur că vrei să aprobi acest document?",
            REJECT_DOCUMENT_MESSAGE: "Ești sigur că vrei să respingi acest document?",
            GENERATE_DOCUMENT_MESSAGE: "Documentul a fost generat",
            GENERATE_DOCUMENT_ERROR: "Documentul nu poate fi generat",
            SIGN_DOCUMENT_ERROR: "Documentul nu poate fi semnat",
            SIGN_SUCCESS: "Documentul a fost semnat",
            SEND_REVIEW: "Necesită clarificări",
            RETURN_DOCUMENT: "Regenerare document",
            RETURN_DOCUMENT_MESSAGE: "Sunteți sigur că vreți să returnați acest document? Această acțiune este ireversibilă și presupune regenerarea actului.",
            SAVE_FAILED: "Salvarea nu a reușit",
            GENERATE_DOCUMENT_BTN: "Finalizează document",
            SEND_TO_REVIEW: "Trimite spre consultare",
            ASSIGN_REVIEWER: "Alege consultant",
            REASSIGN_REVIEWER: "Realege consultant",
            SEND_TO_REVIEW_DOCUMENT_MESSAGE: "Ești sigur că vrei să trimiți spre consultare acest document?",
        },
        ENUMS: {
            STATUS: {
                NEW: "Nouă",
                PENDING: "În verificare",
                RESOLVED: "Soluționat",
                REJECTED: "Respinsă",
                REJECTED_IN_PROGRESS: "În respingere",
                APPROVED: "În lucru",
                DRAFT: "Draft",
                GENERATED: "Generat",
                SIGNED: "Semnat",
                SEALED: "Sigilat",
                SIGN_PENDING: "În semnare",
                CLOSED: "Finalizată",
                REVIEW: "În clarificări",
                ERROR: "Eroare",
                REGISTERED: "Înregistrată",
            },
        },
        SIGN_CONFIRMATION: {
            INVALID_PIN: "Codul nu este valid, vă rugăm reîncercați",
            PIN_EXPIRED: "Codul a expirat, vă rugăm reîncercați",
            SESSION_EXPIRED: "Sesiunea a expirat, vă rugăm reîncercați",
            ERROR: "A apărut o eroare, vă rugăm reîncercați",
            BULK_FAILED: "Următoarele cereri nu pot fi semnate {0}",
        },
        SIGN_STATUS: {
            TITLE: "Status semnare",
            IDENTIFICATION_NUMBER: "Cod de intrare",
            PARENT_IDENTIFICATION_NUMBER: "Număr cerere",
            SIGNING_BY: "În curs de semnare la",
            LAST_SIGNING_DATE: "Data ultimei semnări",
        },
        NOTIFIERS: {
            ASSIGN_SUCCESS: "Documentul a fost asignat la <strong>{name}</strong> cu succes!",
            INVALID_PROFILE_FOR_SIGNING_TITLE: "Datele din profil nu sunt valide",
            INVALID_PROFILE_FOR_SIGNING_TEXT: "Te rugăm să verifici CNP-ul și datele cărții de identitate din secțiunea <b>Profilul meu</b> necesare pentru semnarea online!",
            INVALID_PROFILE_FOR_SIGNING_BUTTON_TEXT: "Mergi la Profilul meu",
            INVALID_STAFF_ENROLLMENT_TITLE: "A apărut o eroare la procesul de semnare",
            INVALID_STAFF_ENROLLMENT_TEXT: "Te rugăm să te înrolezi pentru a putea semna",
            INVALID_STAFF_ENROLLMENT_BUTTON_TEXT: "Mergi la Profilul meu",
            REVIEW_RESPONSE_SUCCESS: "Răspunsul consultării a fost trimis cu success!'",
            REJECT_VIZA_RESPONSE_SUCCESS: "Respingerea a fost trimisă cu success!'",
        },
        RESPONSE_MODAL: {
            REJECT_APPLICATION_TITLE: "Motiv respingere",
        },
    },
    DOCUMENT_SERIES_ALLOCATION: {
        LIST: {
            TITLE: "Registru rezervări",
        },
        ADD_BUTTON: "Rezervă serie",
        DETAILS_BUTTON: "Detalii serii documente",
        EXPORT_ALLOCATIONS_BUTTON: "Exportă",
        FIELDS: {
            CREATED_BY: "Rezervat de",
            CREATED_DATE: "Data rezervării",
            ALLOCATED_SERIES: "Serie",
            TYPE_NAME: "Tip serie",
            FILE: "Document (PDF)",
            ISSUED_DATE: "Data emitere",
            LOCATION: "Locație",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            IDENTIFICATION_NUMBER: "Număr identificare",
            TAX_VALUE: "Taxă (în lei)",
            AVAILABILITY_PERIOD_MONTHS: "Valabilitate (luni)",
            EXECUTION_DURATION: "⁠Durata de execuție",
            EXECUTION_START_DATE: "⁠Data începere lucrari",
            EXTENSION_DATE: "Data prelungire",
            INVESTITION_VALUE: "Valoarea investiției",
            USE_REAL_ESTATE: "Amplasament vs. pin locatie",
        },
        FORM: {
            ADD_TITLE: "Rezervă serie",
            EDIT_TITLE: "Editează serie",
            VIEW_TITLE: "Vizualizare serie rezervată",
            ADD_LOCATION: "Adaugă locație",
            TITLE_TOOLTIP: "Pentru desenarea unei contur, a se folosi opțiunea de măsurare arie din meniul de pe hartă. Pentru a selecta o locatie de pe hartă, faceți dublu click.",
            LOCATION_TYPES: {
                LABEL: "Tip amplasament",
                PINPOINT: "Locație",
                REAL_ESTATE_LIST: "Carte funciara",
            },
            DEFAULT_FILE_NAME: "Document",
        },
        PLACEHOLDERS: {
            CREATED_BY: "Rezervat de",
            CREATED_DATE: "Data rezervării",
            ALLOCATED_SERIES: "Caută dupa serie",
            TYPE_NAME: "Tip serie",
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Rezervat cu succes",
            CREATED_SUCCESS_TEXT: "Seria cu numarul <strong>{number}</strong> a fost rezervată cu succes.",
        },
    },
    APPLICATION_ATTACHMENTS: {
        TITLE: "ANEXE",
    },
    RELATED_APPLICATION: {
        TITLE: "Documente de legătură",
        NOT_FOUND: "Documentul nu a fost găsit în sistem.",
        NOT_FOUND_AND_UPLOAD: "Documentul nu a fost găsit în sistem. Va rugăm să încărcați documentul.",
        SEARCH_DESCRIPTION: "Selectați documentul emis prin Ghișeul Unic sau introduceți numărul",
        ISSUED_BY_SYSTEM_DESCRIPTION: "Emis de {tenant} prin Ghișeul Unic",
        ISSUED_BY_DESCRIPTION: "Emis de altă autoritate/sistem",
        FIELDS: {
            ALLOCATED_DOCUMENT_SERIES: "Nr. Document",
            ISSUED_DATE: "Anul emiterii",
            ISSUED_BY: "Emis de",
            RELATED_DOCUMENT: "Certificat urbanism",
        },
    },
    DOCUMENT_EXPIRY: {
        INLINE: {
            PREFIX: "Prezentul act are valabilitatea de",
            SUFFIX: "de la data emiterii.",
        },
        FIELDS: {
            PERIOD_VALUE: "Valabilitate",
            PERIOD_UNIT: "Unitate",
        },
        ENUMS: {
            PERIOD_UNIT: {
                ZILE: "Zile",
                LUNI: "Luni",
                ANI: "Ani",
            },
        },
    },
    DOCUMENT_EXTENSION: {
        FIELDS: {
            ISSUE_DATE: "Valabil de la",
            EXTENSION_MONTHS: "Perioada prelungire(luni)",
            EXTENDED_UNTIL: "Valabil până la",
        },
    },
    OFFENDER: {
        DETAILS: {
            HEADER: "Detalii contravenient",
            ADD_BTN: "Adaugă contravenient",
            REMOVE_BTN: "Șterge contravenient",
            PERSON: {
                HEADER: "Tip persoană",
                INDIVIDUAL: "Persoană fizică",
                LEGAL: "Persoană juridică",
            },
            CITIZENSHIP: {
                HEADER: "Cetățenie",
                ROMANIAN: "Cetățean romȃn",
                FOREIGNER: "Cetățean străin",
            },
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Filiala",
            },
            ADDRESS: "Adresă",
            CONTACT: "Contact",
        },
        SINGLE: "Total {total} contravenient",
        MULTIPLE: "Total {total} contravenienți",
        LIST_HEADER: "Lista contravenienților",
        MODAL: {
            ADD_HEADER: "Adaugă un contravenient",
            EDIT_HEADER: "Editează un contravenient",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Adresă domiciliu",
            CONTACT: "Contact",
            CITIZENSHIP: "Cetățenie",
            ADDRESS_COUNTY: "Județul",
            ADDRESS_STREET: "Str.",
            ADDRESS_NUMBER: "nr.",
            ADDRESS_STAIRCASE: "scara",
            ADDRESS_APARTMENT: "ap.",
            PASSPORT_NUMBER: "Pașaport",
        },
    },
    WITNESS: {
        DETAILS: {
            HEADER: "Detalii martor",
            ADD_BTN: "Adaugă martor",
            REMOVE_BTN: "Șterge martor",
            CITIZENSHIP: {
                HEADER: "Cetățenie",
                ROMANIAN: "Cetățean romȃn",
                FOREIGNER: "Cetățean străin",
            },
            PERSON: {
                HEADER: "Tip persoană",
                INDIVIDUAL: "Persoană fizică",
                LEGAL: "Persoană juridică",
            },
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Filiala",
            },
            ADDRESS: "Adresă",
            CONTACT: "Contact",
            SAVE_AS_PREDEFINED: "Salvează ca martor predefinit",
        },
        SINGLE: "Total {total} martor",
        MULTIPLE: "Total {total} martor",
        LIST_HEADER: "Lista martorilor",
        MODAL: {
            ADD_HEADER: "Adaugă un martor",
            EDIT_HEADER: "Editează un martor",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Adresă domiciliu",
            CONTACT: "Contact",
            CITIZENSHIP: "Cetătenie",
            ADDRESS_COUNTY: "Judetul",
            ADDRESS_STREET: "Str.",
            ADDRESS_NUMBER: "nr.",
            ADDRESS_STAIRCASE: "scara",
            ADDRESS_APARTMENT: "ap.",
            PASSPORT_NUMBER: "Pașaport",
        },
    },
    REALTY: {
        FORM: {
            HEADER: "Adaugă construcție",
            ADD_BTN: "Adaugă construcție nouă",
            DUPLICATE_CADASTRAL_NUMBER: "Acest număr cadastral este deja adăugat",
            DUPLICATE_CADASTRAL_NUMBER_PLURAL: "Unele numere cadastrale selectate sunt deja adăugate",
            DIFFERENT_AREA: "Aria introdusă este diferită de cea de la ANCPI",
            WRONG_COUNTY: "Se pot depune cereri doar pe județul {county}",
        },
        VIEW: {
            ADDRESS: "Adresă",
            CONTACT: "Contact",
            CADASTRAL_PLAN: "Plan cadastral",
            NO_FILES: "Nu există fișiere",
            FILES_LABEL: "Fișiere de identificare",
        },
        SINGLE: "Total {total} construcție",
        MULTIPLE: "Total {total} construcții",
        LIST_HEADER: "Lista construcțiilor",
        MODAL: {
            ADD_HEADER: "Adaugă o construcție",
            SUMMARY_HEADER: "Lista completă a construcțiilor",
        },
        CARD: {
            CADASTRAL_NUMBER: "Nr. cadastral",
            UAT: "UAT",
            LAND_AREA: "Suprafață",
            COUNTY: "Județul {county}",
            CATEGORY: "Cod categorie",
            MISSING_COORDINATES_MESSAGE: "Lipsă coordonate ANCPI",
            ADDRESS: "Strada {street}, număr {no}",
        },
    },
    STAFF: {
        SECTION_TITLE: "Detalii funcționar",
        FIELDS: {
            FUNCTION: "Funcția",
            ORGANISATION: "Organ control",
            FIRST_NAME: "Prenume",
            LAST_NAME: "Nume",
            IDENTIFICATION_NUMBER: "Număr legitimatie control",
            ID_EXPIRATION_DATE: "Data expirării",
            ID_RELEASED_BY: "Eliberat de",
            ADDRESS: "Adresă sediu / șantier control",
        },
    },
    CONTROL_TYPE: {
        HEADER: "Alege tipul de control",
        LIST: {
            TITLE: "Tipologii de controale",
        },
        ADD_BUTTON: "Control nou",
        FIELDS: {
            NAME: "Denumire",
            STATUS: "Status",
            DESCRIPTION: "Descriere",
            FORM: "Interfață formular",
            DOCUMENT_TEMPLATE: "Formular tipizat",
            DOCUMENT_SERIES_TYPE: "Tip serie document",
            OUTPUT_DOCUMENT_SERIES_TYPE: "Tip serie documente PVCC",
            TENANT_ID: "Organizație",
        },
        FORM: {
            EDIT_TITLE: "Editează tip control",
            ADD_TITLE: "Tip control nou",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Activ",
                INACTIVE: "Inactiv",
            },
        },
        PLACEHOLDERS: {
            NAME: "Caută după denumire",
            STATUS: "Status",
        },
    },
    AC_TAX_VALIDATOR: {
        FORM: {
            HEADER: "Adaugă construcție",
            MIN_VALUE: "(minim {value})",
        },
        FIELDS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            VILLAGE: "Localitate",
            STREET: "Strada",
            STREET_NUMBER_SHORT: "Nr.",
            CONSTRUCTION_SCOPE: "In vederea executarii lucrarilor de",
            CONSTRUCTION_TYPE: "Sistem constructiv",
            SURFACE: "Suprafata desfasurata totala a constructiilor",
            CONSTRUCTION_VALUE: "in valoare de (lei) locuinte",
            CONSTRUCTION_PURPOSE: "pentru (obiectiv)",
            COUNTY: "Judet",
        },
        PLACEHOLDERS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            VILLAGE: "Localitate",
            STREET: "Strada",
            STREET_NUMBER_SHORT: "Nr.",
            CONSTRUCTION_SCOPE: "Tip constructie",
            CONSTRUCTION_TYPE: "Sistem constructiv",
            SURFACE: "Suprafata",
            CONSTRUCTION_VALUE: "Valoare",
            CONSTRUCTION_PURPOSE: "",
            COUNTY: "",
        },
        ENUMS: {
            CONSTRUCTION_SCOPE: {
                LOCUINTE: "Locuințe si anexele acestora (0.5%)",
                OTHER: "Alte tipuri de lucrări (1%)",
            },
            CONSTRUCTION_TYPE: {
                BETON: "Cladire cu cadre din beton armat sau cu pereti exteriori din caramida arsa sau din orice alte materiale rezultate in urma unui tratament termic si/sau chimic",
                LEMN: "Cladire cu pereti exteriori din lemn, din piatra naturala, din caramida nearsa, din valatuci sau orice alte materiale nesupuse unui tratament termic si/sau chimic",
                ANEXE: "Cladire-anexa indiferent de sistemul constructiv",
            },
        },
        ERRORS: {
            CONSTRUCTION_VALUE_TOO_SMALL: "Valoarea introdusă este mai mică decat valoarea minimă!",
            SURFACE_WRONG_FORMAT: "Valoarea introdusă nu e validă",
        },
    },
    LOCALITIES: {
        LIST_HEADER: "Detalii amplasamente",
        FORM: {
            HEADER: "Adaugă un amplasament nou",
            ADD_BTN: "Adaugă amplasament nou",
            WRONG_COUNTY: "Se pot depune cereri doar pe județul {county}",
        },
        VIEW: {
            ADDRESS: "Adresă",
            CONTACT: "Contact",
        },
        SINGLE: "Total {total} amplasamente",
        MULTIPLE: "Total {total} amplasamente",
        MODAL: {
            ADD_HEADER: "Adaugă un amplasament",
            SUMMARY_HEADER: "Lista completă a amplasamentelor",
        },
        CARD: {
            UAT: "Municipiu / Oraș / Comună",
            COUNTY: "Județul {county}",
            VILLAGE: "Localitate",
            ADDRESS: "Adresă domiciliu",
            ADDRESS_COUNTY: "Judetul",
            ADDRESS_STREET: "Str.",
            ADDRESS_NUMBER: "nr.",
            ADDRESS_STAIRCASE: "scara",
            ADDRESS_APARTMENT: "ap.",
        },
        FIELDS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "Municipiu / Oraș / Comună",
            VILLAGE: "Localitate",
            STREET: "Strada",
            STREET_NUMBER_SHORT: "Nr.",
            COUNTY: "Județ",
            STAIRCASE: "Scara",
            BLOCK: "Bloc",
            FLOOR: "Etaj",
            APARTMENT: "Apartament",
        },
        PLACEHOLDERS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "Municipiu / Oraș / Comună",
            VILLAGE: "Localitate",
            STREET: "Strada",
            STREET_NUMBER_SHORT: "Nr.",
            COUNTY: "",
        },
    },
    BUILDINGS: {
        LIST_HEADER: "Corpuri de clădire",
        FORM: {
            HEADER: "Adaugă corpuri",
            ADD_BTN: "Adaugă corp nou",
            WRONG_COUNTY: "Se pot depune cereri doar pe județul {county}",
        },
        VIEW: {
            ADDRESS: "Adresă",
            CONTACT: "Contact",
        },
        SINGLE: "Total {total} corp",
        MULTIPLE: "Total {total} corpuri",
        MODAL: {
            ADD_HEADER: "Adaugă un corp nou",
            SUMMARY_HEADER: "Lista completă a corpurilor",
        },
        CARD: {
            NAME: "Nume corp",
            HEIGHT: "Înălțimea construcțiilor propuse",
            HEIGHT_SHORT: "Înălțime",
            NR_LEVELS: "Numărul de niveluri",
            CHARACTERISTICS: "Caracteristici constructive și aspect exterior",
            CHARACTERISTICS_SHORT: "Caracteristici",
            CAPACITY: "Capacități funcționale ale construcțiilor proiectate",
            CAPACITY_SHORT: "Capacități",
        },
        FIELDS: {
            NAME: "Denumire corp c-ție (ex: C1 -locuință)",
            HEIGHT: "Înălțimea la cornișă/streașină (m)",
            MAX_HEIGHT: "Înalțimea la coamă/atic (m)",
            EXISTING_LEVELS: "Număr de niveluri existente",
            PROPOSED_LEVELS: "Număr de niveluri propuse",
            CONSTRUCTION_TYPE: "Sistem constructiv (descriere)",
            FOUNDATIONS: "Fundații (tip + descriere)",
            ROOF_TYPE: "Acoperiș (tip + descriere)",
            HEATING_TYPE: "Sistem de încălzire",
            ISOLATION: "Învelitoare",
            EXTERIOR_FINISH: "Finisaje exterioare",
            EXTERIOR_WOODWORK: "Tâmplărie exterioară",
            FUNCTION: "Funcțiune",
            CATEGORY_OF_IMPORTANCE: "Categoria de importanță",
            BUILDING_FUNCTION: "Tip corp c-ție",
            BUILDING_FUNC_EXISTING: "Existent",
            BUILT_AREA: "Suprafață construită (mp)",
            DEVELOPED_AREA: "Suprafață desfășurată (mp)",
            USEFUL_AREA: "Suprafață utilă (mp)",
            LIVING_AREA: "Suprafață locuibilă (mp)",
            PROPOSED_APARTMENTS_NO: "Număr unități locative propuse",
            ONE_ROOM_APARTMENT_NO: "1 cam.",
            TWO_ROOMS_APARTMENT_NO: "2 cam.",
            THREE_ROOMS_APARTMENT_NO: "3 cam.",
            FOUR_ROOMS_APARTMENT_NO: "4 cam.",
            FIVE_ROOMS_APARTMENT_NO: "5 cam.",
            OTHER_ROOMS_APARTMENT_NO: "Altele",
            OTHER_CHARACTERISTICS: "Alte caracteristici ale capacităţilor funcţionale pentru construcţii propuse, necuprinse în categoriile de mai sus",
            CL_HOUSING_TYPES: "Tipuri",
        },
        PLACEHOLDERS: {
            EXTERIOR_FINISH: "tip: tencuiala decorativa \nculoare: RAL ... \nmaterial:",
            EXTERIOR_WOODWORK: "tip: \nculoare: RAL ... \nmaterial: Lemn/PVC",
            ISOLATION: "tip: tigla ceramica \nculoare: RAL ... \nmaterial:",
            PROPOSED_APARTMENTS_NO: "Suma = A+B+C+D+E+F",
            ONE_ROOM_APARTMENT_NO: "A",
            TWO_ROOMS_APARTMENT_NO: "B",
            THREE_ROOMS_APARTMENT_NO: "C",
            FOUR_ROOMS_APARTMENT_NO: "D",
            FIVE_ROOMS_APARTMENT_NO: "E",
            OTHER_ROOMS_APARTMENT_NO: "F",
        },
        ENUMS: {
            BUILDING_FUNCTION: {
                EXISTING: "Existent",
                PROPOSED: "Propus",
            },
            BUILDING_FUNC_EXISTING: {
                DISSOLVED: "Desființat",
                MAINTAINED: "Menținut",
            },
            FUNCTION: {
                CL: "Locuințe CL",
                CAS: "Construcții Administrative și Social Culturale CAS",
                CIE: "Construcții Industriale și Edilitare CIE",
                CA: "Construcții Anexa CA",
            },
            CATEGORY_OF_IMPORTANCE: {
                A: "Constructii de importanță excepțională (A)",
                B: "Construcții de importanță deosebită (B)",
                C: "Construcții de importanță normală (C)",
                D: "Construcții de importanță redusă (D)",
            },
            CL_HOUSING_TYPES: {
                PERMANENT: "Permanente",
                SEASONAL: "Sezoniere",
                SOCIABLE: "Sociale",
                FOR_RENT: "de închiriat",
                OF_DUTY: "de serviciu ",
                OF_NECESSITY: "de necesitate ",
                OF_INTERVENTION: "de intervenție ",
                OF_PROTOCOL: "de protocol",
            },
        },
        NO_BUILDINGS: "Nici o clădire adăugată",
    },
    URBANISM_REGULATIONS_EDIT: {
        SYNC_UTR: "Salvează UTR",
        SYNC_UTR_DESC: "Salvează UTR-ul printre reglementările organizației aferente cererii",
        CHECK_EXISTING_UTR: "Verifică simbol UTR",
        CHECK_EXISTING_UTR_DESC: "Verifică daca simbolul UTR exista deja printre reglementarile curente pe UAT-ul selectat",
        UTR_ALREADY_EXISTS: "Simbolul UTR '{0}' există deja in sistem.",
        UTR_KEY_IS_AVAILABLE: "Simbolul UTR '{0}' este disponibilă.",
        OVERWRITE_EXISTING_UTR_WARN: "Exista in sistem un regulament pentru cheia '{0}', regulamentul curent se va salva cu cheia '{1}'. Continuă?",
        LIST_HEADER: "Reglementari",
        FORM: {
            HEADER: "Adaugă UTR",
            ADD_BTN: "Adaugă un UTR nou",
            ADD_BTN_LABEL: "Sau",
        },
        SINGLE: "Total {total} UTR",
        MULTIPLE: "Total {total} UTR-uri",
        MODAL: {
            ADD_HEADER: "Adaugă un regulament",
            EDIT_HEADER: "Modifică regulament",
            VIEW_HEADER: "Vizualizează regulament",
            SUMMARY_HEADER: "Lista regulamentelor locale de urbanism",
            OPTIONS: {
                LABEL: "Alege un regulament existent sau adaugă un regulament nou",
                LOAD_EXISTING_UTR: "Alege dintre regulamentele existente",
                ADD_NEW_UTR: "Adaugă un UTR nou",
            },
        },
        CARD: {
            UAT: "Municipiu / Oraș / Comună",
            NAME: "Nume",
            SYMBOL: "Simbol",
        },
        SECTION_LABEL: "SECȚIUNEA {0}",
        ARTICLE_LABEL: "Articolul {0}",
        SECTION_1: "CARACTERUL ZONEI",
        SECTION_2: "UTILIZARE FUNCȚIONALĂ",
        SECTION_3: "CONDIȚII DE AMPLASARE, ECHIPARE ȘI CONFORMARE A CONSTRUCȚIILOR",
        SECTION_4: "POSIBILITĂȚI MAXIME DE UTILIZARE A TERENULUI",
        SECTION_EXISTING_UTR: "Detalii UTR",
        FIELDS: {
            COUNTY: "Județ",
            RU_SCOPE: "Scop Ru",
            RU_SCOPES: "Scopuri Ru",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            UTR_ID: "Reglementări",
            UTR: "Reglementare",
            NAME: "Denumire UTR",
            SYMBOL: "Simbol UTR(de ex. Lv)",
            IS_EXISTING_UTR: "Utr existent",
            ARTICLE_1: "Condiționări generale",
            ARTICLE_2: "Servituți",
            ARTICLE_3: "Utilizări permise",
            ARTICLE_4: "Utilizări permise cu condiționări",
            ARTICLE_5: "Utilizări interzise",
            ARTICLE_6: "Caracteristici ale parcelelor",
            ARTICLE_7: "Amplasarea clădirilor față de aliniament",
            ARTICLE_8: "Amplasarea clădirilor față de limitele laterale și posterioare ale parcelelor",
            ARTICLE_9: "Amplasarea clădirilor unele față de altele pe aceeași parcelă",
            ARTICLE_10: "Condiții de acces și circulații",
            ARTICLE_11: "Staționarea autovehiculelor",
            ARTICLE_12: "Înălțimea maximă a clădirilor",
            ARTICLE_13: "Aspectul exterior al clădirilor",
            ARTICLE_14: "Condiții de echipare edilitară",
            ARTICLE_15: "Spații verzi",
            ARTICLE_16: "Împrejmuiri",
            ARTICLE_17: "Procentul maxim de ocupare al terenului (POT)",
            ARTICLE_18: "Coeficientul maxim de utilizare a terenului (CUT)",
            RLU_RT: "Regim Tehnic",
            RLU_RJ: "Regim Juridic",
            RLU_RE: "Regim Economic",
            RLU_POT: "POT",
            RLU_CUT: "CUT ",
            RLU_RDA: "Regim de actualizare",
        },
        PLACEHOLDERS: {},
        ENUMS: {},
    },
    APPLICATION_REGISTER: {
        TITLE: "Înregistrează un document",
        EMAIL: "Email",
        PHONE: "Telefon",
        EXTERNAL_DOCUMENT_NUMBER: "Număr document extern",
        EXTERNAL_DOCUMENT_DATE: "Dată document extern",
        CONNECTED_APPLICATIONS: "Documente conexe",
        DETAILS: "Detalii",
        DOCUMENTS: "Documente",
        FILE_UPLOAD_INFO_MESSAGE: "Încarcă un fișier prin drag and drop sau prin click",
        MAX_FILE_SIZE: "Maxim 50MB",
        FILE_SIZE_ERROR: "Unul din fișiere depăseste limita de 50 MB",
        FILE_EXTENSION_ERROR: "Acest tip de fișier nu este acceptat.",
        FILE_MISSING_ERROR: "Fișierul este obligatoriu",
        REGISTER_DOCUMENT: "Înregistrează document",
        REGISTER_APPLICATION: "Înregistrează cerere",
        GENERATE_DOCUMENT: "Generează document",
        REGISTER_DOCUMENT_INFO_OF: "Înregistrează un document nou de tipul:",
        REGISTER_DOCUMENT_INFO_AS: "(câmpurile marcate cu * sunt obligatorii)",
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Documentul a fost înregistrat cu succes!",
            CREATED_SUCCESS_TEXT: "Numarul alocat este <strong>{number}</strong>",
            CONFIRM_BUTTON: "Imprimă număr de înregistrare",
            CANCEL_BUTTON: "Înregistrează un alt document",
            CREATE_ERROR_TITLE: "A apărut o eroare la înregistrarea documentului!",
            CREATE_ERROR_TEXT: "Vă rugăm să verificați datele întroduse și să reîncercați.",
            UNFINISHED_CONNECTED_DOCUMENTS_TEXT: "Există documente conexe în lucru. Ești sigur că vrei să finalizezi acest documentul?",
        },
        BENEFICIARY_REGISTER_TEXT: "Inregistrează pe bază de mail sau telefon",
        BENEFICIARY_INVITE_TEXT: "Invită beneficiar in Ghiseul Unic",
        BENEFICIARY_INVITED_SUCCESS: "Invitația a fost trimisă cu succes",
        BENEFICIARY_INVITED_ERROR: "Invitația nu a putut fi trimisă",
        BENEFICIARY_INVITE_EMAIL_ERROR: "Invitația nu a putut fi trimisă. Verificați dacă adresa de email este validă",
        PRINT_RECEIPT: {
            REGISTERED_TEXT: "Documentul dumneavoastră a fost înregistrat cu succes în Ghișeul Unic!",
            DOCUMENT_NUMBER: "Număr document",
            REGISTRATION_DATE: "Dată înregistrare",
            SCAN_FOR_STATUS: "Scanează pentru status document",
        },
    },
    APPLICATION_CIRCULAR_MAIL: {
        TITLE: "Trimite circulară",
        SEARCH_FOR_DEPARTMENTS: "Departament",
        SEARCH_FOR_USERS: "Funcționar",
        RECIPIENT: "Destinatar",
        ADDITIONAL_RECIPIENT: "Destinatar suplimentar",
        SUBJECT: "Subiect",
        MESSAGE: "Mesaj",
        SEND: "Trimite",
        CANCEL: "Anulează",
        DEPARTMENT: "Departamente",
        USERS: "Funcționari",
        ORGANIZATION: "Organizație",
        SEARCH_PLACEHOLDER_DEPARTMENTS: "Caută după numele departamentului",
        SEARCH_PLACEHOLDER_USERS: "Caută după numele funcționarului",
        SEARCH_PLACEHOLDER_ORGANIZATIONS: "Caută după numele organizației",
        ATTACHMENTS: "Atașamente",
        MAX_FILE_SIZE: "Maxim 50MB",
        FILE_UPLOAD_INFO_MESSAGE: "Încarcă un fișier prin drag and drop sau prin click (pdf, png, jpg, jpeg)",
        FILE_UPLOAD_ERROR: "Unul din fișiere depășește limita de 50 MB",
        FILE_MISSING_ERROR: "Fișierul este obligatoriu",
        SEND_TO_ALL_ORGANIZATIONS: "Trimite la toată organizația",
        ADDITIONAL_RECIPIENT_PLACEHOLDER: "Introdu adresele de email separate prin virgulă",
        SUCCESS_TITLE: "Trimis cu succes",
        SUCCESS_TEXT: "Circulara a fost trimisă cu succes!",
        ERROR_TITLE: "Vă rugăm verificați datele întroduse și reîncercați.",
        ERROR_TEXT: "Cel puțin un destinatar este obligatoriu.",
    },
    PUBLIC_APPLICATION: {
        STATUS: "Status document",
        APPLICATION_NAME: "Tip document înregistrat",
        IDENTIFICATION_NUMBER: "Număr înregistrare",
        DATE: "Dată înregistrare",
        FUNCTION: "Funcția",
        DEPARTMENT: "Departament",
        ALLOCATED_DOCUMENT_SERIES: "Număr finalizare",
        ISSUED_DATE: "Dată finalizare",
        NOT_FOUND: "Cererea nu a fost găsită",
        TECHNICAL_ERROR: "Eroare tehnica",
        INFO: "După finalizarea cererii, puteți vizualiza și descărca documentele aferente cererii.",
        PHONE_LABEL: "Număr de telefon beneficiar/solicitant",
        PHONE_PLACEHOLDER: "Introdu numărul de telefon",
        SEND_SMS: "Trimite SMS",
        PHONE_ERROR_MANDATORY: "Numărul de telefon este obligatoriu",
        PHONE_ERROR: "Vă rugăm introduceți un număr de telefon valid",
        PHONE_ERROR_PHONE_BLOCKED: "Pentru că ai introdus codul greșit de 5 ori telefonul îți este blocat pentru 5 minute",
        PHONE_ERROR_PHONE_NUMBER_NOT_ALLOCATED: "Telefonul introdus trebuie să aparțină solicitantului sau a unuia dintre beneficiari",
        SMS_LABEL: "Validează cod SMS",
        SMS_PLACEHOLDER: "Introdu codul primit prin SMS",
        VALIDATE_CODE: "Validează cod",
        CODE_ERROR_MANDATORY: "Codul primit prin SMS este obligatoriu",
        CODE_ERROR: "Cod invalid",
        CODE_ERROR_PHONE_BLOCKED: "Pentru că ai introdus codul greșit de 5 ori telefonul îți este blocat pentru 5 minute",
        CODE_ERROR_INVALID_CODE: "Codul introdus este greșit",
        CODE_ERROR_CODE_EXPIRED: "Codul a expirat. Te rugăm să reiei procesul",
        CODE_ERROR_PHONE_NUMBER_NOT_ALLOCATED: "Telefonul introdus trebuie să aparțină solicitantului sau a unuia dintre beneficiari",
        CODE_SENT_TO: "S-a trimis cod pentru numarul ",
        IF_NUMBER_WRONG: ". Dacă numărul este greșit sau codul a expirat.",
        RETRY: "Reîncearcă",
        APPLICATIONS_DOCUMENTS: "Documentele aferente cererii",
        PUBLIC_DOCUMENTS: "Acte publice",
        DOWNLOAD_ALL: "Descarca toate documentele",
        TIME_REMAINING: "Mai aveti la dispozitie {time} pentru a vizualiza sau descarca documentele",
    },
    EFACTURA: {
        AUTHORIZE: "Autorizează",
        SYNC_NOW: "Sincronizează acum",
        PROCESS_AGAIN: "Procesează din nou",
        AUTH_SUCCESS: "Autorizare ANAF cu success",
        AUTH_FAILED: "Autorizare esuata",
        AUTH_NO_CIF: "Lipseste CIF setat pe organizatie.Completeaza un CIF si reincearca.",
        TOKEN_ACTIVE_EXPIRES: "Token activ, expiră {expires}",
        SYNC_STATUS: {
            NOT_SYNCED: "Nu s-au sincronizat datele",
            LAST_SYNC: "Ultima sincronizare: {date}",
        },
        EXPIRES: {
            UNKNOWN: "necunoscut",
            EXPIRED: "a expirat",
            IN: "în {duration}",
            AND: "și",
            SECONDS: "{n} secunde | {n} secundă | {n} secunde",
            MINUTES: "{n} minute | {n} minut | {n} minute",
            HOURS: "{n} ore | {n} oră | {n} ore",
            DAYS: "{n} zile | {n} zi | {n} zile",
            MONTHS: "{n} luni | {n} lună | {n} luni",
        },
    },
    INVOICES: {
        FIELDS: {
            DETAILS: "Detalii factură",
            CREATIONDATE: "Data emiterii",
            INVOICE_ID: "Cod factură",
            REQUEST_ID: "Cod solicitare",
            STATUS: "Status",
            NUMAR_FACTURA: "Nr. Factură",
            FURNIZOR: "Furnizor",
            VALOARE: "Valoare",
            IDENTIFICATION_NUMBER: "Nr. înreg.",
            APPLICATION_DATE: "Dată înreg.",
            REFERINTA_CONTRACT: "Nr. contract",
            CIF_EMITENT: "CIF emitent",
            ID_INCARCARE: "ID încărcare",
        },
        PLACEHOLDERS: {
            NUMAR_FACTURA: "Nr. Factură",
            STATUS: "Status",
            FURNIZOR: "Furnizor",
            IDENTIFICATION_NUMBER: "Nr. înreg.",
            APPLICATION_DATE: "Dată înreg.",
            REFERINTA_CONTRACT: "Nr. contract",
            CIF_EMITENT: "CIF emitent",
            ID_INCARCARE: "ID încărcare",
        },
        ENUMS: {
            STATUS: {
                NEW: "Nouă",
                PROCESSED: "Procesată",
                REPROCESSING: "Așteaptă reprocesare",
                PROCESSING: "În procesare",
                FAILED: "Cu eroare",
            },
        },
    },
    PCUEL: {
        INFO_MODAL_TEXT: "Contul dumneavoastră va fi sincronizat cu platforma PCUEL. Astfel veți putea regăsi actele emise în Ghișeul Unic automat în platforma PCUEL.",
        ALREADY_SYNCED_TEXT: "Contul dumneavoastră este deja sincronizat cu platforma PCUEL.",
        DIFFERENT_ACCOUNT_TEXT: "Profilul dumneavoastră este deja sincronizat cu un alt cont PCUEL. Pentru a schimba contul asociat, vă rugăm contactați suportul tehnic.",
        CONFLICT_TEXT: "Contul PCUEL indicat este deja asociat unui alt profil. Vă rugăm contactați suportul tehnic.",
        UNLINK_ERROR: "A apărut o eroare la desincronizarea contului cu PCUEL",
        UNLINK_SUCCESS: "Ștergerea sincronizării a fost cu succes",
        UNLINK_CONFIRMATION_MESSAGE: "Ești sigur că dorești sa dezactivezi sincronizarea cu PCUEL?",
    },
};

module.exports = { locale };
